(function() {
    function t(e, t) {
      return function() {
        return e.apply(t, arguments);
      };
    }
    var i, e, s, a, o, r;
    (e = (function() {
      function e() {
        this.update = t(this.update, this);
      }
      return (
        (e.prototype.update = function(o) {
          var r, e, t;
          for (e in o) (t = o[e]), "items" !== e && (this[e] = t);
          return (this.items = (function() {
            var e, t, i, n;
            for (n = [], e = 0, t = (i = o.items).length; e < t; e++)
              (r = i[e]), n.push(new a(r));
            return n;
          })());
        }),
        e
      );
    })()),
      (a = (function() {
        function e(e) {
          (this.propertyArray = t(this.propertyArray, this)),
            (this.update = t(this.update, this)),
            this.update(e);
        }
        return (
          (e.prototype.update = function(e) {
            var t, i;
            for (t in e) (i = e[t]), "properties" !== t && (this[t] = i);
            return (this.properties = s.Utils.extend({}, e.properties));
          }),
          (e.prototype.propertyArray = function() {
            var e, t, i, n;
            for (e in ((n = []), (i = this.properties)))
              (t = i[e]), n.push({ name: e, value: t });
            return n;
          }),
          e
        );
      })()),
      (s = {
        settings: {
          debug: !1,
          dataAPI: !0,
          requestBodyClass: null,
          rivetsModels: {},
          currency: null,
          moneyFormat: null,
          moneyWithCurrencyFormat: null,
          weightUnit: "g",
          weightPrecision: 0
        },
        cart: new e(),
        init: function(e, t) {
          return (
            null == t && (t = {}),
            s.configure(t),
            s.Utils.log("Initialising CartJS."),
            s.cart.update(e),
            s.settings.dataAPI &&
              (s.Utils.log('"dataAPI" setting is true, initialising Data API.'),
              s.Data.init()),
            s.settings.requestBodyClass &&
              (s.Utils.log('"requestBodyClass" set, adding event listeners.'),
              jQuery(document).on("cart.requestStarted", function() {
                return jQuery("body").addClass(s.settings.requestBodyClass);
              }),
              jQuery(document).on("cart.requestComplete", function() {
                return jQuery("body").removeClass(s.settings.requestBodyClass);
              })),
            s.Rivets.init(),
            jQuery(document).trigger("cart.ready", [s.cart])
          );
        },
        configure: function(e) {
          return null == e && (e = {}), s.Utils.extend(s.settings, e);
        }
      }),
      null == window.console &&
        ((window.console = {}), (window.console.log = function() {})),
      (s.Utils = {
        log: function() {
          return s.Utils.console(console.log, arguments);
        },
        error: function() {
          return s.Utils.console(console.error, arguments);
        },
        console: function(e, t) {
          if (
            s.settings.debug &&
            "undefined" != typeof console &&
            null !== console
          )
            return (
              (t = Array.prototype.slice.call(t)).unshift("[CartJS]:"),
              e.apply(console, t)
            );
        },
        wrapKeys: function(e, t, i) {
          var n, o, r;
          for (n in (null == t && (t = "properties"), (r = {}), e))
            (o = e[n]), (r[t + "[" + n + "]"] = null != i ? i : o);
          return r;
        },
        unwrapKeys: function(e, t, i) {
          var n, o, r;
          for (n in (null == t && (t = "properties"), (o = {}), e))
            (r = e[n]),
              (o[n.replace(t + "[", "").replace("]", "")] = null != i ? i : r);
          return o;
        },
        extend: function(e, t) {
          var i, n;
          for (i in t) (n = t[i]), (e[i] = n);
          return e;
        },
        clone: function(e) {
          var t, i;
          if (null == e || "object" != typeof e) return e;
          for (t in ((i = new e.constructor()), e)) i[t] = clone(e[t]);
          return i;
        },
        isArray:
          Array.isArray ||
          function(e) {
            return "[object Array]" === {}.toString.call(e);
          },
        ensureArray: function(e) {
          return s.Utils.isArray(e) ? e : null != e ? [e] : [];
        },
        formatMoney: function(e, t, i, n) {
          var o, r;
          return (
            null == n && (n = ""),
            n || (n = s.settings.currency),
            null != window.Currency &&
              n !== s.settings.currency &&
              ((e = Currency.convert(e, s.settings.currency, n)),
              null != (null != (o = window.Currency) ? o.moneyFormats : void 0) &&
                n in window.Currency.moneyFormats &&
                (t = window.Currency.moneyFormats[n][i])),
            null != (null != (r = window.Shopify) ? r.formatMoney : void 0)
              ? Shopify.formatMoney(e, t)
              : e
          );
        },
        getSizedImageUrl: function(e, t) {
          var i, n;
          return null !=
            (null != (i = window.Shopify) && null != (n = i.Image)
              ? n.getSizedImageUrl
              : void 0)
            ? e
              ? Shopify.Image.getSizedImageUrl(e, t)
              : Shopify.Image.getSizedImageUrl(
                  "https://cdn.shopify.com/s/images/admin/no-image-.gif",
                  t
                ).replace("-_", "-")
            : e || "https://cdn.shopify.com/s/images/admin/no-image-large.gif";
        }
      }),
      (o = !(r = [])),
      (s.Queue = {
        add: function(e, t, i) {
          var n;
          if (
            (null == i && (i = {}),
            (n = {
              url: e,
              data: t,
              type: i.type || "POST",
              dataType: i.dataType || "json",
              success: s.Utils.ensureArray(i.success),
              error: s.Utils.ensureArray(i.error),
              complete: s.Utils.ensureArray(i.complete)
            }),
            i.updateCart && n.success.push(s.cart.update),
            r.push(n),
            !o)
          )
            return (
              jQuery(document).trigger("cart.requestStarted", [s.cart]),
              s.Queue.process()
            );
        },
        process: function() {
          var e;
          return r.length
            ? ((o = !0),
              ((e = r.shift()).complete = s.Queue.process),
              jQuery.ajax(e))
            : ((o = !1),
              void jQuery(document).trigger("cart.requestComplete", [s.cart]));
        }
      }),
      (s.Core = {
        getCart: function(e) {
          return (
            null == e && (e = {}),
            (e.type = "GET"),
            (e.updateCart = !0),
            s.Queue.add("/cart.js", {}, e)
          );
        },
        addItem: function(e, t, i, n) {
          var o;
          return (
            null == t && (t = 1),
            null == i && (i = {}),
            null == n && (n = {}),
            ((o = s.Utils.wrapKeys(i)).id = e),
            (o.quantity = t),
            s.Queue.add("/cart/add.js", o, n),
            s.Core.getCart()
          );
        },
        updateItem: function(e, t, i, n) {
          var o;
          return (
            null == i && (i = {}),
            null == n && (n = {}),
            ((o = s.Utils.wrapKeys(i)).line = e),
            null != t && (o.quantity = t),
            (n.updateCart = !0),
            s.Queue.add("/cart/change.js", o, n)
          );
        },
        removeItem: function(e, t) {
          return null == t && (t = {}), s.Core.updateItem(e, 0, {}, t);
        },
        updateItemById: function(e, t, i, n) {
          var o;
          return (
            null == i && (i = {}),
            null == n && (n = {}),
            ((o = s.Utils.wrapKeys(i)).id = e),
            null != t && (o.quantity = t),
            (n.updateCart = !0),
            s.Queue.add("/cart/change.js", o, n)
          );
        },
        updateItemQuantitiesById: function(e, t) {
          return (
            null == e && (e = {}),
            null == t && (t = {}),
            (t.updateCart = !0),
            s.Queue.add("/cart/update.js", { updates: e }, t)
          );
        },
        removeItemById: function(e, t) {
          var i;
          return (
            null == t && (t = {}),
            (i = { id: e, quantity: 0 }),
            (t.updateCart = !0),
            s.Queue.add("/cart/change.js", i, t)
          );
        },
        clear: function(e) {
          return (
            null == e && (e = {}),
            (e.updateCart = !0),
            s.Queue.add("/cart/clear.js", {}, e)
          );
        },
        getAttribute: function(e, t) {
          return e in s.cart.attributes ? s.cart.attributes[e] : t;
        },
        setAttribute: function(e, t, i) {
          var n;
          return (
            null == i && (i = {}), ((n = {})[e] = t), s.Core.setAttributes(n, i)
          );
        },
        getAttributes: function() {
          return s.cart.attributes;
        },
        setAttributes: function(e, t) {
          return (
            null == e && (e = {}),
            null == t && (t = {}),
            (t.updateCart = !0),
            s.Queue.add("/cart/update.js", s.Utils.wrapKeys(e, "attributes"), t)
          );
        },
        clearAttributes: function(e) {
          return (
            null == e && (e = {}),
            (e.updateCart = !0),
            s.Queue.add(
              "/cart/update.js",
              s.Utils.wrapKeys(s.Core.getAttributes(), "attributes", ""),
              e
            )
          );
        },
        getNote: function() {
          return s.cart.note;
        },
        setNote: function(e, t) {
          return (
            null == t && (t = {}),
            (t.updateCart = !0),
            s.Queue.add("/cart/update.js", { note: e }, t)
          );
        }
      }),
      (i = null),
      (s.Data = {
        init: function() {
          return (
            (i = jQuery(document)),
            s.Data.setEventListeners("on"),
            s.Data.render(null, s.cart)
          );
        },
        destroy: function() {
          return s.Data.setEventListeners("off");
        },
        setEventListeners: function(e) {
          return (
            i[e]("click", "[data-cart-add]", s.Data.add),
            i[e]("click", "[data-cart-remove]", s.Data.remove),
            i[e]("click", "[data-cart-remove-id]", s.Data.removeById),
            i[e]("click", "[data-cart-update]", s.Data.update),
            i[e]("click", "[data-cart-update-id]", s.Data.updateById),
            i[e]("click", "[data-cart-clear]", s.Data.clear),
            i[e]("change", "[data-cart-toggle]", s.Data.toggle),
            i[e](
              "change",
              "[data-cart-toggle-attribute]",
              s.Data.toggleAttribute
            ),
            i[e]("submit", "[data-cart-submit]", s.Data.submit),
            i[e]("cart.requestComplete", s.Data.render)
          );
        },
        add: function(e) {
          var t;
          return (
            e.preventDefault(),
            (t = jQuery(this)),
            s.Core.addItem(t.attr("data-cart-add"), t.attr("data-cart-quantity"))
          );
        },
        remove: function(e) {
          var t;
          return (
            e.preventDefault(),
            (t = jQuery(this)),
            s.Core.removeItem(t.attr("data-cart-remove"))
          );
        },
        removeById: function(e) {
          var t;
          return (
            e.preventDefault(),
            (t = jQuery(this)),
            s.Core.removeItemById(t.attr("data-cart-remove-id"))
          );
        },
        update: function(e) {
          var t;
          return (
            e.preventDefault(),
            (t = jQuery(this)),
            s.Core.updateItem(
              t.attr("data-cart-update"),
              t.attr("data-cart-quantity")
            )
          );
        },
        updateById: function(e) {
          var t;
          return (
            e.preventDefault(),
            (t = jQuery(this)),
            s.Core.updateItemById(
              t.attr("data-cart-update-id"),
              t.attr("data-cart-quantity")
            )
          );
        },
        clear: function(e) {
          return e.preventDefault(), s.Core.clear();
        },
        toggle: function(e) {
          var t, i;
          return (
            (i = (t = jQuery(this)).attr("data-cart-toggle")),
            t.is(":checked") ? s.Core.addItem(i) : s.Core.removeItemById(i)
          );
        },
        toggleAttribute: function(e) {
          var t, i;
          return (
            (i = (t = jQuery(this)).attr("data-cart-toggle-attribute")),
            s.Core.setAttribute(i, t.is(":checked") ? "Yes" : "")
          );
        },
        submit: function(e) {
          var t, i, n, o;
          return (
            e.preventDefault(),
            (t = jQuery(this).serializeArray()),
            (o = i = void 0),
            (n = {}),
            jQuery.each(t, function(e, t) {
              return "id" === t.name
                ? (i = t.value)
                : "quantity" === t.name
                ? (o = t.value)
                : (n[t.name] = t.value);
            }),
            s.Core.addItem(i, o, s.Utils.unwrapKeys(n))
          );
        },
        render: function(e, t) {
          var i;
          return (
            (i = {
              item_count: t.item_count,
              total_price: t.total_price,
              total_price_money: s.Utils.formatMoney(
                t.total_price,
                s.settings.moneyFormat,
                "money_format",
                null !=
                  ("undefined" != typeof Currency && null !== Currency
                    ? Currency.currentCurrency
                    : void 0)
                  ? Currency.currentCurrency
                  : void 0
              ),
              total_price_money_with_currency: s.Utils.formatMoney(
                t.total_price,
                s.settings.moneyWithCurrencyFormat,
                "money_with_currency_format",
                null !=
                  ("undefined" != typeof Currency && null !== Currency
                    ? Currency.currentCurrency
                    : void 0)
                  ? Currency.currentCurrency
                  : void 0
              )
            }),
            jQuery("[data-cart-render]").each(function() {
              var e;
              return (e = jQuery(this)).html(i[e.attr("data-cart-render")]);
            })
          );
        }
      }),
      "rivets" in window
        ? ((s.Rivets = {
            model: null,
            boundViews: [],
            init: function() {
              return s.Rivets.bindViews();
            },
            destroy: function() {
              return s.Rivets.unbindViews();
            },
            bindViews: function() {
              return (
                s.Utils.log("Rivets.js is present, binding views."),
                s.Rivets.unbindViews(),
                (s.Rivets.model = s.Utils.extend(
                  { cart: s.cart },
                  s.settings.rivetsModels
                )),
                null != window.Currency &&
                  (s.Rivets.model.Currency = window.Currency),
                jQuery("[data-cart-view]").each(function() {
                  var e;
                  return (
                    (e = rivets.bind(jQuery(this), s.Rivets.model)),
                    s.Rivets.boundViews.push(e)
                  );
                })
              );
            },
            unbindViews: function() {
              var e, t, i;
              for (e = 0, t = (i = s.Rivets.boundViews).length; e < t; e++)
                i[e].unbind();
              return (s.Rivets.boundViews = []);
            }
          }),
          (rivets.formatters.eq = function(e, t) {
            return e === t;
          }),
          (rivets.formatters.includes = function(e, t) {
            return 0 <= e.indexOf(t);
          }),
          (rivets.formatters.match = function(e, t, i) {
            return e.match(new RegExp(t, i));
          }),
          (rivets.formatters.lt = function(e, t) {
            return e < t;
          }),
          (rivets.formatters.gt = function(e, t) {
            return t < e;
          }),
          (rivets.formatters.not = function(e) {
            return !e;
          }),
          (rivets.formatters.empty = function(e) {
            return !e.length;
          }),
          (rivets.formatters.plus = function(e, t) {
            return parseInt(e) + parseInt(t);
          }),
          (rivets.formatters.minus = function(e, t) {
            return parseInt(e) - parseInt(t);
          }),
          (rivets.formatters.prepend = function(e, t) {
            return t + e;
          }),
          (rivets.formatters.append = function(e, t) {
            return e + t;
          }),
          (rivets.formatters.slice = function(e, t, i) {
            return e.slice(t, i);
          }),
          (rivets.formatters.pluralize = function(e, t, i) {
            return (
              null == i && (i = t + "s"),
              s.Utils.isArray(e) && (e = e.length),
              1 === e ? t : i
            );
          }),
          (rivets.formatters.array_element = function(e, t) {
            return e[t];
          }),
          (rivets.formatters.array_first = function(e) {
            return e[0];
          }),
          (rivets.formatters.array_last = function(e) {
            return e[e.length - 1];
          }),
          (rivets.formatters.money = function(e, t) {
            return s.Utils.formatMoney(
              e,
              s.settings.moneyFormat,
              "money_format",
              t
            );
          }),
          (rivets.formatters.money_with_currency = function(e, t) {
            return s.Utils.formatMoney(
              e,
              s.settings.moneyWithCurrencyFormat,
              "money_with_currency_format",
              t
            );
          }),
          (rivets.formatters.weight = function(e) {
            switch (s.settings.weightUnit) {
              case "kg":
                return (e / 1e3).toFixed(s.settings.weightPrecision);
              case "oz":
                return (0.035274 * e).toFixed(s.settings.weightPrecision);
              case "lb":
                return (0.00220462 * e).toFixed(s.settings.weightPrecision);
              default:
                return e.toFixed(s.settings.weightPrecision);
            }
          }),
          (rivets.formatters.weight_with_unit = function(e) {
            return rivets.formatters.weight(e) + s.settings.weightUnit;
          }),
          (rivets.formatters.product_image_size = function(e, t) {
            return s.Utils.getSizedImageUrl(e, t);
          }),
          (rivets.formatters.moneyWithCurrency =
            rivets.formatters.money_with_currency),
          (rivets.formatters.weightWithUnit = rivets.formatters.weight_with_unit),
          (rivets.formatters.productImageSize =
            rivets.formatters.product_image_size))
        : (s.Rivets = { init: function() {}, destroy: function() {} }),
      (s.factory = function(e) {
        return (
          (e.init = s.init),
          (e.configure = s.configure),
          (e.cart = s.cart),
          (e.settings = s.settings),
          (e.getCart = s.Core.getCart),
          (e.addItem = s.Core.addItem),
          (e.updateItem = s.Core.updateItem),
          (e.updateItemById = s.Core.updateItemById),
          (e.updateItemQuantitiesById = s.Core.updateItemQuantitiesById),
          (e.removeItem = s.Core.removeItem),
          (e.removeItemById = s.Core.removeItemById),
          (e.clear = s.Core.clear),
          (e.getAttribute = s.Core.getAttribute),
          (e.setAttribute = s.Core.setAttribute),
          (e.getAttributes = s.Core.getAttributes),
          (e.setAttributes = s.Core.setAttributes),
          (e.clearAttributes = s.Core.clearAttributes),
          (e.getNote = s.Core.getNote),
          (e.setNote = s.Core.setNote),
          (e.render = s.Data.render)
        );
      }),
      "object" == typeof exports
        ? s.factory(exports)
        : "function" == typeof define && define.amd
        ? define(["exports"], function(e) {
            return s.factory((this.CartJS = e)), e;
          })
        : s.factory((this.CartJS = {}));
  }.call(this),
    (function(g, m) {
      "use strict";
      if (
        "IntersectionObserver" in g &&
        "IntersectionObserverEntry" in g &&
        "intersectionRatio" in g.IntersectionObserverEntry.prototype
      )
        "isIntersecting" in g.IntersectionObserverEntry.prototype ||
          Object.defineProperty(
            g.IntersectionObserverEntry.prototype,
            "isIntersecting",
            {
              get: function() {
                return 0 < this.intersectionRatio;
              }
            }
          );
      else {
        var t = [];
        (e.prototype.THROTTLE_TIMEOUT = 100),
          (e.prototype.POLL_INTERVAL = null),
          (e.prototype.USE_MUTATION_OBSERVER = !0),
          (e.prototype.observe = function(t) {
            if (
              !this._observationTargets.some(function(e) {
                return e.element == t;
              })
            ) {
              if (!t || 1 != t.nodeType)
                throw new Error("target must be an Element");
              this._registerInstance(),
                this._observationTargets.push({ element: t, entry: null }),
                this._monitorIntersections(),
                this._checkForIntersections();
            }
          }),
          (e.prototype.unobserve = function(t) {
            (this._observationTargets = this._observationTargets.filter(function(
              e
            ) {
              return e.element != t;
            })),
              this._observationTargets.length ||
                (this._unmonitorIntersections(), this._unregisterInstance());
          }),
          (e.prototype.disconnect = function() {
            (this._observationTargets = []),
              this._unmonitorIntersections(),
              this._unregisterInstance();
          }),
          (e.prototype.takeRecords = function() {
            var e = this._queuedEntries.slice();
            return (this._queuedEntries = []), e;
          }),
          (e.prototype._initThresholds = function(e) {
            var t = e || [0];
            return (
              Array.isArray(t) || (t = [t]),
              t.sort().filter(function(e, t, i) {
                if ("number" != typeof e || isNaN(e) || e < 0 || 1 < e)
                  throw new Error(
                    "threshold must be a number between 0 and 1 inclusively"
                  );
                return e !== i[t - 1];
              })
            );
          }),
          (e.prototype._parseRootMargin = function(e) {
            var t = (e || "0px").split(/\s+/).map(function(e) {
              var t = /^(-?\d*\.?\d+)(px|%)$/.exec(e);
              if (!t)
                throw new Error(
                  "rootMargin must be specified in pixels or percent"
                );
              return { value: parseFloat(t[1]), unit: t[2] };
            });
            return (
              (t[1] = t[1] || t[0]),
              (t[2] = t[2] || t[0]),
              (t[3] = t[3] || t[1]),
              t
            );
          }),
          (e.prototype._monitorIntersections = function() {
            this._monitoringIntersections ||
              ((this._monitoringIntersections = !0),
              this.POLL_INTERVAL
                ? (this._monitoringInterval = setInterval(
                    this._checkForIntersections,
                    this.POLL_INTERVAL
                  ))
                : (i(g, "resize", this._checkForIntersections, !0),
                  i(m, "scroll", this._checkForIntersections, !0),
                  this.USE_MUTATION_OBSERVER &&
                    "MutationObserver" in g &&
                    ((this._domObserver = new MutationObserver(
                      this._checkForIntersections
                    )),
                    this._domObserver.observe(m, {
                      attributes: !0,
                      childList: !0,
                      characterData: !0,
                      subtree: !0
                    }))));
          }),
          (e.prototype._unmonitorIntersections = function() {
            this._monitoringIntersections &&
              ((this._monitoringIntersections = !1),
              clearInterval(this._monitoringInterval),
              (this._monitoringInterval = null),
              n(g, "resize", this._checkForIntersections, !0),
              n(m, "scroll", this._checkForIntersections, !0),
              this._domObserver &&
                (this._domObserver.disconnect(), (this._domObserver = null)));
          }),
          (e.prototype._checkForIntersections = function() {
            var a = this._rootIsInDom(),
              l = a
                ? this._getRootRect()
                : { top: 0, bottom: 0, left: 0, right: 0, width: 0, height: 0 };
            this._observationTargets.forEach(function(e) {
              var t = e.element,
                i = v(t),
                n = this._rootContainsTarget(t),
                o = e.entry,
                r = a && n && this._computeTargetAndRootIntersection(t, l),
                s = (e.entry = new c({
                  time: g.performance && performance.now && performance.now(),
                  target: t,
                  boundingClientRect: i,
                  rootBounds: l,
                  intersectionRect: r
                }));
              o
                ? a && n
                  ? this._hasCrossedThreshold(o, s) && this._queuedEntries.push(s)
                  : o && o.isIntersecting && this._queuedEntries.push(s)
                : this._queuedEntries.push(s);
            }, this),
              this._queuedEntries.length &&
                this._callback(this.takeRecords(), this);
          }),
          (e.prototype._computeTargetAndRootIntersection = function(e, t) {
            if ("none" != g.getComputedStyle(e).display) {
              for (var i, n, o, r, s, a, l, c, d = v(e), u = y(e), p = !1; !p; ) {
                var h = null,
                  f = 1 == u.nodeType ? g.getComputedStyle(u) : {};
                if ("none" == f.display) return;
                if (
                  (u == this.root || u == m
                    ? ((p = !0), (h = t))
                    : u != m.body &&
                      u != m.documentElement &&
                      "visible" != f.overflow &&
                      (h = v(u)),
                  h &&
                    ((i = h),
                    (n = d),
                    void 0,
                    (o = Math.max(i.top, n.top)),
                    (r = Math.min(i.bottom, n.bottom)),
                    (s = Math.max(i.left, n.left)),
                    (a = Math.min(i.right, n.right)),
                    (c = r - o),
                    !(d = 0 <= (l = a - s) &&
                      0 <= c && {
                        top: o,
                        bottom: r,
                        left: s,
                        right: a,
                        width: l,
                        height: c
                      })))
                )
                  break;
                u = y(u);
              }
              return d;
            }
          }),
          (e.prototype._getRootRect = function() {
            var e;
            if (this.root) e = v(this.root);
            else {
              var t = m.documentElement,
                i = m.body;
              e = {
                top: 0,
                left: 0,
                right: t.clientWidth || i.clientWidth,
                width: t.clientWidth || i.clientWidth,
                bottom: t.clientHeight || i.clientHeight,
                height: t.clientHeight || i.clientHeight
              };
            }
            return this._expandRectByRootMargin(e);
          }),
          (e.prototype._expandRectByRootMargin = function(i) {
            var e = this._rootMarginValues.map(function(e, t) {
                return "px" == e.unit
                  ? e.value
                  : (e.value * (t % 2 ? i.width : i.height)) / 100;
              }),
              t = {
                top: i.top - e[0],
                right: i.right + e[1],
                bottom: i.bottom + e[2],
                left: i.left - e[3]
              };
            return (t.width = t.right - t.left), (t.height = t.bottom - t.top), t;
          }),
          (e.prototype._hasCrossedThreshold = function(e, t) {
            var i = e && e.isIntersecting ? e.intersectionRatio || 0 : -1,
              n = t.isIntersecting ? t.intersectionRatio || 0 : -1;
            if (i !== n)
              for (var o = 0; o < this.thresholds.length; o++) {
                var r = this.thresholds[o];
                if (r == i || r == n || r < i != r < n) return !0;
              }
          }),
          (e.prototype._rootIsInDom = function() {
            return !this.root || o(m, this.root);
          }),
          (e.prototype._rootContainsTarget = function(e) {
            return o(this.root || m, e);
          }),
          (e.prototype._registerInstance = function() {
            t.indexOf(this) < 0 && t.push(this);
          }),
          (e.prototype._unregisterInstance = function() {
            var e = t.indexOf(this);
            -1 != e && t.splice(e, 1);
          }),
          (g.IntersectionObserver = e),
          (g.IntersectionObserverEntry = c);
      }
      function c(e) {
        (this.time = e.time),
          (this.target = e.target),
          (this.rootBounds = e.rootBounds),
          (this.boundingClientRect = e.boundingClientRect),
          (this.intersectionRect = e.intersectionRect || {
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            width: 0,
            height: 0
          }),
          (this.isIntersecting = !!e.intersectionRect);
        var t = this.boundingClientRect,
          i = t.width * t.height,
          n = this.intersectionRect,
          o = n.width * n.height;
        this.intersectionRatio = i ? o / i : this.isIntersecting ? 1 : 0;
      }
      function e(e, t) {
        var i = t || {};
        if ("function" != typeof e)
          throw new Error("callback must be a function");
        if (i.root && 1 != i.root.nodeType)
          throw new Error("root must be an Element");
        (this._checkForIntersections = (function(e, t) {
          var i = null;
          return function() {
            i ||
              (i = setTimeout(function() {
                e(), (i = null);
              }, t));
          };
        })(this._checkForIntersections.bind(this), this.THROTTLE_TIMEOUT)),
          (this._callback = e),
          (this._observationTargets = []),
          (this._queuedEntries = []),
          (this._rootMarginValues = this._parseRootMargin(i.rootMargin)),
          (this.thresholds = this._initThresholds(i.threshold)),
          (this.root = i.root || null),
          (this.rootMargin = this._rootMarginValues
            .map(function(e) {
              return e.value + e.unit;
            })
            .join(" "));
      }
      function i(e, t, i, n) {
        "function" == typeof e.addEventListener
          ? e.addEventListener(t, i, n || !1)
          : "function" == typeof e.attachEvent && e.attachEvent("on" + t, i);
      }
      function n(e, t, i, n) {
        "function" == typeof e.removeEventListener
          ? e.removeEventListener(t, i, n || !1)
          : "function" == typeof e.detatchEvent && e.detatchEvent("on" + t, i);
      }
      function v(e) {
        var t;
        try {
          t = e.getBoundingClientRect();
        } catch (e) {}
        return t
          ? ((t.width && t.height) ||
              (t = {
                top: t.top,
                right: t.right,
                bottom: t.bottom,
                left: t.left,
                width: t.right - t.left,
                height: t.bottom - t.top
              }),
            t)
          : { top: 0, bottom: 0, left: 0, right: 0, width: 0, height: 0 };
      }
      function o(e, t) {
        for (var i = t; i; ) {
          if (i == e) return !0;
          i = y(i);
        }
        return !1;
      }
      function y(e) {
        var t = e.parentNode;
        return t && 11 == t.nodeType && t.host ? t.host : t;
      }
    })(window, document),
    (function(e) {
      var t = !1;
      if (
        ("function" == typeof define && define.amd && (define(e), (t = !0)),
        "object" == typeof exports && ((module.exports = e()), (t = !0)),
        !t)
      ) {
        var i = window.Cookies,
          n = (window.Cookies = e());
        n.noConflict = function() {
          return (window.Cookies = i), n;
        };
      }
    })(function() {
      function g() {
        for (var e = 0, t = {}; e < arguments.length; e++) {
          var i = arguments[e];
          for (var n in i) t[n] = i[n];
        }
        return t;
      }
      return (function e(h) {
        function f(e, t, i) {
          var n;
          if ("undefined" != typeof document) {
            if (1 < arguments.length) {
              if (
                "number" == typeof (i = g({ path: "/" }, f.defaults, i)).expires
              ) {
                var o = new Date();
                o.setMilliseconds(o.getMilliseconds() + 864e5 * i.expires),
                  (i.expires = o);
              }
              i.expires = i.expires ? i.expires.toUTCString() : "";
              try {
                (n = JSON.stringify(t)), /^[\{\[]/.test(n) && (t = n);
              } catch (e) {}
              (t = h.write
                ? h.write(t, e)
                : encodeURIComponent(String(t)).replace(
                    /%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,
                    decodeURIComponent
                  )),
                (e = (e = (e = encodeURIComponent(String(e))).replace(
                  /%(23|24|26|2B|5E|60|7C)/g,
                  decodeURIComponent
                )).replace(/[\(\)]/g, escape));
              var r = "";
              for (var s in i)
                i[s] && ((r += "; " + s), !0 !== i[s] && (r += "=" + i[s]));
              return (document.cookie = e + "=" + t + r);
            }
            e || (n = {});
            for (
              var a = document.cookie ? document.cookie.split("; ") : [],
                l = /(%[0-9A-Z]{2})+/g,
                c = 0;
              c < a.length;
              c++
            ) {
              var d = a[c].split("="),
                u = d.slice(1).join("=");
              '"' === u.charAt(0) && (u = u.slice(1, -1));
              try {
                var p = d[0].replace(l, decodeURIComponent);
                if (
                  ((u = h.read
                    ? h.read(u, p)
                    : h(u, p) || u.replace(l, decodeURIComponent)),
                  this.json)
                )
                  try {
                    u = JSON.parse(u);
                  } catch (e) {}
                if (e === p) {
                  n = u;
                  break;
                }
                e || (n[p] = u);
              } catch (e) {}
            }
            return n;
          }
        }
        return (
          ((f.set = f).get = function(e) {
            return f.call(f, e);
          }),
          (f.getJSON = function() {
            return f.apply({ json: !0 }, [].slice.call(arguments));
          }),
          (f.defaults = {}),
          (f.remove = function(e, t) {
            f(e, "", g(t, { expires: -1 }));
          }),
          (f.withConverter = e),
          f
        );
      })(function() {});
    }));
  var _extends =
      Object.assign ||
      function(e) {
        for (var t = 1; t < arguments.length; t++) {
          var i = arguments[t];
          for (var n in i)
            Object.prototype.hasOwnProperty.call(i, n) && (e[n] = i[n]);
        }
        return e;
      },
    _typeof =
      "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
        ? function(e) {
            return typeof e;
          }
        : function(e) {
            return e &&
              "function" == typeof Symbol &&
              e.constructor === Symbol &&
              e !== Symbol.prototype
              ? "symbol"
              : typeof e;
          };
  !(function(e, t) {
    "object" ===
      ("undefined" == typeof exports ? "undefined" : _typeof(exports)) &&
    "undefined" != typeof module
      ? (module.exports = t())
      : "function" == typeof define && define.amd
      ? define(t)
      : (e.LazyLoad = t());
  })(this, function() {
    "use strict";
    function a(e, t) {
      return e.getAttribute("data-" + t);
    }
    function o(e) {
      return e.filter(function(e) {
        return !a(e, "was-processed");
      });
    }
    function r(e, t) {
      var i = new e(t),
        n = new CustomEvent("LazyLoad::Initialized", { detail: { instance: i } });
      window.dispatchEvent(n);
    }
    function i(e, t) {
      var i = t.data_src,
        n = t.data_srcset,
        o = e.tagName,
        r = a(e, i);
      if ("IMG" === o) {
        !(function(e, t) {
          var i = t.data_srcset,
            n = e.parentElement;
          if ("PICTURE" === n.tagName)
            for (var o, r = 0; (o = n.children[r]); r += 1)
              if ("SOURCE" === o.tagName) {
                var s = a(o, i);
                s && o.setAttribute("srcset", s);
              }
        })(e, t);
        var s = a(e, n);
        return (
          s && e.setAttribute("srcset", s), void (r && e.setAttribute("src", r))
        );
      }
      "IFRAME" !== o
        ? r && (e.style.backgroundImage = 'url("' + r + '")')
        : r && e.setAttribute("src", r);
    }
    function s(e, t) {
      u ? e.classList.add(t) : (e.className += (e.className ? " " : "") + t);
    }
    function l(e, t) {
      e && e(t);
    }
    function c(e, t, i) {
      e.removeEventListener("load", t), e.removeEventListener("error", i);
    }
    function d(e, t) {
      -1 < ["IMG", "IFRAME"].indexOf(e.tagName) &&
        ((function(i, n) {
          function o(e) {
            p(e, !0, n), c(i, o, t);
          }
          var t = function e(t) {
            p(t, !1, n), c(i, o, e);
          };
          i.addEventListener("load", o), i.addEventListener("error", t);
        })(e, t),
        s(e, t.class_loading)),
        i(e, t),
        (function(e, t, i) {
          e.setAttribute("data-" + t, i);
        })(e, "was-processed", !0),
        l(t.callback_set, e);
    }
    function e(e, t) {
      (this._settings = _extends({}, n, e)), this._setObserver(), this.update(t);
    }
    var n = {
        elements_selector: "img",
        container: document,
        threshold: 300,
        data_src: "src",
        data_srcset: "srcset",
        class_loading: "loading",
        class_loaded: "loaded",
        class_error: "error",
        callback_load: null,
        callback_error: null,
        callback_set: null
      },
      u = "classList" in document.createElement("p"),
      p = function(e, t, i) {
        var n = e.target;
        !(function(e, t) {
          u
            ? e.classList.remove(t)
            : (e.className = e.className
                .replace(new RegExp("(^|\\s+)" + t + "(\\s+|$)"), " ")
                .replace(/^\s+/, "")
                .replace(/\s+$/, ""));
        })(n, i.class_loading),
          s(n, t ? i.class_loaded : i.class_error),
          l(t ? i.callback_load : i.callback_error, n);
      };
    e.prototype = {
      _setObserver: function() {
        var i = this;
        if ("IntersectionObserver" in window) {
          var n = this._settings;
          this._observer = new IntersectionObserver(
            function(e) {
              e.forEach(function(e) {
                if (0 < e.intersectionRatio) {
                  var t = e.target;
                  d(t, n), i._observer.unobserve(t);
                }
              }),
                (i._elements = o(i._elements));
            },
            {
              root: n.container === document ? null : n.container,
              rootMargin: n.threshold + "px"
            }
          );
        }
      },
      update: function(e) {
        var t = this,
          i = this._settings,
          n = e || i.container.querySelectorAll(i.elements_selector);
        (this._elements = o(Array.prototype.slice.call(n))),
          this._observer
            ? this._elements.forEach(function(e) {
                t._observer.observe(e);
              })
            : (this._elements.forEach(function(e) {
                d(e, i);
              }),
              (this._elements = o(this._elements)));
      },
      destroy: function() {
        var t = this;
        this._observer &&
          (o(this._elements).forEach(function(e) {
            t._observer.unobserve(e);
          }),
          (this._observer = null)),
          (this._elements = null),
          (this._settings = null);
      }
    };
    var t = window.lazyLoadOptions;
    return (
      t &&
        (function(e, t) {
          if (t.length) for (var i, n = 0; (i = t[n]); n += 1) r(e, i);
          else r(e, t);
        })(e, t),
      e
    );
  }),
    (function() {
      "use strict";
      if ("undefined" != typeof window) {
        var e = window.navigator.userAgent.match(/Edge\/(\d{2})\./),
          n = !!e && 16 <= parseInt(e[1], 10);
        if ("objectFit" in document.documentElement.style == !1 || n) {
          var o = function(e, t, i) {
              var n, o, r, s, a;
              if (((i = i.split(" ")).length < 2 && (i[1] = i[0]), "x" === e))
                (n = i[0]),
                  (o = i[1]),
                  (r = "left"),
                  (s = "right"),
                  (a = t.clientWidth);
              else {
                if ("y" !== e) return;
                (n = i[1]),
                  (o = i[0]),
                  (r = "top"),
                  (s = "bottom"),
                  (a = t.clientHeight);
              }
              if (n !== r && o !== r) {
                if (n !== s && o !== s)
                  return "center" === n || "50%" === n
                    ? ((t.style[r] = "50%"),
                      void (t.style["margin-" + r] = a / -2 + "px"))
                    : void (0 <= n.indexOf("%")
                        ? (n = parseInt(n)) < 50
                          ? ((t.style[r] = n + "%"),
                            (t.style["margin-" + r] = a * (n / -100) + "px"))
                          : ((n = 100 - n),
                            (t.style[s] = n + "%"),
                            (t.style["margin-" + s] = a * (n / -100) + "px"))
                        : (t.style[r] = n));
                t.style[s] = "0";
              } else t.style[r] = "0";
            },
            r = function(e) {
              var t = e.dataset
                  ? e.dataset.objectFit
                  : e.getAttribute("data-object-fit"),
                i = e.dataset
                  ? e.dataset.objectPosition
                  : e.getAttribute("data-object-position");
              (t = t || "cover"), (i = i || "50% 50%");
              var n = e.parentNode;
              !(function(e) {
                var t = window.getComputedStyle(e, null),
                  i = t.getPropertyValue("position"),
                  n = t.getPropertyValue("overflow"),
                  o = t.getPropertyValue("display");
                (i && "static" !== i) || (e.style.position = "relative"),
                  "hidden" !== n && (e.style.overflow = "hidden"),
                  (o && "inline" !== o) || (e.style.display = "block"),
                  0 === e.clientHeight && (e.style.height = "100%"),
                  -1 === e.className.indexOf("object-fit-polyfill") &&
                    (e.className = e.className + " object-fit-polyfill");
              })(n),
                (function(e) {
                  var t = window.getComputedStyle(e, null),
                    i = {
                      "max-width": "none",
                      "max-height": "none",
                      "min-width": "0px",
                      "min-height": "0px",
                      top: "auto",
                      right: "auto",
                      bottom: "auto",
                      left: "auto",
                      "margin-top": "0px",
                      "margin-right": "0px",
                      "margin-bottom": "0px",
                      "margin-left": "0px"
                    };
                  for (var n in i)
                    t.getPropertyValue(n) !== i[n] && (e.style[n] = i[n]);
                })(e),
                (e.style.position = "absolute"),
                (e.style.height = "100%"),
                (e.style.width = "auto"),
                "scale-down" === t &&
                  ((e.style.height = "auto"),
                  e.clientWidth < n.clientWidth && e.clientHeight < n.clientHeight
                    ? (o("x", e, i), o("y", e, i))
                    : ((t = "contain"), (e.style.height = "100%"))),
                "none" === t
                  ? ((e.style.width = "auto"),
                    (e.style.height = "auto"),
                    o("x", e, i),
                    o("y", e, i))
                  : ("cover" === t && e.clientWidth > n.clientWidth) ||
                    ("contain" === t && e.clientWidth < n.clientWidth)
                  ? ((e.style.top = "0"), (e.style.marginTop = "0"), o("x", e, i))
                  : "scale-down" !== t &&
                    ((e.style.width = "100%"),
                    (e.style.height = "auto"),
                    (e.style.left = "0"),
                    (e.style.marginLeft = "0"),
                    o("y", e, i));
            },
            t = function(e) {
              if (void 0 === e)
                e = document.querySelectorAll("[data-object-fit]");
              else if (e && e.nodeName) e = [e];
              else {
                if ("object" != typeof e || !e.length || !e[0].nodeName)
                  return !1;
                e = e;
              }
              for (var t = 0; t < e.length; t++)
                if (e[t].nodeName) {
                  var i = e[t].nodeName.toLowerCase();
                  "img" !== i || n
                    ? "video" === i &&
                      (0 < e[t].readyState
                        ? r(e[t])
                        : e[t].addEventListener("loadedmetadata", function() {
                            r(this);
                          }))
                    : e[t].complete
                    ? r(e[t])
                    : e[t].addEventListener("load", function() {
                        r(this);
                      });
                }
              return !0;
            };
          document.addEventListener("DOMContentLoaded", function() {
            t();
          }),
            window.addEventListener("resize", function() {
              t();
            }),
            (window.objectFitPolyfill = t);
        } else
          window.objectFitPolyfill = function() {
            return !1;
          };
      }
    })(),
    (function(e, t) {
      "object" == typeof exports && "undefined" != typeof module
        ? (module.exports = t())
        : "function" == typeof define && define.amd
        ? define(t)
        : (e.Popper = t());
    })(this, function() {
      "use strict";
      for (
        var e = "undefined" != typeof window && "undefined" != typeof document,
          t = ["Edge", "Trident", "Firefox"],
          i = 0,
          n = 0;
        n < t.length;
        n += 1
      )
        if (e && 0 <= navigator.userAgent.indexOf(t[n])) {
          i = 1;
          break;
        }
      var s =
        e && window.Promise
          ? function(e) {
              var t = !1;
              return function() {
                t ||
                  ((t = !0),
                  window.Promise.resolve().then(function() {
                    (t = !1), e();
                  }));
              };
            }
          : function(e) {
              var t = !1;
              return function() {
                t ||
                  ((t = !0),
                  setTimeout(function() {
                    (t = !1), e();
                  }, i));
              };
            };
      function a(e) {
        return e && "[object Function]" === {}.toString.call(e);
      }
      function b(e, t) {
        if (1 !== e.nodeType) return [];
        var i = getComputedStyle(e, null);
        return t ? i[t] : i;
      }
      function h(e) {
        return "HTML" === e.nodeName ? e : e.parentNode || e.host;
      }
      function f(e) {
        if (!e) return document.body;
        switch (e.nodeName) {
          case "HTML":
          case "BODY":
            return e.ownerDocument.body;
          case "#document":
            return e.body;
        }
        var t = b(e),
          i = t.overflow,
          n = t.overflowX,
          o = t.overflowY;
        return /(auto|scroll|overlay)/.test(i + o + n) ? e : f(h(e));
      }
      var o = e && !(!window.MSInputMethodContext || !document.documentMode),
        r = e && /MSIE 10/.test(navigator.userAgent);
      function g(e) {
        return 11 === e ? o : 10 === e ? r : o || r;
      }
      function w(e) {
        if (!e) return document.documentElement;
        for (
          var t = g(10) ? document.body : null, i = e.offsetParent;
          i === t && e.nextElementSibling;
  
        )
          i = (e = e.nextElementSibling).offsetParent;
        var n = i && i.nodeName;
        return n && "BODY" !== n && "HTML" !== n
          ? -1 !== ["TD", "TABLE"].indexOf(i.nodeName) &&
            "static" === b(i, "position")
            ? w(i)
            : i
          : e
          ? e.ownerDocument.documentElement
          : document.documentElement;
      }
      function l(e) {
        return null !== e.parentNode ? l(e.parentNode) : e;
      }
      function m(e, t) {
        if (!(e && e.nodeType && t && t.nodeType))
          return document.documentElement;
        var i = e.compareDocumentPosition(t) & Node.DOCUMENT_POSITION_FOLLOWING,
          n = i ? e : t,
          o = i ? t : e,
          r = document.createRange();
        r.setStart(n, 0), r.setEnd(o, 0);
        var s = r.commonAncestorContainer;
        if ((e !== s && t !== s) || n.contains(o))
          return (function(e) {
            var t = e.nodeName;
            return "BODY" !== t && ("HTML" === t || w(e.firstElementChild) === e);
          })(s)
            ? s
            : w(s);
        var a = l(e);
        return a.host ? m(a.host, t) : m(e, l(t).host);
      }
      function v(e) {
        var t =
            "top" ===
            (1 < arguments.length && void 0 !== arguments[1]
              ? arguments[1]
              : "top")
              ? "scrollTop"
              : "scrollLeft",
          i = e.nodeName;
        if ("BODY" !== i && "HTML" !== i) return e[t];
        var n = e.ownerDocument.documentElement;
        return (e.ownerDocument.scrollingElement || n)[t];
      }
      function u(e, t) {
        var i = "x" === t ? "Left" : "Top",
          n = "Left" == i ? "Right" : "Bottom";
        return (
          parseFloat(e["border" + i + "Width"], 10) +
          parseFloat(e["border" + n + "Width"], 10)
        );
      }
      function c(e, t, i, n) {
        return Math.max(
          t["offset" + e],
          t["scroll" + e],
          i["client" + e],
          i["offset" + e],
          i["scroll" + e],
          g(10)
            ? parseInt(i["offset" + e]) +
                parseInt(n["margin" + ("Height" === e ? "Top" : "Left")]) +
                parseInt(n["margin" + ("Height" === e ? "Bottom" : "Right")])
            : 0
        );
      }
      function y(e) {
        var t = e.body,
          i = e.documentElement,
          n = g(10) && getComputedStyle(i);
        return { height: c("Height", t, i, n), width: c("Width", t, i, n) };
      }
      function _(e, t, i) {
        return (
          t in e
            ? Object.defineProperty(e, t, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
              })
            : (e[t] = i),
          e
        );
      }
      var d = (function() {
          function n(e, t) {
            for (var i = 0; i < t.length; i++) {
              var n = t[i];
              (n.enumerable = n.enumerable || !1),
                (n.configurable = !0),
                "value" in n && (n.writable = !0),
                Object.defineProperty(e, n.key, n);
            }
          }
          return function(e, t, i) {
            return t && n(e.prototype, t), i && n(e, i), e;
          };
        })(),
        k =
          Object.assign ||
          function(e) {
            for (var t = 1; t < arguments.length; t++) {
              var i = arguments[t];
              for (var n in i)
                Object.prototype.hasOwnProperty.call(i, n) && (e[n] = i[n]);
            }
            return e;
          };
      function $(e) {
        return k({}, e, { right: e.left + e.width, bottom: e.top + e.height });
      }
      function S(e) {
        var t = {};
        try {
          if (g(10)) {
            t = e.getBoundingClientRect();
            var i = v(e, "top"),
              n = v(e, "left");
            (t.top += i), (t.left += n), (t.bottom += i), (t.right += n);
          } else t = e.getBoundingClientRect();
        } catch (e) {}
        var o = {
            left: t.left,
            top: t.top,
            width: t.right - t.left,
            height: t.bottom - t.top
          },
          r = "HTML" === e.nodeName ? y(e.ownerDocument) : {},
          s = r.width || e.clientWidth || o.right - o.left,
          a = r.height || e.clientHeight || o.bottom - o.top,
          l = e.offsetWidth - s,
          c = e.offsetHeight - a;
        if (l || c) {
          var d = b(e);
          (l -= u(d, "x")), (c -= u(d, "y")), (o.width -= l), (o.height -= c);
        }
        return $(o);
      }
      function T(e, t) {
        var i = 2 < arguments.length && void 0 !== arguments[2] && arguments[2],
          n = g(10),
          o = "HTML" === t.nodeName,
          r = S(e),
          s = S(t),
          a = f(e),
          l = b(t),
          c = parseFloat(l.borderTopWidth, 10),
          d = parseFloat(l.borderLeftWidth, 10);
        i && o && ((s.top = Math.max(s.top, 0)), (s.left = Math.max(s.left, 0)));
        var u = $({
          top: r.top - s.top - c,
          left: r.left - s.left - d,
          width: r.width,
          height: r.height
        });
        if (((u.marginTop = 0), (u.marginLeft = 0), !n && o)) {
          var p = parseFloat(l.marginTop, 10),
            h = parseFloat(l.marginLeft, 10);
          (u.top -= c - p),
            (u.bottom -= c - p),
            (u.left -= d - h),
            (u.right -= d - h),
            (u.marginTop = p),
            (u.marginLeft = h);
        }
        return (
          (n && !i ? t.contains(a) : t === a && "BODY" !== a.nodeName) &&
            (u = (function(e, t) {
              var i =
                  2 < arguments.length && void 0 !== arguments[2] && arguments[2],
                n = v(t, "top"),
                o = v(t, "left"),
                r = i ? -1 : 1;
              return (
                (e.top += n * r),
                (e.bottom += n * r),
                (e.left += o * r),
                (e.right += o * r),
                e
              );
            })(u, t)),
          u
        );
      }
      function C(e) {
        if (!e || !e.parentElement || g()) return document.documentElement;
        for (var t = e.parentElement; t && "none" === b(t, "transform"); )
          t = t.parentElement;
        return t || document.documentElement;
      }
      function p(e, t, i, n) {
        var o = 4 < arguments.length && void 0 !== arguments[4] && arguments[4],
          r = { top: 0, left: 0 },
          s = o ? C(e) : m(e, t);
        if ("viewport" === n)
          r = (function(e) {
            var t =
                1 < arguments.length && void 0 !== arguments[1] && arguments[1],
              i = e.ownerDocument.documentElement,
              n = T(e, i),
              o = Math.max(i.clientWidth, window.innerWidth || 0),
              r = Math.max(i.clientHeight, window.innerHeight || 0),
              s = t ? 0 : v(i),
              a = t ? 0 : v(i, "left");
            return $({
              top: s - n.top + n.marginTop,
              left: a - n.left + n.marginLeft,
              width: o,
              height: r
            });
          })(s, o);
        else {
          var a = void 0;
          "scrollParent" === n
            ? "BODY" === (a = f(h(t))).nodeName &&
              (a = e.ownerDocument.documentElement)
            : (a = "window" === n ? e.ownerDocument.documentElement : n);
          var l = T(a, s, o);
          if (
            "HTML" !== a.nodeName ||
            (function e(t) {
              var i = t.nodeName;
              return (
                "BODY" !== i &&
                "HTML" !== i &&
                ("fixed" === b(t, "position") || e(h(t)))
              );
            })(s)
          )
            r = l;
          else {
            var c = y(e.ownerDocument),
              d = c.height,
              u = c.width;
            (r.top += l.top - l.marginTop),
              (r.bottom = d + l.top),
              (r.left += l.left - l.marginLeft),
              (r.right = u + l.left);
          }
        }
        var p = "number" == typeof (i = i || 0);
        return (
          (r.left += p ? i : i.left || 0),
          (r.top += p ? i : i.top || 0),
          (r.right -= p ? i : i.right || 0),
          (r.bottom -= p ? i : i.bottom || 0),
          r
        );
      }
      function x(e, t, n, i, o) {
        var r =
          5 < arguments.length && void 0 !== arguments[5] ? arguments[5] : 0;
        if (-1 === e.indexOf("auto")) return e;
        var s = p(n, i, r, o),
          a = {
            top: { width: s.width, height: t.top - s.top },
            right: { width: s.right - t.right, height: s.height },
            bottom: { width: s.width, height: s.bottom - t.bottom },
            left: { width: t.left - s.left, height: s.height }
          },
          l = Object.keys(a)
            .map(function(e) {
              return k({ key: e }, a[e], {
                area: (function(e) {
                  return e.width * e.height;
                })(a[e])
              });
            })
            .sort(function(e, t) {
              return t.area - e.area;
            }),
          c = l.filter(function(e) {
            var t = e.width,
              i = e.height;
            return t >= n.clientWidth && i >= n.clientHeight;
          }),
          d = 0 < c.length ? c[0].key : l[0].key,
          u = e.split("-")[1];
        return d + (u ? "-" + u : "");
      }
      function A(e, t, i) {
        var n =
          3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
        return T(i, n ? C(t) : m(t, i), n);
      }
      function E(e) {
        var t = getComputedStyle(e),
          i = parseFloat(t.marginTop) + parseFloat(t.marginBottom),
          n = parseFloat(t.marginLeft) + parseFloat(t.marginRight);
        return { width: e.offsetWidth + n, height: e.offsetHeight + i };
      }
      function O(e) {
        var t = { left: "right", right: "left", bottom: "top", top: "bottom" };
        return e.replace(/left|right|bottom|top/g, function(e) {
          return t[e];
        });
      }
      function I(e, t, i) {
        i = i.split("-")[0];
        var n = E(e),
          o = { width: n.width, height: n.height },
          r = -1 !== ["right", "left"].indexOf(i),
          s = r ? "top" : "left",
          a = r ? "left" : "top",
          l = r ? "height" : "width",
          c = r ? "width" : "height";
        return (
          (o[s] = t[s] + t[l] / 2 - n[l] / 2),
          (o[a] = i === a ? t[a] - n[c] : t[O(a)]),
          o
        );
      }
      function L(e, t) {
        return Array.prototype.find ? e.find(t) : e.filter(t)[0];
      }
      function j(e, i, t) {
        return (
          (void 0 === t
            ? e
            : e.slice(
                0,
                (function(e, t, i) {
                  if (Array.prototype.findIndex)
                    return e.findIndex(function(e) {
                      return e[t] === i;
                    });
                  var n = L(e, function(e) {
                    return e[t] === i;
                  });
                  return e.indexOf(n);
                })(e, "name", t)
              )
          ).forEach(function(e) {
            e.function &&
              console.warn(
                "`modifier.function` is deprecated, use `modifier.fn`!"
              );
            var t = e.function || e.fn;
            e.enabled &&
              a(t) &&
              ((i.offsets.popper = $(i.offsets.popper)),
              (i.offsets.reference = $(i.offsets.reference)),
              (i = t(i, e)));
          }),
          i
        );
      }
      function D(e, i) {
        return e.some(function(e) {
          var t = e.name;
          return e.enabled && t === i;
        });
      }
      function P(e) {
        for (
          var t = [!1, "ms", "Webkit", "Moz", "O"],
            i = e.charAt(0).toUpperCase() + e.slice(1),
            n = 0;
          n < t.length;
          n++
        ) {
          var o = t[n],
            r = o ? "" + o + i : e;
          if (void 0 !== document.body.style[r]) return r;
        }
        return null;
      }
      function M(e) {
        var t = e.ownerDocument;
        return t ? t.defaultView : window;
      }
      function q(e, t, i, n) {
        (i.updateBound = n),
          M(e).addEventListener("resize", i.updateBound, { passive: !0 });
        var o = f(e);
        return (
          (function e(t, i, n, o) {
            var r = "BODY" === t.nodeName,
              s = r ? t.ownerDocument.defaultView : t;
            s.addEventListener(i, n, { passive: !0 }),
              r || e(f(s.parentNode), i, n, o),
              o.push(s);
          })(o, "scroll", i.updateBound, i.scrollParents),
          (i.scrollElement = o),
          (i.eventsEnabled = !0),
          i
        );
      }
      function H() {
        this.state.eventsEnabled &&
          (cancelAnimationFrame(this.scheduleUpdate),
          (this.state = (function(e, t) {
            return (
              M(e).removeEventListener("resize", t.updateBound),
              t.scrollParents.forEach(function(e) {
                e.removeEventListener("scroll", t.updateBound);
              }),
              (t.updateBound = null),
              (t.scrollParents = []),
              (t.scrollElement = null),
              (t.eventsEnabled = !1),
              t
            );
          })(this.reference, this.state)));
      }
      function N(e) {
        return "" !== e && !isNaN(parseFloat(e)) && isFinite(e);
      }
      function R(i, n) {
        Object.keys(n).forEach(function(e) {
          var t = "";
          -1 !==
            ["width", "height", "top", "right", "bottom", "left"].indexOf(e) &&
            N(n[e]) &&
            (t = "px"),
            (i.style[e] = n[e] + t);
        });
      }
      function z(e, t, i) {
        var n = L(e, function(e) {
            return e.name === t;
          }),
          o =
            !!n &&
            e.some(function(e) {
              return e.name === i && e.enabled && e.order < n.order;
            });
        if (!o) {
          var r = "`" + t + "`",
            s = "`" + i + "`";
          console.warn(
            s +
              " modifier is required by " +
              r +
              " modifier in order to work, be sure to include it before " +
              r +
              "!"
          );
        }
        return o;
      }
      var U = [
          "auto-start",
          "auto",
          "auto-end",
          "top-start",
          "top",
          "top-end",
          "right-start",
          "right",
          "right-end",
          "bottom-end",
          "bottom",
          "bottom-start",
          "left-end",
          "left",
          "left-start"
        ],
        F = U.slice(3);
      function B(e) {
        var t = 1 < arguments.length && void 0 !== arguments[1] && arguments[1],
          i = F.indexOf(e),
          n = F.slice(i + 1).concat(F.slice(0, i));
        return t ? n.reverse() : n;
      }
      var W = "flip",
        Y = "clockwise",
        Q = "counterclockwise";
      function V(e, o, r, t) {
        var s = [0, 0],
          a = -1 !== ["right", "left"].indexOf(t),
          i = e.split(/(\+|\-)/).map(function(e) {
            return e.trim();
          }),
          n = i.indexOf(
            L(i, function(e) {
              return -1 !== e.search(/,|\s/);
            })
          );
        i[n] &&
          -1 === i[n].indexOf(",") &&
          console.warn(
            "Offsets separated by white space(s) are deprecated, use a comma (,) instead."
          );
        var l = /\s*,\s*|\s+/,
          c =
            -1 !== n
              ? [
                  i.slice(0, n).concat([i[n].split(l)[0]]),
                  [i[n].split(l)[1]].concat(i.slice(n + 1))
                ]
              : [i];
        return (
          (c = c.map(function(e, t) {
            var i = (1 === t ? !a : a) ? "height" : "width",
              n = !1;
            return e
              .reduce(function(e, t) {
                return "" === e[e.length - 1] && -1 !== ["+", "-"].indexOf(t)
                  ? ((e[e.length - 1] = t), (n = !0), e)
                  : n
                  ? ((e[e.length - 1] += t), (n = !1), e)
                  : e.concat(t);
              }, [])
              .map(function(e) {
                return (function(e, t, i, n) {
                  var o = e.match(/((?:\-|\+)?\d*\.?\d*)(.*)/),
                    r = +o[1],
                    s = o[2];
                  if (!r) return e;
                  if (0 !== s.indexOf("%"))
                    return "vh" !== s && "vw" !== s
                      ? r
                      : (("vh" === s
                          ? Math.max(
                              document.documentElement.clientHeight,
                              window.innerHeight || 0
                            )
                          : Math.max(
                              document.documentElement.clientWidth,
                              window.innerWidth || 0
                            )) /
                          100) *
                          r;
                  var a = void 0;
                  switch (s) {
                    case "%p":
                      a = i;
                      break;
                    case "%":
                    case "%r":
                    default:
                      a = n;
                  }
                  return ($(a)[t] / 100) * r;
                })(e, i, o, r);
              });
          })).forEach(function(i, n) {
            i.forEach(function(e, t) {
              N(e) && (s[n] += e * ("-" === i[t - 1] ? -1 : 1));
            });
          }),
          s
        );
      }
      var G = {
          placement: "bottom",
          positionFixed: !1,
          eventsEnabled: !0,
          removeOnDestroy: !1,
          onCreate: function() {},
          onUpdate: function() {},
          modifiers: {
            shift: {
              order: 100,
              enabled: !0,
              fn: function(e) {
                var t = e.placement,
                  i = t.split("-")[0],
                  n = t.split("-")[1];
                if (n) {
                  var o = e.offsets,
                    r = o.reference,
                    s = o.popper,
                    a = -1 !== ["bottom", "top"].indexOf(i),
                    l = a ? "left" : "top",
                    c = a ? "width" : "height",
                    d = {
                      start: _({}, l, r[l]),
                      end: _({}, l, r[l] + r[c] - s[c])
                    };
                  e.offsets.popper = k({}, s, d[n]);
                }
                return e;
              }
            },
            offset: {
              order: 200,
              enabled: !0,
              fn: function(e, t) {
                var i = t.offset,
                  n = e.placement,
                  o = e.offsets,
                  r = o.popper,
                  s = o.reference,
                  a = n.split("-")[0],
                  l = void 0;
                return (
                  (l = N(+i) ? [+i, 0] : V(i, r, s, a)),
                  "left" === a
                    ? ((r.top += l[0]), (r.left -= l[1]))
                    : "right" === a
                    ? ((r.top += l[0]), (r.left += l[1]))
                    : "top" === a
                    ? ((r.left += l[0]), (r.top -= l[1]))
                    : "bottom" === a && ((r.left += l[0]), (r.top += l[1])),
                  (e.popper = r),
                  e
                );
              },
              offset: 0
            },
            preventOverflow: {
              order: 300,
              enabled: !0,
              fn: function(e, n) {
                var t = n.boundariesElement || w(e.instance.popper);
                e.instance.reference === t && (t = w(t));
                var i = P("transform"),
                  o = e.instance.popper.style,
                  r = o.top,
                  s = o.left,
                  a = o[i];
                (o.top = ""), (o.left = ""), (o[i] = "");
                var l = p(
                  e.instance.popper,
                  e.instance.reference,
                  n.padding,
                  t,
                  e.positionFixed
                );
                (o.top = r), (o.left = s), (o[i] = a), (n.boundaries = l);
                var c = n.priority,
                  d = e.offsets.popper,
                  u = {
                    primary: function(e) {
                      var t = d[e];
                      return (
                        d[e] < l[e] &&
                          !n.escapeWithReference &&
                          (t = Math.max(d[e], l[e])),
                        _({}, e, t)
                      );
                    },
                    secondary: function(e) {
                      var t = "right" === e ? "left" : "top",
                        i = d[t];
                      return (
                        d[e] > l[e] &&
                          !n.escapeWithReference &&
                          (i = Math.min(
                            d[t],
                            l[e] - ("right" === e ? d.width : d.height)
                          )),
                        _({}, t, i)
                      );
                    }
                  };
                return (
                  c.forEach(function(e) {
                    var t =
                      -1 !== ["left", "top"].indexOf(e) ? "primary" : "secondary";
                    d = k({}, d, u[t](e));
                  }),
                  (e.offsets.popper = d),
                  e
                );
              },
              priority: ["left", "right", "top", "bottom"],
              padding: 5,
              boundariesElement: "scrollParent"
            },
            keepTogether: {
              order: 400,
              enabled: !0,
              fn: function(e) {
                var t = e.offsets,
                  i = t.popper,
                  n = t.reference,
                  o = e.placement.split("-")[0],
                  r = Math.floor,
                  s = -1 !== ["top", "bottom"].indexOf(o),
                  a = s ? "right" : "bottom",
                  l = s ? "left" : "top",
                  c = s ? "width" : "height";
                return (
                  i[a] < r(n[l]) && (e.offsets.popper[l] = r(n[l]) - i[c]),
                  i[l] > r(n[a]) && (e.offsets.popper[l] = r(n[a])),
                  e
                );
              }
            },
            arrow: {
              order: 500,
              enabled: !0,
              fn: function(e, t) {
                var i;
                if (!z(e.instance.modifiers, "arrow", "keepTogether")) return e;
                var n = t.element;
                if ("string" == typeof n) {
                  if (!(n = e.instance.popper.querySelector(n))) return e;
                } else if (!e.instance.popper.contains(n))
                  return (
                    console.warn(
                      "WARNING: `arrow.element` must be child of its popper element!"
                    ),
                    e
                  );
                var o = e.placement.split("-")[0],
                  r = e.offsets,
                  s = r.popper,
                  a = r.reference,
                  l = -1 !== ["left", "right"].indexOf(o),
                  c = l ? "height" : "width",
                  d = l ? "Top" : "Left",
                  u = d.toLowerCase(),
                  p = l ? "left" : "top",
                  h = l ? "bottom" : "right",
                  f = E(n)[c];
                a[h] - f < s[u] && (e.offsets.popper[u] -= s[u] - (a[h] - f)),
                  a[u] + f > s[h] && (e.offsets.popper[u] += a[u] + f - s[h]),
                  (e.offsets.popper = $(e.offsets.popper));
                var g = a[u] + a[c] / 2 - f / 2,
                  m = b(e.instance.popper),
                  v = parseFloat(m["margin" + d], 10),
                  y = parseFloat(m["border" + d + "Width"], 10),
                  w = g - e.offsets.popper[u] - v - y;
                return (
                  (w = Math.max(Math.min(s[c] - f, w), 0)),
                  (e.arrowElement = n),
                  (e.offsets.arrow =
                    (_((i = {}), u, Math.round(w)), _(i, p, ""), i)),
                  e
                );
              },
              element: "[x-arrow]"
            },
            flip: {
              order: 600,
              enabled: !0,
              fn: function(h, f) {
                if (D(h.instance.modifiers, "inner")) return h;
                if (h.flipped && h.placement === h.originalPlacement) return h;
                var g = p(
                    h.instance.popper,
                    h.instance.reference,
                    f.padding,
                    f.boundariesElement,
                    h.positionFixed
                  ),
                  m = h.placement.split("-")[0],
                  v = O(m),
                  y = h.placement.split("-")[1] || "",
                  w = [];
                switch (f.behavior) {
                  case W:
                    w = [m, v];
                    break;
                  case Y:
                    w = B(m);
                    break;
                  case Q:
                    w = B(m, !0);
                    break;
                  default:
                    w = f.behavior;
                }
                return (
                  w.forEach(function(e, t) {
                    if (m !== e || w.length === t + 1) return h;
                    (m = h.placement.split("-")[0]), (v = O(m));
                    var i = h.offsets.popper,
                      n = h.offsets.reference,
                      o = Math.floor,
                      r =
                        ("left" === m && o(i.right) > o(n.left)) ||
                        ("right" === m && o(i.left) < o(n.right)) ||
                        ("top" === m && o(i.bottom) > o(n.top)) ||
                        ("bottom" === m && o(i.top) < o(n.bottom)),
                      s = o(i.left) < o(g.left),
                      a = o(i.right) > o(g.right),
                      l = o(i.top) < o(g.top),
                      c = o(i.bottom) > o(g.bottom),
                      d =
                        ("left" === m && s) ||
                        ("right" === m && a) ||
                        ("top" === m && l) ||
                        ("bottom" === m && c),
                      u = -1 !== ["top", "bottom"].indexOf(m),
                      p =
                        !!f.flipVariations &&
                        ((u && "start" === y && s) ||
                          (u && "end" === y && a) ||
                          (!u && "start" === y && l) ||
                          (!u && "end" === y && c));
                    (r || d || p) &&
                      ((h.flipped = !0),
                      (r || d) && (m = w[t + 1]),
                      p &&
                        (y = (function(e) {
                          return "end" === e
                            ? "start"
                            : "start" === e
                            ? "end"
                            : e;
                        })(y)),
                      (h.placement = m + (y ? "-" + y : "")),
                      (h.offsets.popper = k(
                        {},
                        h.offsets.popper,
                        I(h.instance.popper, h.offsets.reference, h.placement)
                      )),
                      (h = j(h.instance.modifiers, h, "flip")));
                  }),
                  h
                );
              },
              behavior: "flip",
              padding: 5,
              boundariesElement: "viewport"
            },
            inner: {
              order: 700,
              enabled: !1,
              fn: function(e) {
                var t = e.placement,
                  i = t.split("-")[0],
                  n = e.offsets,
                  o = n.popper,
                  r = n.reference,
                  s = -1 !== ["left", "right"].indexOf(i),
                  a = -1 === ["top", "left"].indexOf(i);
                return (
                  (o[s ? "left" : "top"] =
                    r[i] - (a ? o[s ? "width" : "height"] : 0)),
                  (e.placement = O(t)),
                  (e.offsets.popper = $(o)),
                  e
                );
              }
            },
            hide: {
              order: 800,
              enabled: !0,
              fn: function(e) {
                if (!z(e.instance.modifiers, "hide", "preventOverflow")) return e;
                var t = e.offsets.reference,
                  i = L(e.instance.modifiers, function(e) {
                    return "preventOverflow" === e.name;
                  }).boundaries;
                if (
                  t.bottom < i.top ||
                  t.left > i.right ||
                  t.top > i.bottom ||
                  t.right < i.left
                ) {
                  if (!0 === e.hide) return e;
                  (e.hide = !0), (e.attributes["x-out-of-boundaries"] = "");
                } else {
                  if (!1 === e.hide) return e;
                  (e.hide = !1), (e.attributes["x-out-of-boundaries"] = !1);
                }
                return e;
              }
            },
            computeStyle: {
              order: 850,
              enabled: !0,
              fn: function(e, t) {
                var i = t.x,
                  n = t.y,
                  o = e.offsets.popper,
                  r = L(e.instance.modifiers, function(e) {
                    return "applyStyle" === e.name;
                  }).gpuAcceleration;
                void 0 !== r &&
                  console.warn(
                    "WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!"
                  );
                var s = void 0 !== r ? r : t.gpuAcceleration,
                  a = w(e.instance.popper),
                  l = S(a),
                  c = { position: o.position },
                  d = {
                    left: Math.floor(o.left),
                    top: Math.round(o.top),
                    bottom: Math.round(o.bottom),
                    right: Math.floor(o.right)
                  },
                  u = "bottom" === i ? "top" : "bottom",
                  p = "right" === n ? "left" : "right",
                  h = P("transform"),
                  f = void 0,
                  g = void 0;
                if (
                  ((g =
                    "bottom" == u
                      ? "HTML" === a.nodeName
                        ? -a.clientHeight + d.bottom
                        : -l.height + d.bottom
                      : d.top),
                  (f =
                    "right" == p
                      ? "HTML" === a.nodeName
                        ? -a.clientWidth + d.right
                        : -l.width + d.right
                      : d.left),
                  s && h)
                )
                  (c[h] = "translate3d(" + f + "px, " + g + "px, 0)"),
                    (c[u] = 0),
                    (c[p] = 0),
                    (c.willChange = "transform");
                else {
                  var m = "bottom" == u ? -1 : 1,
                    v = "right" == p ? -1 : 1;
                  (c[u] = g * m), (c[p] = f * v), (c.willChange = u + ", " + p);
                }
                var y = { "x-placement": e.placement };
                return (
                  (e.attributes = k({}, y, e.attributes)),
                  (e.styles = k({}, c, e.styles)),
                  (e.arrowStyles = k({}, e.offsets.arrow, e.arrowStyles)),
                  e
                );
              },
              gpuAcceleration: !0,
              x: "bottom",
              y: "right"
            },
            applyStyle: {
              order: 900,
              enabled: !0,
              fn: function(e) {
                return (
                  R(e.instance.popper, e.styles),
                  (function(t, i) {
                    Object.keys(i).forEach(function(e) {
                      !1 !== i[e]
                        ? t.setAttribute(e, i[e])
                        : t.removeAttribute(e);
                    });
                  })(e.instance.popper, e.attributes),
                  e.arrowElement &&
                    Object.keys(e.arrowStyles).length &&
                    R(e.arrowElement, e.arrowStyles),
                  e
                );
              },
              onLoad: function(e, t, i, n, o) {
                var r = A(o, t, e, i.positionFixed),
                  s = x(
                    i.placement,
                    r,
                    t,
                    e,
                    i.modifiers.flip.boundariesElement,
                    i.modifiers.flip.padding
                  );
                return (
                  t.setAttribute("x-placement", s),
                  R(t, { position: i.positionFixed ? "fixed" : "absolute" }),
                  i
                );
              },
              gpuAcceleration: void 0
            }
          }
        },
        X = (function() {
          function r(e, t) {
            var i = this,
              n =
                2 < arguments.length && void 0 !== arguments[2]
                  ? arguments[2]
                  : {};
            !(function(e, t) {
              if (!(e instanceof t))
                throw new TypeError("Cannot call a class as a function");
            })(this, r),
              (this.scheduleUpdate = function() {
                return requestAnimationFrame(i.update);
              }),
              (this.update = s(this.update.bind(this))),
              (this.options = k({}, r.Defaults, n)),
              (this.state = {
                isDestroyed: !1,
                isCreated: !1,
                scrollParents: []
              }),
              (this.reference = e && e.jquery ? e[0] : e),
              (this.popper = t && t.jquery ? t[0] : t),
              (this.options.modifiers = {}),
              Object.keys(k({}, r.Defaults.modifiers, n.modifiers)).forEach(
                function(e) {
                  i.options.modifiers[e] = k(
                    {},
                    r.Defaults.modifiers[e] || {},
                    n.modifiers ? n.modifiers[e] : {}
                  );
                }
              ),
              (this.modifiers = Object.keys(this.options.modifiers)
                .map(function(e) {
                  return k({ name: e }, i.options.modifiers[e]);
                })
                .sort(function(e, t) {
                  return e.order - t.order;
                })),
              this.modifiers.forEach(function(e) {
                e.enabled &&
                  a(e.onLoad) &&
                  e.onLoad(i.reference, i.popper, i.options, e, i.state);
              }),
              this.update();
            var o = this.options.eventsEnabled;
            o && this.enableEventListeners(), (this.state.eventsEnabled = o);
          }
          return (
            d(r, [
              {
                key: "update",
                value: function() {
                  return function() {
                    if (!this.state.isDestroyed) {
                      var e = {
                        instance: this,
                        styles: {},
                        arrowStyles: {},
                        attributes: {},
                        flipped: !1,
                        offsets: {}
                      };
                      (e.offsets.reference = A(
                        this.state,
                        this.popper,
                        this.reference,
                        this.options.positionFixed
                      )),
                        (e.placement = x(
                          this.options.placement,
                          e.offsets.reference,
                          this.popper,
                          this.reference,
                          this.options.modifiers.flip.boundariesElement,
                          this.options.modifiers.flip.padding
                        )),
                        (e.originalPlacement = e.placement),
                        (e.positionFixed = this.options.positionFixed),
                        (e.offsets.popper = I(
                          this.popper,
                          e.offsets.reference,
                          e.placement
                        )),
                        (e.offsets.popper.position = this.options.positionFixed
                          ? "fixed"
                          : "absolute"),
                        (e = j(this.modifiers, e)),
                        this.state.isCreated
                          ? this.options.onUpdate(e)
                          : ((this.state.isCreated = !0),
                            this.options.onCreate(e));
                    }
                  }.call(this);
                }
              },
              {
                key: "destroy",
                value: function() {
                  return function() {
                    return (
                      (this.state.isDestroyed = !0),
                      D(this.modifiers, "applyStyle") &&
                        (this.popper.removeAttribute("x-placement"),
                        (this.popper.style.position = ""),
                        (this.popper.style.top = ""),
                        (this.popper.style.left = ""),
                        (this.popper.style.right = ""),
                        (this.popper.style.bottom = ""),
                        (this.popper.style.willChange = ""),
                        (this.popper.style[P("transform")] = "")),
                      this.disableEventListeners(),
                      this.options.removeOnDestroy &&
                        this.popper.parentNode.removeChild(this.popper),
                      this
                    );
                  }.call(this);
                }
              },
              {
                key: "enableEventListeners",
                value: function() {
                  return function() {
                    this.state.eventsEnabled ||
                      (this.state = q(
                        this.reference,
                        this.options,
                        this.state,
                        this.scheduleUpdate
                      ));
                  }.call(this);
                }
              },
              {
                key: "disableEventListeners",
                value: function() {
                  return H.call(this);
                }
              }
            ]),
            r
          );
        })();
      return (
        (X.Utils = ("undefined" != typeof window ? window : global).PopperUtils),
        (X.placements = U),
        (X.Defaults = G),
        X
      );
    }),
    (function(e) {
      "use strict";
      var l,
        t = Object.prototype,
        c = t.hasOwnProperty,
        i = "function" == typeof Symbol ? Symbol : {},
        o = i.iterator || "@@iterator",
        n = i.asyncIterator || "@@asyncIterator",
        r = i.toStringTag || "@@toStringTag",
        s = "object" == typeof module,
        a = e.regeneratorRuntime;
      if (a) s && (module.exports = a);
      else {
        (a = e.regeneratorRuntime = s ? module.exports : {}).wrap = w;
        var d = "suspendedStart",
          u = "suspendedYield",
          p = "executing",
          h = "completed",
          f = {},
          g = {};
        g[o] = function() {
          return this;
        };
        var m = Object.getPrototypeOf,
          v = m && m(m(O([])));
        v && v !== t && c.call(v, o) && (g = v);
        var y = ($.prototype = _.prototype = Object.create(g));
        (k.prototype = y.constructor = $),
          ($.constructor = k),
          ($[r] = k.displayName = "GeneratorFunction"),
          (a.isGeneratorFunction = function(e) {
            var t = "function" == typeof e && e.constructor;
            return (
              !!t &&
              (t === k || "GeneratorFunction" === (t.displayName || t.name))
            );
          }),
          (a.mark = function(e) {
            return (
              Object.setPrototypeOf
                ? Object.setPrototypeOf(e, $)
                : ((e.__proto__ = $), r in e || (e[r] = "GeneratorFunction")),
              (e.prototype = Object.create(y)),
              e
            );
          }),
          (a.awrap = function(e) {
            return { __await: e };
          }),
          S(T.prototype),
          (T.prototype[n] = function() {
            return this;
          }),
          (a.AsyncIterator = T),
          (a.async = function(e, t, i, n) {
            var o = new T(w(e, t, i, n));
            return a.isGeneratorFunction(t)
              ? o
              : o.next().then(function(e) {
                  return e.done ? e.value : o.next();
                });
          }),
          S(y),
          (y[r] = "Generator"),
          (y[o] = function() {
            return this;
          }),
          (y.toString = function() {
            return "[object Generator]";
          }),
          (a.keys = function(i) {
            var n = [];
            for (var e in i) n.push(e);
            return (
              n.reverse(),
              function e() {
                for (; n.length; ) {
                  var t = n.pop();
                  if (t in i) return (e.value = t), (e.done = !1), e;
                }
                return (e.done = !0), e;
              }
            );
          }),
          (a.values = O),
          (E.prototype = {
            constructor: E,
            reset: function(e) {
              if (
                ((this.prev = 0),
                (this.next = 0),
                (this.sent = this._sent = l),
                (this.done = !1),
                (this.delegate = null),
                (this.method = "next"),
                (this.arg = l),
                this.tryEntries.forEach(A),
                !e)
              )
                for (var t in this)
                  "t" === t.charAt(0) &&
                    c.call(this, t) &&
                    !isNaN(+t.slice(1)) &&
                    (this[t] = l);
            },
            stop: function() {
              this.done = !0;
              var e = this.tryEntries[0].completion;
              if ("throw" === e.type) throw e.arg;
              return this.rval;
            },
            dispatchException: function(i) {
              if (this.done) throw i;
              var n = this;
              function e(e, t) {
                return (
                  (r.type = "throw"),
                  (r.arg = i),
                  (n.next = e),
                  t && ((n.method = "next"), (n.arg = l)),
                  !!t
                );
              }
              for (var t = this.tryEntries.length - 1; 0 <= t; --t) {
                var o = this.tryEntries[t],
                  r = o.completion;
                if ("root" === o.tryLoc) return e("end");
                if (o.tryLoc <= this.prev) {
                  var s = c.call(o, "catchLoc"),
                    a = c.call(o, "finallyLoc");
                  if (s && a) {
                    if (this.prev < o.catchLoc) return e(o.catchLoc, !0);
                    if (this.prev < o.finallyLoc) return e(o.finallyLoc);
                  } else if (s) {
                    if (this.prev < o.catchLoc) return e(o.catchLoc, !0);
                  } else {
                    if (!a)
                      throw new Error("try statement without catch or finally");
                    if (this.prev < o.finallyLoc) return e(o.finallyLoc);
                  }
                }
              }
            },
            abrupt: function(e, t) {
              for (var i = this.tryEntries.length - 1; 0 <= i; --i) {
                var n = this.tryEntries[i];
                if (
                  n.tryLoc <= this.prev &&
                  c.call(n, "finallyLoc") &&
                  this.prev < n.finallyLoc
                ) {
                  var o = n;
                  break;
                }
              }
              o &&
                ("break" === e || "continue" === e) &&
                o.tryLoc <= t &&
                t <= o.finallyLoc &&
                (o = null);
              var r = o ? o.completion : {};
              return (
                (r.type = e),
                (r.arg = t),
                o
                  ? ((this.method = "next"), (this.next = o.finallyLoc), f)
                  : this.complete(r)
              );
            },
            complete: function(e, t) {
              if ("throw" === e.type) throw e.arg;
              return (
                "break" === e.type || "continue" === e.type
                  ? (this.next = e.arg)
                  : "return" === e.type
                  ? ((this.rval = this.arg = e.arg),
                    (this.method = "return"),
                    (this.next = "end"))
                  : "normal" === e.type && t && (this.next = t),
                f
              );
            },
            finish: function(e) {
              for (var t = this.tryEntries.length - 1; 0 <= t; --t) {
                var i = this.tryEntries[t];
                if (i.finallyLoc === e)
                  return this.complete(i.completion, i.afterLoc), A(i), f;
              }
            },
            catch: function(e) {
              for (var t = this.tryEntries.length - 1; 0 <= t; --t) {
                var i = this.tryEntries[t];
                if (i.tryLoc === e) {
                  var n = i.completion;
                  if ("throw" === n.type) {
                    var o = n.arg;
                    A(i);
                  }
                  return o;
                }
              }
              throw new Error("illegal catch attempt");
            },
            delegateYield: function(e, t, i) {
              return (
                (this.delegate = { iterator: O(e), resultName: t, nextLoc: i }),
                "next" === this.method && (this.arg = l),
                f
              );
            }
          });
      }
      function w(e, t, i, n) {
        var o = t && t.prototype instanceof _ ? t : _,
          r = Object.create(o.prototype),
          s = new E(n || []);
        return (
          (r._invoke = (function(r, s, a) {
            var l = d;
            return function(e, t) {
              if (l === p) throw new Error("Generator is already running");
              if (l === h) {
                if ("throw" === e) throw t;
                return I();
              }
              for (a.method = e, a.arg = t; ; ) {
                var i = a.delegate;
                if (i) {
                  var n = C(i, a);
                  if (n) {
                    if (n === f) continue;
                    return n;
                  }
                }
                if ("next" === a.method) a.sent = a._sent = a.arg;
                else if ("throw" === a.method) {
                  if (l === d) throw ((l = h), a.arg);
                  a.dispatchException(a.arg);
                } else "return" === a.method && a.abrupt("return", a.arg);
                l = p;
                var o = b(r, s, a);
                if ("normal" === o.type) {
                  if (((l = a.done ? h : u), o.arg === f)) continue;
                  return { value: o.arg, done: a.done };
                }
                "throw" === o.type &&
                  ((l = h), (a.method = "throw"), (a.arg = o.arg));
              }
            };
          })(e, i, s)),
          r
        );
      }
      function b(e, t, i) {
        try {
          return { type: "normal", arg: e.call(t, i) };
        } catch (e) {
          return { type: "throw", arg: e };
        }
      }
      function _() {}
      function k() {}
      function $() {}
      function S(e) {
        ["next", "throw", "return"].forEach(function(t) {
          e[t] = function(e) {
            return this._invoke(t, e);
          };
        });
      }
      function T(l) {
        var t;
        this._invoke = function(i, n) {
          function e() {
            return new Promise(function(e, t) {
              !(function t(e, i, n, o) {
                var r = b(l[e], l, i);
                if ("throw" !== r.type) {
                  var s = r.arg,
                    a = s.value;
                  return a && "object" == typeof a && c.call(a, "__await")
                    ? Promise.resolve(a.__await).then(
                        function(e) {
                          t("next", e, n, o);
                        },
                        function(e) {
                          t("throw", e, n, o);
                        }
                      )
                    : Promise.resolve(a).then(function(e) {
                        (s.value = e), n(s);
                      }, o);
                }
                o(r.arg);
              })(i, n, e, t);
            });
          }
          return (t = t ? t.then(e, e) : e());
        };
      }
      function C(e, t) {
        var i = e.iterator[t.method];
        if (i === l) {
          if (((t.delegate = null), "throw" === t.method)) {
            if (
              e.iterator.return &&
              ((t.method = "return"), (t.arg = l), C(e, t), "throw" === t.method)
            )
              return f;
            (t.method = "throw"),
              (t.arg = new TypeError(
                "The iterator does not provide a 'throw' method"
              ));
          }
          return f;
        }
        var n = b(i, e.iterator, t.arg);
        if ("throw" === n.type)
          return (t.method = "throw"), (t.arg = n.arg), (t.delegate = null), f;
        var o = n.arg;
        return o
          ? o.done
            ? ((t[e.resultName] = o.value),
              (t.next = e.nextLoc),
              "return" !== t.method && ((t.method = "next"), (t.arg = l)),
              (t.delegate = null),
              f)
            : o
          : ((t.method = "throw"),
            (t.arg = new TypeError("iterator result is not an object")),
            (t.delegate = null),
            f);
      }
      function x(e) {
        var t = { tryLoc: e[0] };
        1 in e && (t.catchLoc = e[1]),
          2 in e && ((t.finallyLoc = e[2]), (t.afterLoc = e[3])),
          this.tryEntries.push(t);
      }
      function A(e) {
        var t = e.completion || {};
        (t.type = "normal"), delete t.arg, (e.completion = t);
      }
      function E(e) {
        (this.tryEntries = [{ tryLoc: "root" }]),
          e.forEach(x, this),
          this.reset(!0);
      }
      function O(t) {
        if (t) {
          var e = t[o];
          if (e) return e.call(t);
          if ("function" == typeof t.next) return t;
          if (!isNaN(t.length)) {
            var i = -1,
              n = function e() {
                for (; ++i < t.length; )
                  if (c.call(t, i)) return (e.value = t[i]), (e.done = !1), e;
                return (e.value = l), (e.done = !0), e;
              };
            return (n.next = n);
          }
        }
        return { next: I };
      }
      function I() {
        return { value: l, done: !0 };
      }
    })(
      (function() {
        return this;
      })() || Function("return this")()
    ),
    (function(i) {
      "function" == typeof define && define.amd
        ? define(["jquery"], i)
        : "object" == typeof module && module.exports
        ? (module.exports = function(e, t) {
            return (
              void 0 === t &&
                (t =
                  "undefined" != typeof window
                    ? require("jquery")
                    : require("jquery")(e)),
              i(t),
              t
            );
          })
        : i(jQuery);
    })(function(n) {
      var e = (function() {
          if (n && n.fn && n.fn.select2 && n.fn.select2.amd)
            var e = n.fn.select2.amd;
          var t, o, c, i;
          return (
            (e && e.requirejs) ||
              (e ? (o = e) : (e = {}),
              (function(h) {
                var r,
                  s,
                  f,
                  g,
                  m = {},
                  v = {},
                  y = {},
                  w = {},
                  i = Object.prototype.hasOwnProperty,
                  n = [].slice,
                  b = /\.js$/;
                function _(e, t) {
                  return i.call(e, t);
                }
                function a(e, t) {
                  var i,
                    n,
                    o,
                    r,
                    s,
                    a,
                    l,
                    c,
                    d,
                    u,
                    p,
                    h = t && t.split("/"),
                    f = y.map,
                    g = (f && f["*"]) || {};
                  if (e) {
                    for (
                      s = (e = e.split("/")).length - 1,
                        y.nodeIdCompat &&
                          b.test(e[s]) &&
                          (e[s] = e[s].replace(b, "")),
                        "." === e[0].charAt(0) &&
                          h &&
                          (e = h.slice(0, h.length - 1).concat(e)),
                        d = 0;
                      d < e.length;
                      d++
                    )
                      if ("." === (p = e[d])) e.splice(d, 1), (d -= 1);
                      else if (".." === p) {
                        if (
                          0 === d ||
                          (1 === d && ".." === e[2]) ||
                          ".." === e[d - 1]
                        )
                          continue;
                        0 < d && (e.splice(d - 1, 2), (d -= 2));
                      }
                    e = e.join("/");
                  }
                  if ((h || g) && f) {
                    for (d = (i = e.split("/")).length; 0 < d; d -= 1) {
                      if (((n = i.slice(0, d).join("/")), h))
                        for (u = h.length; 0 < u; u -= 1)
                          if ((o = f[h.slice(0, u).join("/")]) && (o = o[n])) {
                            (r = o), (a = d);
                            break;
                          }
                      if (r) break;
                      !l && g && g[n] && ((l = g[n]), (c = d));
                    }
                    !r && l && ((r = l), (a = c)),
                      r && (i.splice(0, a, r), (e = i.join("/")));
                  }
                  return e;
                }
                function k(t, i) {
                  return function() {
                    var e = n.call(arguments, 0);
                    return (
                      "string" != typeof e[0] && 1 === e.length && e.push(null),
                      s.apply(h, e.concat([t, i]))
                    );
                  };
                }
                function $(t) {
                  return function(e) {
                    m[t] = e;
                  };
                }
                function S(e) {
                  if (_(v, e)) {
                    var t = v[e];
                    delete v[e], (w[e] = !0), r.apply(h, t);
                  }
                  if (!_(m, e) && !_(w, e)) throw new Error("No " + e);
                  return m[e];
                }
                function l(e) {
                  var t,
                    i = e ? e.indexOf("!") : -1;
                  return (
                    -1 < i &&
                      ((t = e.substring(0, i)),
                      (e = e.substring(i + 1, e.length))),
                    [t, e]
                  );
                }
                function T(e) {
                  return e ? l(e) : [];
                }
                (f = function(e, t) {
                  var i,
                    n = l(e),
                    o = n[0],
                    r = t[1];
                  return (
                    (e = n[1]),
                    o && (i = S((o = a(o, r)))),
                    o
                      ? (e =
                          i && i.normalize
                            ? i.normalize(
                                e,
                                (function(t) {
                                  return function(e) {
                                    return a(e, t);
                                  };
                                })(r)
                              )
                            : a(e, r))
                      : ((o = (n = l((e = a(e, r))))[0]),
                        (e = n[1]),
                        o && (i = S(o))),
                    { f: o ? o + "!" + e : e, n: e, pr: o, p: i }
                  );
                }),
                  (g = {
                    require: function(e) {
                      return k(e);
                    },
                    exports: function(e) {
                      var t = m[e];
                      return void 0 !== t ? t : (m[e] = {});
                    },
                    module: function(e) {
                      return {
                        id: e,
                        uri: "",
                        exports: m[e],
                        config: (function(e) {
                          return function() {
                            return (y && y.config && y.config[e]) || {};
                          };
                        })(e)
                      };
                    }
                  }),
                  (r = function(e, t, i, n) {
                    var o,
                      r,
                      s,
                      a,
                      l,
                      c,
                      d,
                      u = [],
                      p = typeof i;
                    if (
                      ((c = T((n = n || e))), "undefined" == p || "function" == p)
                    ) {
                      for (
                        t =
                          !t.length && i.length
                            ? ["require", "exports", "module"]
                            : t,
                          l = 0;
                        l < t.length;
                        l += 1
                      )
                        if ("require" === (r = (a = f(t[l], c)).f))
                          u[l] = g.require(e);
                        else if ("exports" === r) (u[l] = g.exports(e)), (d = !0);
                        else if ("module" === r) o = u[l] = g.module(e);
                        else if (_(m, r) || _(v, r) || _(w, r)) u[l] = S(r);
                        else {
                          if (!a.p) throw new Error(e + " missing " + r);
                          a.p.load(a.n, k(n, !0), $(r), {}), (u[l] = m[r]);
                        }
                      (s = i ? i.apply(m[e], u) : void 0),
                        e &&
                          (o && o.exports !== h && o.exports !== m[e]
                            ? (m[e] = o.exports)
                            : (s === h && d) || (m[e] = s));
                    } else e && (m[e] = i);
                  }),
                  (t = o = s = function(e, t, i, n, o) {
                    if ("string" == typeof e)
                      return g[e] ? g[e](t) : S(f(e, T(t)).f);
                    if (!e.splice) {
                      if (((y = e).deps && s(y.deps, y.callback), !t)) return;
                      t.splice ? ((e = t), (t = i), (i = null)) : (e = h);
                    }
                    return (
                      (t = t || function() {}),
                      "function" == typeof i && ((i = n), (n = o)),
                      n
                        ? r(h, e, t, i)
                        : setTimeout(function() {
                            r(h, e, t, i);
                          }, 4),
                      s
                    );
                  }),
                  (s.config = function(e) {
                    return s(e);
                  }),
                  (t._defined = m),
                  ((c = function(e, t, i) {
                    if ("string" != typeof e)
                      throw new Error(
                        "See almond README: incorrect module build, no module name"
                      );
                    t.splice || ((i = t), (t = [])),
                      _(m, e) || _(v, e) || (v[e] = [e, t, i]);
                  }).amd = { jQuery: !0 });
              })(),
              (e.requirejs = t),
              (e.require = o),
              (e.define = c)),
            e.define("almond", function() {}),
            e.define("jquery", [], function() {
              var e = n || $;
              return (
                null == e &&
                  console &&
                  console.error &&
                  console.error(
                    "Select2: An instance of jQuery or a jQuery-compatible library was not found. Make sure that you are including jQuery before Select2 on your web page."
                  ),
                e
              );
            }),
            e.define("select2/utils", ["jquery"], function(r) {
              var e = {};
              function d(e) {
                var t = e.prototype,
                  i = [];
                for (var n in t) {
                  "function" == typeof t[n] && ("constructor" !== n && i.push(n));
                }
                return i;
              }
              (e.Extend = function(e, t) {
                var i = {}.hasOwnProperty;
                function n() {
                  this.constructor = e;
                }
                for (var o in t) i.call(t, o) && (e[o] = t[o]);
                return (
                  (n.prototype = t.prototype),
                  (e.prototype = new n()),
                  (e.__super__ = t.prototype),
                  e
                );
              }),
                (e.Decorate = function(n, o) {
                  var e = d(o),
                    t = d(n);
                  function r() {
                    var e = Array.prototype.unshift,
                      t = o.prototype.constructor.length,
                      i = n.prototype.constructor;
                    0 < t &&
                      (e.call(arguments, n.prototype.constructor),
                      (i = o.prototype.constructor)),
                      i.apply(this, arguments);
                  }
                  (o.displayName = n.displayName),
                    (r.prototype = new (function() {
                      this.constructor = r;
                    })());
                  for (var i = 0; i < t.length; i++) {
                    var s = t[i];
                    r.prototype[s] = n.prototype[s];
                  }
                  function a(e) {
                    var t = function() {};
                    e in r.prototype && (t = r.prototype[e]);
                    var i = o.prototype[e];
                    return function() {
                      return (
                        Array.prototype.unshift.call(arguments, t),
                        i.apply(this, arguments)
                      );
                    };
                  }
                  for (var l = 0; l < e.length; l++) {
                    var c = e[l];
                    r.prototype[c] = a(c);
                  }
                  return r;
                });
              function t() {
                this.listeners = {};
              }
              return (
                (t.prototype.on = function(e, t) {
                  (this.listeners = this.listeners || {}),
                    e in this.listeners
                      ? this.listeners[e].push(t)
                      : (this.listeners[e] = [t]);
                }),
                (t.prototype.trigger = function(e) {
                  var t = Array.prototype.slice,
                    i = t.call(arguments, 1);
                  (this.listeners = this.listeners || {}),
                    null == i && (i = []),
                    0 === i.length && i.push({}),
                    (i[0]._type = e) in this.listeners &&
                      this.invoke(this.listeners[e], t.call(arguments, 1)),
                    "*" in this.listeners &&
                      this.invoke(this.listeners["*"], arguments);
                }),
                (t.prototype.invoke = function(e, t) {
                  for (var i = 0, n = e.length; i < n; i++) e[i].apply(this, t);
                }),
                (e.Observable = t),
                (e.generateChars = function(e) {
                  for (var t = "", i = 0; i < e; i++) {
                    t += Math.floor(36 * Math.random()).toString(36);
                  }
                  return t;
                }),
                (e.bind = function(e, t) {
                  return function() {
                    e.apply(t, arguments);
                  };
                }),
                (e._convertData = function(e) {
                  for (var t in e) {
                    var i = t.split("-"),
                      n = e;
                    if (1 !== i.length) {
                      for (var o = 0; o < i.length; o++) {
                        var r = i[o];
                        (r = r.substring(0, 1).toLowerCase() + r.substring(1)) in
                          n || (n[r] = {}),
                          o == i.length - 1 && (n[r] = e[t]),
                          (n = n[r]);
                      }
                      delete e[t];
                    }
                  }
                  return e;
                }),
                (e.hasScroll = function(e, t) {
                  var i = r(t),
                    n = t.style.overflowX,
                    o = t.style.overflowY;
                  return (
                    (n !== o || ("hidden" !== o && "visible" !== o)) &&
                    ("scroll" === n ||
                      "scroll" === o ||
                      (i.innerHeight() < t.scrollHeight ||
                        i.innerWidth() < t.scrollWidth))
                  );
                }),
                (e.escapeMarkup = function(e) {
                  var t = {
                    "\\": "&#92;",
                    "&": "&amp;",
                    "<": "&lt;",
                    ">": "&gt;",
                    '"': "&quot;",
                    "'": "&#39;",
                    "/": "&#47;"
                  };
                  return "string" != typeof e
                    ? e
                    : String(e).replace(/[&<>"'\/\\]/g, function(e) {
                        return t[e];
                      });
                }),
                (e.appendMany = function(e, t) {
                  if ("1.7" === r.fn.jquery.substr(0, 3)) {
                    var i = r();
                    r.map(t, function(e) {
                      i = i.add(e);
                    }),
                      (t = i);
                  }
                  e.append(t);
                }),
                e
              );
            }),
            e.define("select2/results", ["jquery", "./utils"], function(p, e) {
              function n(e, t, i) {
                (this.$element = e),
                  (this.data = i),
                  (this.options = t),
                  n.__super__.constructor.call(this);
              }
              return (
                e.Extend(n, e.Observable),
                (n.prototype.render = function() {
                  var e = p(
                    '<ul class="select2-results__options" role="tree"></ul>'
                  );
                  return (
                    this.options.get("multiple") &&
                      e.attr("aria-multiselectable", "true"),
                    (this.$results = e)
                  );
                }),
                (n.prototype.clear = function() {
                  this.$results.empty();
                }),
                (n.prototype.displayMessage = function(e) {
                  var t = this.options.get("escapeMarkup");
                  this.clear(), this.hideLoading();
                  var i = p(
                      '<li role="treeitem" aria-live="assertive" class="select2-results__option"></li>'
                    ),
                    n = this.options.get("translations").get(e.message);
                  i.append(t(n(e.args))),
                    (i[0].className += " select2-results__message"),
                    this.$results.append(i);
                }),
                (n.prototype.hideMessages = function() {
                  this.$results.find(".select2-results__message").remove();
                }),
                (n.prototype.append = function(e) {
                  this.hideLoading();
                  var t = [];
                  if (null != e.results && 0 !== e.results.length) {
                    e.results = this.sort(e.results);
                    for (var i = 0; i < e.results.length; i++) {
                      var n = e.results[i],
                        o = this.option(n);
                      t.push(o);
                    }
                    this.$results.append(t);
                  } else
                    0 === this.$results.children().length &&
                      this.trigger("results:message", { message: "noResults" });
                }),
                (n.prototype.position = function(e, t) {
                  t.find(".select2-results").append(e);
                }),
                (n.prototype.sort = function(e) {
                  return this.options.get("sorter")(e);
                }),
                (n.prototype.highlightFirstItem = function() {
                  var e = this.$results.find(
                      ".select2-results__option[aria-selected]"
                    ),
                    t = e.filter("[aria-selected=true]");
                  0 < t.length
                    ? t.first().trigger("mouseenter")
                    : e.first().trigger("mouseenter"),
                    this.ensureHighlightVisible();
                }),
                (n.prototype.setClasses = function() {
                  var t = this;
                  this.data.current(function(e) {
                    var n = p.map(e, function(e) {
                      return e.id.toString();
                    });
                    t.$results
                      .find(".select2-results__option[aria-selected]")
                      .each(function() {
                        var e = p(this),
                          t = p.data(this, "data"),
                          i = "" + t.id;
                        (null != t.element && t.element.selected) ||
                        (null == t.element && -1 < p.inArray(i, n))
                          ? e.attr("aria-selected", "true")
                          : e.attr("aria-selected", "false");
                      });
                  });
                }),
                (n.prototype.showLoading = function(e) {
                  this.hideLoading();
                  var t = {
                      disabled: !0,
                      loading: !0,
                      text: this.options.get("translations").get("searching")(e)
                    },
                    i = this.option(t);
                  (i.className += " loading-results"), this.$results.prepend(i);
                }),
                (n.prototype.hideLoading = function() {
                  this.$results.find(".loading-results").remove();
                }),
                (n.prototype.option = function(e) {
                  var t = document.createElement("li");
                  t.className = "select2-results__option";
                  var i = { role: "treeitem", "aria-selected": "false" };
                  for (var n in (e.disabled &&
                    (delete i["aria-selected"], (i["aria-disabled"] = "true")),
                  null == e.id && delete i["aria-selected"],
                  null != e._resultId && (t.id = e._resultId),
                  e.title && (t.title = e.title),
                  e.children &&
                    ((i.role = "group"),
                    (i["aria-label"] = e.text),
                    delete i["aria-selected"]),
                  i)) {
                    var o = i[n];
                    t.setAttribute(n, o);
                  }
                  if (e.children) {
                    var r = p(t),
                      s = document.createElement("strong");
                    s.className = "select2-results__group";
                    p(s);
                    this.template(e, s);
                    for (var a = [], l = 0; l < e.children.length; l++) {
                      var c = e.children[l],
                        d = this.option(c);
                      a.push(d);
                    }
                    var u = p("<ul></ul>", {
                      class:
                        "select2-results__options select2-results__options--nested"
                    });
                    u.append(a), r.append(s), r.append(u);
                  } else this.template(e, t);
                  return p.data(t, "data", e), t;
                }),
                (n.prototype.bind = function(t, e) {
                  var l = this,
                    i = t.id + "-results";
                  this.$results.attr("id", i),
                    t.on("results:all", function(e) {
                      l.clear(),
                        l.append(e.data),
                        t.isOpen() && (l.setClasses(), l.highlightFirstItem());
                    }),
                    t.on("results:append", function(e) {
                      l.append(e.data), t.isOpen() && l.setClasses();
                    }),
                    t.on("query", function(e) {
                      l.hideMessages(), l.showLoading(e);
                    }),
                    t.on("select", function() {
                      t.isOpen() && (l.setClasses(), l.highlightFirstItem());
                    }),
                    t.on("unselect", function() {
                      t.isOpen() && (l.setClasses(), l.highlightFirstItem());
                    }),
                    t.on("open", function() {
                      l.$results.attr("aria-expanded", "true"),
                        l.$results.attr("aria-hidden", "false"),
                        l.setClasses(),
                        l.ensureHighlightVisible();
                    }),
                    t.on("close", function() {
                      l.$results.attr("aria-expanded", "false"),
                        l.$results.attr("aria-hidden", "true"),
                        l.$results.removeAttr("aria-activedescendant");
                    }),
                    t.on("results:toggle", function() {
                      var e = l.getHighlightedResults();
                      0 !== e.length && e.trigger("mouseup");
                    }),
                    t.on("results:select", function() {
                      var e = l.getHighlightedResults();
                      if (0 !== e.length) {
                        var t = e.data("data");
                        "true" == e.attr("aria-selected")
                          ? l.trigger("close", {})
                          : l.trigger("select", { data: t });
                      }
                    }),
                    t.on("results:previous", function() {
                      var e = l.getHighlightedResults(),
                        t = l.$results.find("[aria-selected]"),
                        i = t.index(e);
                      if (0 !== i) {
                        var n = i - 1;
                        0 === e.length && (n = 0);
                        var o = t.eq(n);
                        o.trigger("mouseenter");
                        var r = l.$results.offset().top,
                          s = o.offset().top,
                          a = l.$results.scrollTop() + (s - r);
                        0 === n
                          ? l.$results.scrollTop(0)
                          : s - r < 0 && l.$results.scrollTop(a);
                      }
                    }),
                    t.on("results:next", function() {
                      var e = l.getHighlightedResults(),
                        t = l.$results.find("[aria-selected]"),
                        i = t.index(e) + 1;
                      if (!(i >= t.length)) {
                        var n = t.eq(i);
                        n.trigger("mouseenter");
                        var o =
                            l.$results.offset().top + l.$results.outerHeight(!1),
                          r = n.offset().top + n.outerHeight(!1),
                          s = l.$results.scrollTop() + r - o;
                        0 === i
                          ? l.$results.scrollTop(0)
                          : o < r && l.$results.scrollTop(s);
                      }
                    }),
                    t.on("results:focus", function(e) {
                      e.element.addClass("select2-results__option--highlighted");
                    }),
                    t.on("results:message", function(e) {
                      l.displayMessage(e);
                    }),
                    p.fn.mousewheel &&
                      this.$results.on("mousewheel", function(e) {
                        var t = l.$results.scrollTop(),
                          i = l.$results.get(0).scrollHeight - t + e.deltaY,
                          n = 0 < e.deltaY && t - e.deltaY <= 0,
                          o = e.deltaY < 0 && i <= l.$results.height();
                        n
                          ? (l.$results.scrollTop(0),
                            e.preventDefault(),
                            e.stopPropagation())
                          : o &&
                            (l.$results.scrollTop(
                              l.$results.get(0).scrollHeight - l.$results.height()
                            ),
                            e.preventDefault(),
                            e.stopPropagation());
                      }),
                    this.$results.on(
                      "mouseup",
                      ".select2-results__option[aria-selected]",
                      function(e) {
                        var t = p(this),
                          i = t.data("data");
                        "true" !== t.attr("aria-selected")
                          ? l.trigger("select", { originalEvent: e, data: i })
                          : l.options.get("multiple")
                          ? l.trigger("unselect", { originalEvent: e, data: i })
                          : l.trigger("close", {});
                      }
                    ),
                    this.$results.on(
                      "mouseenter",
                      ".select2-results__option[aria-selected]",
                      function(e) {
                        var t = p(this).data("data");
                        l
                          .getHighlightedResults()
                          .removeClass("select2-results__option--highlighted"),
                          l.trigger("results:focus", {
                            data: t,
                            element: p(this)
                          });
                      }
                    );
                }),
                (n.prototype.getHighlightedResults = function() {
                  return this.$results.find(
                    ".select2-results__option--highlighted"
                  );
                }),
                (n.prototype.destroy = function() {
                  this.$results.remove();
                }),
                (n.prototype.ensureHighlightVisible = function() {
                  var e = this.getHighlightedResults();
                  if (0 !== e.length) {
                    var t = this.$results.find("[aria-selected]").index(e),
                      i = this.$results.offset().top,
                      n = e.offset().top,
                      o = this.$results.scrollTop() + (n - i),
                      r = n - i;
                    (o -= 2 * e.outerHeight(!1)),
                      t <= 2
                        ? this.$results.scrollTop(0)
                        : (r > this.$results.outerHeight() || r < 0) &&
                          this.$results.scrollTop(o);
                  }
                }),
                (n.prototype.template = function(e, t) {
                  var i = this.options.get("templateResult"),
                    n = this.options.get("escapeMarkup"),
                    o = i(e, t);
                  null == o
                    ? (t.style.display = "none")
                    : "string" == typeof o
                    ? (t.innerHTML = n(o))
                    : p(t).append(o);
                }),
                n
              );
            }),
            e.define("select2/keys", [], function() {
              return {
                BACKSPACE: 8,
                TAB: 9,
                ENTER: 13,
                SHIFT: 16,
                CTRL: 17,
                ALT: 18,
                ESC: 27,
                SPACE: 32,
                PAGE_UP: 33,
                PAGE_DOWN: 34,
                END: 35,
                HOME: 36,
                LEFT: 37,
                UP: 38,
                RIGHT: 39,
                DOWN: 40,
                DELETE: 46
              };
            }),
            e.define(
              "select2/selection/base",
              ["jquery", "../utils", "../keys"],
              function(i, e, o) {
                function n(e, t) {
                  (this.$element = e),
                    (this.options = t),
                    n.__super__.constructor.call(this);
                }
                return (
                  e.Extend(n, e.Observable),
                  (n.prototype.render = function() {
                    var e = i(
                      '<span class="select2-selection" role="combobox"  aria-haspopup="true" aria-expanded="false"></span>'
                    );
                    return (
                      (this._tabindex = 0),
                      null != this.$element.data("old-tabindex")
                        ? (this._tabindex = this.$element.data("old-tabindex"))
                        : null != this.$element.attr("tabindex") &&
                          (this._tabindex = this.$element.attr("tabindex")),
                      e.attr("title", this.$element.attr("title")),
                      e.attr("tabindex", this._tabindex),
                      (this.$selection = e)
                    );
                  }),
                  (n.prototype.bind = function(e, t) {
                    var i = this,
                      n = (e.id, e.id + "-results");
                    (this.container = e),
                      this.$selection.on("focus", function(e) {
                        i.trigger("focus", e);
                      }),
                      this.$selection.on("blur", function(e) {
                        i._handleBlur(e);
                      }),
                      this.$selection.on("keydown", function(e) {
                        i.trigger("keypress", e),
                          e.which === o.SPACE && e.preventDefault();
                      }),
                      e.on("results:focus", function(e) {
                        i.$selection.attr(
                          "aria-activedescendant",
                          e.data._resultId
                        );
                      }),
                      e.on("selection:update", function(e) {
                        i.update(e.data);
                      }),
                      e.on("open", function() {
                        i.$selection.attr("aria-expanded", "true"),
                          i.$selection.attr("aria-owns", n),
                          i._attachCloseHandler(e);
                      }),
                      e.on("close", function() {
                        i.$selection.attr("aria-expanded", "false"),
                          i.$selection.removeAttr("aria-activedescendant"),
                          i.$selection.removeAttr("aria-owns"),
                          i.$selection.focus(),
                          i._detachCloseHandler(e);
                      }),
                      e.on("enable", function() {
                        i.$selection.attr("tabindex", i._tabindex);
                      }),
                      e.on("disable", function() {
                        i.$selection.attr("tabindex", "-1");
                      });
                  }),
                  (n.prototype._handleBlur = function(e) {
                    var t = this;
                    window.setTimeout(function() {
                      document.activeElement == t.$selection[0] ||
                        i.contains(t.$selection[0], document.activeElement) ||
                        t.trigger("blur", e);
                    }, 1);
                  }),
                  (n.prototype._attachCloseHandler = function(e) {
                    i(document.body).on("mousedown.select2." + e.id, function(e) {
                      var t = i(e.target).closest(".select2");
                      i(".select2.select2-container--open").each(function() {
                        var e = i(this);
                        this != t[0] && e.data("element").select2("close");
                      });
                    });
                  }),
                  (n.prototype._detachCloseHandler = function(e) {
                    i(document.body).off("mousedown.select2." + e.id);
                  }),
                  (n.prototype.position = function(e, t) {
                    t.find(".selection").append(e);
                  }),
                  (n.prototype.destroy = function() {
                    this._detachCloseHandler(this.container);
                  }),
                  (n.prototype.update = function(e) {
                    throw new Error(
                      "The `update` method must be defined in child classes."
                    );
                  }),
                  n
                );
              }
            ),
            e.define(
              "select2/selection/single",
              ["jquery", "./base", "../utils", "../keys"],
              function(e, t, i, n) {
                function o() {
                  o.__super__.constructor.apply(this, arguments);
                }
                return (
                  i.Extend(o, t),
                  (o.prototype.render = function() {
                    var e = o.__super__.render.call(this);
                    return (
                      e.addClass("select2-selection--single"),
                      e.html(
                        '<span class="select2-selection__rendered"></span><span class="select2-selection__arrow" role="presentation"><b role="presentation"></b></span>'
                      ),
                      e
                    );
                  }),
                  (o.prototype.bind = function(t, e) {
                    var i = this;
                    o.__super__.bind.apply(this, arguments);
                    var n = t.id + "-container";
                    this.$selection
                      .find(".select2-selection__rendered")
                      .attr("id", n),
                      this.$selection.attr("aria-labelledby", n),
                      this.$selection.on("mousedown", function(e) {
                        1 === e.which &&
                          i.trigger("toggle", { originalEvent: e });
                      }),
                      this.$selection.on("focus", function(e) {}),
                      this.$selection.on("blur", function(e) {}),
                      t.on("focus", function(e) {
                        t.isOpen() || i.$selection.focus();
                      }),
                      t.on("selection:update", function(e) {
                        i.update(e.data);
                      });
                  }),
                  (o.prototype.clear = function() {
                    this.$selection.find(".select2-selection__rendered").empty();
                  }),
                  (o.prototype.display = function(e, t) {
                    var i = this.options.get("templateSelection");
                    return this.options.get("escapeMarkup")(i(e, t));
                  }),
                  (o.prototype.selectionContainer = function() {
                    return e("<span></span>");
                  }),
                  (o.prototype.update = function(e) {
                    if (0 !== e.length) {
                      var t = e[0],
                        i = this.$selection.find(".select2-selection__rendered"),
                        n = this.display(t, i);
                      i.empty().append(n), i.prop("title", t.title || t.text);
                    } else this.clear();
                  }),
                  o
                );
              }
            ),
            e.define(
              "select2/selection/multiple",
              ["jquery", "./base", "../utils"],
              function(n, e, a) {
                function o(e, t) {
                  o.__super__.constructor.apply(this, arguments);
                }
                return (
                  a.Extend(o, e),
                  (o.prototype.render = function() {
                    var e = o.__super__.render.call(this);
                    return (
                      e.addClass("select2-selection--multiple"),
                      e.html('<ul class="select2-selection__rendered"></ul>'),
                      e
                    );
                  }),
                  (o.prototype.bind = function(e, t) {
                    var i = this;
                    o.__super__.bind.apply(this, arguments),
                      this.$selection.on("click", function(e) {
                        i.trigger("toggle", { originalEvent: e });
                      }),
                      this.$selection.on(
                        "click",
                        ".select2-selection__choice__remove",
                        function(e) {
                          if (!i.options.get("disabled")) {
                            var t = n(this)
                              .parent()
                              .data("data");
                            i.trigger("unselect", { originalEvent: e, data: t });
                          }
                        }
                      );
                  }),
                  (o.prototype.clear = function() {
                    this.$selection.find(".select2-selection__rendered").empty();
                  }),
                  (o.prototype.display = function(e, t) {
                    var i = this.options.get("templateSelection");
                    return this.options.get("escapeMarkup")(i(e, t));
                  }),
                  (o.prototype.selectionContainer = function() {
                    return n(
                      '<li class="select2-selection__choice"><span class="select2-selection__choice__remove" role="presentation">&times;</span></li>'
                    );
                  }),
                  (o.prototype.update = function(e) {
                    if ((this.clear(), 0 !== e.length)) {
                      for (var t = [], i = 0; i < e.length; i++) {
                        var n = e[i],
                          o = this.selectionContainer(),
                          r = this.display(n, o);
                        o.append(r),
                          o.prop("title", n.title || n.text),
                          o.data("data", n),
                          t.push(o);
                      }
                      var s = this.$selection.find(
                        ".select2-selection__rendered"
                      );
                      a.appendMany(s, t);
                    }
                  }),
                  o
                );
              }
            ),
            e.define("select2/selection/placeholder", ["../utils"], function(e) {
              function t(e, t, i) {
                (this.placeholder = this.normalizePlaceholder(
                  i.get("placeholder")
                )),
                  e.call(this, t, i);
              }
              return (
                (t.prototype.normalizePlaceholder = function(e, t) {
                  return "string" == typeof t && (t = { id: "", text: t }), t;
                }),
                (t.prototype.createPlaceholder = function(e, t) {
                  var i = this.selectionContainer();
                  return (
                    i.html(this.display(t)),
                    i
                      .addClass("select2-selection__placeholder")
                      .removeClass("select2-selection__choice"),
                    i
                  );
                }),
                (t.prototype.update = function(e, t) {
                  var i = 1 == t.length && t[0].id != this.placeholder.id;
                  if (1 < t.length || i) return e.call(this, t);
                  this.clear();
                  var n = this.createPlaceholder(this.placeholder);
                  this.$selection.find(".select2-selection__rendered").append(n);
                }),
                t
              );
            }),
            e.define(
              "select2/selection/allowClear",
              ["jquery", "../keys"],
              function(n, o) {
                function e() {}
                return (
                  (e.prototype.bind = function(e, t, i) {
                    var n = this;
                    e.call(this, t, i),
                      null == this.placeholder &&
                        this.options.get("debug") &&
                        window.console &&
                        console.error &&
                        console.error(
                          "Select2: The `allowClear` option should be used in combination with the `placeholder` option."
                        ),
                      this.$selection.on(
                        "mousedown",
                        ".select2-selection__clear",
                        function(e) {
                          n._handleClear(e);
                        }
                      ),
                      t.on("keypress", function(e) {
                        n._handleKeyboardClear(e, t);
                      });
                  }),
                  (e.prototype._handleClear = function(e, t) {
                    if (!this.options.get("disabled")) {
                      var i = this.$selection.find(".select2-selection__clear");
                      if (0 !== i.length) {
                        t.stopPropagation();
                        for (var n = i.data("data"), o = 0; o < n.length; o++) {
                          var r = { data: n[o] };
                          if ((this.trigger("unselect", r), r.prevented)) return;
                        }
                        this.$element.val(this.placeholder.id).trigger("change"),
                          this.trigger("toggle", {});
                      }
                    }
                  }),
                  (e.prototype._handleKeyboardClear = function(e, t, i) {
                    i.isOpen() ||
                      (t.which != o.DELETE && t.which != o.BACKSPACE) ||
                      this._handleClear(t);
                  }),
                  (e.prototype.update = function(e, t) {
                    if (
                      (e.call(this, t),
                      !(
                        0 <
                          this.$selection.find(".select2-selection__placeholder")
                            .length || 0 === t.length
                      ))
                    ) {
                      var i = n(
                        '<span class="select2-selection__clear">&times;</span>'
                      );
                      i.data("data", t),
                        this.$selection
                          .find(".select2-selection__rendered")
                          .prepend(i);
                    }
                  }),
                  e
                );
              }
            ),
            e.define(
              "select2/selection/search",
              ["jquery", "../utils", "../keys"],
              function(n, e, s) {
                function t(e, t, i) {
                  e.call(this, t, i);
                }
                return (
                  (t.prototype.render = function(e) {
                    var t = n(
                      '<li class="select2-search select2-search--inline"><input class="select2-search__field" type="search" tabindex="-1" autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false" role="textbox" aria-autocomplete="list" /></li>'
                    );
                    (this.$searchContainer = t), (this.$search = t.find("input"));
                    var i = e.call(this);
                    return this._transferTabIndex(), i;
                  }),
                  (t.prototype.bind = function(e, t, i) {
                    var n = this;
                    e.call(this, t, i),
                      t.on("open", function() {
                        n.$search.trigger("focus");
                      }),
                      t.on("close", function() {
                        n.$search.val(""),
                          n.$search.removeAttr("aria-activedescendant"),
                          n.$search.trigger("focus");
                      }),
                      t.on("enable", function() {
                        n.$search.prop("disabled", !1), n._transferTabIndex();
                      }),
                      t.on("disable", function() {
                        n.$search.prop("disabled", !0);
                      }),
                      t.on("focus", function(e) {
                        n.$search.trigger("focus");
                      }),
                      t.on("results:focus", function(e) {
                        n.$search.attr("aria-activedescendant", e.id);
                      }),
                      this.$selection.on(
                        "focusin",
                        ".select2-search--inline",
                        function(e) {
                          n.trigger("focus", e);
                        }
                      ),
                      this.$selection.on(
                        "focusout",
                        ".select2-search--inline",
                        function(e) {
                          n._handleBlur(e);
                        }
                      ),
                      this.$selection.on(
                        "keydown",
                        ".select2-search--inline",
                        function(e) {
                          if (
                            (e.stopPropagation(),
                            n.trigger("keypress", e),
                            (n._keyUpPrevented = e.isDefaultPrevented()),
                            e.which === s.BACKSPACE && "" === n.$search.val())
                          ) {
                            var t = n.$searchContainer.prev(
                              ".select2-selection__choice"
                            );
                            if (0 < t.length) {
                              var i = t.data("data");
                              n.searchRemoveChoice(i), e.preventDefault();
                            }
                          }
                        }
                      );
                    var o = document.documentMode,
                      r = o && o <= 11;
                    this.$selection.on(
                      "input.searchcheck",
                      ".select2-search--inline",
                      function(e) {
                        r
                          ? n.$selection.off("input.search input.searchcheck")
                          : n.$selection.off("keyup.search");
                      }
                    ),
                      this.$selection.on(
                        "keyup.search input.search",
                        ".select2-search--inline",
                        function(e) {
                          if (r && "input" === e.type)
                            n.$selection.off("input.search input.searchcheck");
                          else {
                            var t = e.which;
                            t != s.SHIFT &&
                              t != s.CTRL &&
                              t != s.ALT &&
                              t != s.TAB &&
                              n.handleSearch(e);
                          }
                        }
                      );
                  }),
                  (t.prototype._transferTabIndex = function(e) {
                    this.$search.attr(
                      "tabindex",
                      this.$selection.attr("tabindex")
                    ),
                      this.$selection.attr("tabindex", "-1");
                  }),
                  (t.prototype.createPlaceholder = function(e, t) {
                    this.$search.attr("placeholder", t.text);
                  }),
                  (t.prototype.update = function(e, t) {
                    var i = this.$search[0] == document.activeElement;
                    this.$search.attr("placeholder", ""),
                      e.call(this, t),
                      this.$selection
                        .find(".select2-selection__rendered")
                        .append(this.$searchContainer),
                      this.resizeSearch(),
                      i && this.$search.focus();
                  }),
                  (t.prototype.handleSearch = function() {
                    if ((this.resizeSearch(), !this._keyUpPrevented)) {
                      var e = this.$search.val();
                      this.trigger("query", { term: e });
                    }
                    this._keyUpPrevented = !1;
                  }),
                  (t.prototype.searchRemoveChoice = function(e, t) {
                    this.trigger("unselect", { data: t }),
                      this.$search.val(t.text),
                      this.handleSearch();
                  }),
                  (t.prototype.resizeSearch = function() {
                    this.$search.css("width", "25px");
                    var e = "";
                    "" !== this.$search.attr("placeholder")
                      ? (e = this.$selection
                          .find(".select2-selection__rendered")
                          .innerWidth())
                      : (e = 0.75 * (this.$search.val().length + 1) + "em");
                    this.$search.css("width", e);
                  }),
                  t
                );
              }
            ),
            e.define("select2/selection/eventRelay", ["jquery"], function(s) {
              function e() {}
              return (
                (e.prototype.bind = function(e, t, i) {
                  var n = this,
                    o = [
                      "open",
                      "opening",
                      "close",
                      "closing",
                      "select",
                      "selecting",
                      "unselect",
                      "unselecting"
                    ],
                    r = ["opening", "closing", "selecting", "unselecting"];
                  e.call(this, t, i),
                    t.on("*", function(e, t) {
                      if (-1 !== s.inArray(e, o)) {
                        t = t || {};
                        var i = s.Event("select2:" + e, { params: t });
                        n.$element.trigger(i),
                          -1 !== s.inArray(e, r) &&
                            (t.prevented = i.isDefaultPrevented());
                      }
                    });
                }),
                e
              );
            }),
            e.define("select2/translation", ["jquery", "require"], function(
              t,
              i
            ) {
              function n(e) {
                this.dict = e || {};
              }
              return (
                (n.prototype.all = function() {
                  return this.dict;
                }),
                (n.prototype.get = function(e) {
                  return this.dict[e];
                }),
                (n.prototype.extend = function(e) {
                  this.dict = t.extend({}, e.all(), this.dict);
                }),
                (n._cache = {}),
                (n.loadPath = function(e) {
                  if (!(e in n._cache)) {
                    var t = i(e);
                    n._cache[e] = t;
                  }
                  return new n(n._cache[e]);
                }),
                n
              );
            }),
            e.define("select2/diacritics", [], function() {
              var ua = window.navigator.userAgent;
              if (ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1){
                return "";
              }
              return {
                "Ⓐ": "A",
                Ａ: "A",
                À: "A",
                Á: "A",
                Â: "A",
                Ầ: "A",
                Ấ: "A",
                Ẫ: "A",
                Ẩ: "A",
                Ã: "A",
                Ā: "A",
                Ă: "A",
                Ằ: "A",
                Ắ: "A",
                Ẵ: "A",
                Ẳ: "A",
                Ȧ: "A",
                Ǡ: "A",
                Ä: "A",
                Ǟ: "A",
                Ả: "A",
                Å: "A",
                Ǻ: "A",
                Ǎ: "A",
                Ȁ: "A",
                Ȃ: "A",
                Ạ: "A",
                Ậ: "A",
                Ặ: "A",
                Ḁ: "A",
                Ą: "A",
                Ⱥ: "A",
                Ɐ: "A",
                Ꜳ: "AA",
                Æ: "AE",
                Ǽ: "AE",
                Ǣ: "AE",
                Ꜵ: "AO",
                Ꜷ: "AU",
                Ꜹ: "AV",
                Ꜻ: "AV",
                Ꜽ: "AY",
                "Ⓑ": "B",
                Ｂ: "B",
                Ḃ: "B",
                Ḅ: "B",
                Ḇ: "B",
                Ƀ: "B",
                Ƃ: "B",
                Ɓ: "B",
                "Ⓒ": "C",
                Ｃ: "C",
                Ć: "C",
                Ĉ: "C",
                Ċ: "C",
                Č: "C",
                Ç: "C",
                Ḉ: "C",
                Ƈ: "C",
                Ȼ: "C",
                Ꜿ: "C",
                "Ⓓ": "D",
                Ｄ: "D",
                Ḋ: "D",
                Ď: "D",
                Ḍ: "D",
                Ḑ: "D",
                Ḓ: "D",
                Ḏ: "D",
                Đ: "D",
                Ƌ: "D",
                Ɗ: "D",
                Ɖ: "D",
                Ꝺ: "D",
                Ǳ: "DZ",
                Ǆ: "DZ",
                ǲ: "Dz",
                ǅ: "Dz",
                "Ⓔ": "E",
                Ｅ: "E",
                È: "E",
                É: "E",
                Ê: "E",
                Ề: "E",
                Ế: "E",
                Ễ: "E",
                Ể: "E",
                Ẽ: "E",
                Ē: "E",
                Ḕ: "E",
                Ḗ: "E",
                Ĕ: "E",
                Ė: "E",
                Ë: "E",
                Ẻ: "E",
                Ě: "E",
                Ȅ: "E",
                Ȇ: "E",
                Ẹ: "E",
                Ệ: "E",
                Ȩ: "E",
                Ḝ: "E",
                Ę: "E",
                Ḙ: "E",
                Ḛ: "E",
                Ɛ: "E",
                Ǝ: "E",
                "Ⓕ": "F",
                Ｆ: "F",
                Ḟ: "F",
                Ƒ: "F",
                Ꝼ: "F",
                "Ⓖ": "G",
                Ｇ: "G",
                Ǵ: "G",
                Ĝ: "G",
                Ḡ: "G",
                Ğ: "G",
                Ġ: "G",
                Ǧ: "G",
                Ģ: "G",
                Ǥ: "G",
                Ɠ: "G",
                "Ꞡ": "G",
                Ᵹ: "G",
                Ꝿ: "G",
                "Ⓗ": "H",
                Ｈ: "H",
                Ĥ: "H",
                Ḣ: "H",
                Ḧ: "H",
                Ȟ: "H",
                Ḥ: "H",
                Ḩ: "H",
                Ḫ: "H",
                Ħ: "H",
                Ⱨ: "H",
                Ⱶ: "H",
                "Ɥ": "H",
                "Ⓘ": "I",
                Ｉ: "I",
                Ì: "I",
                Í: "I",
                Î: "I",
                Ĩ: "I",
                Ī: "I",
                Ĭ: "I",
                İ: "I",
                Ï: "I",
                Ḯ: "I",
                Ỉ: "I",
                Ǐ: "I",
                Ȉ: "I",
                Ȋ: "I",
                Ị: "I",
                Į: "I",
                Ḭ: "I",
                Ɨ: "I",
                "Ⓙ": "J",
                Ｊ: "J",
                Ĵ: "J",
                Ɉ: "J",
                "Ⓚ": "K",
                Ｋ: "K",
                Ḱ: "K",
                Ǩ: "K",
                Ḳ: "K",
                Ķ: "K",
                Ḵ: "K",
                Ƙ: "K",
                Ⱪ: "K",
                Ꝁ: "K",
                Ꝃ: "K",
                Ꝅ: "K",
                "Ꞣ": "K",
                "Ⓛ": "L",
                Ｌ: "L",
                Ŀ: "L",
                Ĺ: "L",
                Ľ: "L",
                Ḷ: "L",
                Ḹ: "L",
                Ļ: "L",
                Ḽ: "L",
                Ḻ: "L",
                Ł: "L",
                Ƚ: "L",
                Ɫ: "L",
                Ⱡ: "L",
                Ꝉ: "L",
                Ꝇ: "L",
                Ꞁ: "L",
                Ǉ: "LJ",
                ǈ: "Lj",
                "Ⓜ": "M",
                Ｍ: "M",
                Ḿ: "M",
                Ṁ: "M",
                Ṃ: "M",
                Ɱ: "M",
                Ɯ: "M",
                "Ⓝ": "N",
                Ｎ: "N",
                Ǹ: "N",
                Ń: "N",
                Ñ: "N",
                Ṅ: "N",
                Ň: "N",
                Ṇ: "N",
                Ņ: "N",
                Ṋ: "N",
                Ṉ: "N",
                Ƞ: "N",
                Ɲ: "N",
                "Ꞑ": "N",
                "Ꞥ": "N",
                Ǌ: "NJ",
                ǋ: "Nj",
                "Ⓞ": "O",
                Ｏ: "O",
                Ò: "O",
                Ó: "O",
                Ô: "O",
                Ồ: "O",
                Ố: "O",
                Ỗ: "O",
                Ổ: "O",
                Õ: "O",
                Ṍ: "O",
                Ȭ: "O",
                Ṏ: "O",
                Ō: "O",
                Ṑ: "O",
                Ṓ: "O",
                Ŏ: "O",
                Ȯ: "O",
                Ȱ: "O",
                Ö: "O",
                Ȫ: "O",
                Ỏ: "O",
                Ő: "O",
                Ǒ: "O",
                Ȍ: "O",
                Ȏ: "O",
                Ơ: "O",
                Ờ: "O",
                Ớ: "O",
                Ỡ: "O",
                Ở: "O",
                Ợ: "O",
                Ọ: "O",
                Ộ: "O",
                Ǫ: "O",
                Ǭ: "O",
                Ø: "O",
                Ǿ: "O",
                Ɔ: "O",
                Ɵ: "O",
                Ꝋ: "O",
                Ꝍ: "O",
                Ƣ: "OI",
                Ꝏ: "OO",
                Ȣ: "OU",
                "Ⓟ": "P",
                Ｐ: "P",
                Ṕ: "P",
                Ṗ: "P",
                Ƥ: "P",
                Ᵽ: "P",
                Ꝑ: "P",
                Ꝓ: "P",
                Ꝕ: "P",
                "Ⓠ": "Q",
                Ｑ: "Q",
                Ꝗ: "Q",
                Ꝙ: "Q",
                Ɋ: "Q",
                "Ⓡ": "R",
                Ｒ: "R",
                Ŕ: "R",
                Ṙ: "R",
                Ř: "R",
                Ȑ: "R",
                Ȓ: "R",
                Ṛ: "R",
                Ṝ: "R",
                Ŗ: "R",
                Ṟ: "R",
                Ɍ: "R",
                Ɽ: "R",
                Ꝛ: "R",
                "Ꞧ": "R",
                Ꞃ: "R",
                "Ⓢ": "S",
                Ｓ: "S",
                ẞ: "S",
                Ś: "S",
                Ṥ: "S",
                Ŝ: "S",
                Ṡ: "S",
                Š: "S",
                Ṧ: "S",
                Ṣ: "S",
                Ṩ: "S",
                Ș: "S",
                Ş: "S",
                "Ȿ": "S",
                "Ꞩ": "S",
                Ꞅ: "S",
                "Ⓣ": "T",
                Ｔ: "T",
                Ṫ: "T",
                Ť: "T",
                Ṭ: "T",
                Ț: "T",
                Ţ: "T",
                Ṱ: "T",
                Ṯ: "T",
                Ŧ: "T",
                Ƭ: "T",
                Ʈ: "T",
                Ⱦ: "T",
                Ꞇ: "T",
                Ꜩ: "TZ",
                "Ⓤ": "U",
                Ｕ: "U",
                Ù: "U",
                Ú: "U",
                Û: "U",
                Ũ: "U",
                Ṹ: "U",
                Ū: "U",
                Ṻ: "U",
                Ŭ: "U",
                Ü: "U",
                Ǜ: "U",
                Ǘ: "U",
                Ǖ: "U",
                Ǚ: "U",
                Ủ: "U",
                Ů: "U",
                Ű: "U",
                Ǔ: "U",
                Ȕ: "U",
                Ȗ: "U",
                Ư: "U",
                Ừ: "U",
                Ứ: "U",
                Ữ: "U",
                Ử: "U",
                Ự: "U",
                Ụ: "U",
                Ṳ: "U",
                Ų: "U",
                Ṷ: "U",
                Ṵ: "U",
                Ʉ: "U",
                "Ⓥ": "V",
                Ｖ: "V",
                Ṽ: "V",
                Ṿ: "V",
                Ʋ: "V",
                Ꝟ: "V",
                Ʌ: "V",
                Ꝡ: "VY",
                "Ⓦ": "W",
                Ｗ: "W",
                Ẁ: "W",
                Ẃ: "W",
                Ŵ: "W",
                Ẇ: "W",
                Ẅ: "W",
                Ẉ: "W",
                Ⱳ: "W",
                "Ⓧ": "X",
                Ｘ: "X",
                Ẋ: "X",
                Ẍ: "X",
                "Ⓨ": "Y",
                Ｙ: "Y",
                Ỳ: "Y",
                Ý: "Y",
                Ŷ: "Y",
                Ỹ: "Y",
                Ȳ: "Y",
                Ẏ: "Y",
                Ÿ: "Y",
                Ỷ: "Y",
                Ỵ: "Y",
                Ƴ: "Y",
                Ɏ: "Y",
                Ỿ: "Y",
                "Ⓩ": "Z",
                Ｚ: "Z",
                Ź: "Z",
                Ẑ: "Z",
                Ż: "Z",
                Ž: "Z",
                Ẓ: "Z",
                Ẕ: "Z",
                Ƶ: "Z",
                Ȥ: "Z",
                "Ɀ": "Z",
                Ⱬ: "Z",
                Ꝣ: "Z",
                "ⓐ": "a",
                ａ: "a",
                ẚ: "a",
                à: "a",
                á: "a",
                â: "a",
                ầ: "a",
                ấ: "a",
                ẫ: "a",
                ẩ: "a",
                ã: "a",
                ā: "a",
                ă: "a",
                ằ: "a",
                ắ: "a",
                ẵ: "a",
                ẳ: "a",
                ȧ: "a",
                ǡ: "a",
                ä: "a",
                ǟ: "a",
                ả: "a",
                å: "a",
                ǻ: "a",
                ǎ: "a",
                ȁ: "a",
                ȃ: "a",
                ạ: "a",
                ậ: "a",
                ặ: "a",
                ḁ: "a",
                ą: "a",
                ⱥ: "a",
                ɐ: "a",
                ꜳ: "aa",
                æ: "ae",
                ǽ: "ae",
                ǣ: "ae",
                ꜵ: "ao",
                ꜷ: "au",
                ꜹ: "av",
                ꜻ: "av",
                ꜽ: "ay",
                "ⓑ": "b",
                ｂ: "b",
                ḃ: "b",
                ḅ: "b",
                ḇ: "b",
                ƀ: "b",
                ƃ: "b",
                ɓ: "b",
                "ⓒ": "c",
                ｃ: "c",
                ć: "c",
                ĉ: "c",
                ċ: "c",
                č: "c",
                ç: "c",
                ḉ: "c",
                ƈ: "c",
                ȼ: "c",
                ꜿ: "c",
                ↄ: "c",
                "ⓓ": "d",
                ｄ: "d",
                ḋ: "d",
                ď: "d",
                ḍ: "d",
                ḑ: "d",
                ḓ: "d",
                ḏ: "d",
                đ: "d",
                ƌ: "d",
                ɖ: "d",
                ɗ: "d",
                ꝺ: "d",
                ǳ: "dz",
                ǆ: "dz",
                "ⓔ": "e",
                ｅ: "e",
                è: "e",
                é: "e",
                ê: "e",
                ề: "e",
                ế: "e",
                ễ: "e",
                ể: "e",
                ẽ: "e",
                ē: "e",
                ḕ: "e",
                ḗ: "e",
                ĕ: "e",
                ė: "e",
                ë: "e",
                ẻ: "e",
                ě: "e",
                ȅ: "e",
                ȇ: "e",
                ẹ: "e",
                ệ: "e",
                ȩ: "e",
                ḝ: "e",
                ę: "e",
                ḙ: "e",
                ḛ: "e",
                ɇ: "e",
                ɛ: "e",
                ǝ: "e",
                "ⓕ": "f",
                ｆ: "f",
                ḟ: "f",
                ƒ: "f",
                ꝼ: "f",
                "ⓖ": "g",
                ｇ: "g",
                ǵ: "g",
                ĝ: "g",
                ḡ: "g",
                ğ: "g",
                ġ: "g",
                ǧ: "g",
                ģ: "g",
                ǥ: "g",
                ɠ: "g",
                "ꞡ": "g",
                ᵹ: "g",
                ꝿ: "g",
                "ⓗ": "h",
                ｈ: "h",
                ĥ: "h",
                ḣ: "h",
                ḧ: "h",
                ȟ: "h",
                ḥ: "h",
                ḩ: "h",
                ḫ: "h",
                ẖ: "h",
                ħ: "h",
                ⱨ: "h",
                ⱶ: "h",
                ɥ: "h",
                ƕ: "hv",
                "ⓘ": "i",
                ｉ: "i",
                ì: "i",
                í: "i",
                î: "i",
                ĩ: "i",
                ī: "i",
                ĭ: "i",
                ï: "i",
                ḯ: "i",
                ỉ: "i",
                ǐ: "i",
                ȉ: "i",
                ȋ: "i",
                ị: "i",
                į: "i",
                ḭ: "i",
                ɨ: "i",
                ı: "i",
                "ⓙ": "j",
                ｊ: "j",
                ĵ: "j",
                ǰ: "j",
                ɉ: "j",
                "ⓚ": "k",
                ｋ: "k",
                ḱ: "k",
                ǩ: "k",
                ḳ: "k",
                ķ: "k",
                ḵ: "k",
                ƙ: "k",
                ⱪ: "k",
                ꝁ: "k",
                ꝃ: "k",
                ꝅ: "k",
                "ꞣ": "k",
                "ⓛ": "l",
                ｌ: "l",
                ŀ: "l",
                ĺ: "l",
                ľ: "l",
                ḷ: "l",
                ḹ: "l",
                ļ: "l",
                ḽ: "l",
                ḻ: "l",
                ſ: "l",
                ł: "l",
                ƚ: "l",
                ɫ: "l",
                ⱡ: "l",
                ꝉ: "l",
                ꞁ: "l",
                ꝇ: "l",
                ǉ: "lj",
                "ⓜ": "m",
                ｍ: "m",
                ḿ: "m",
                ṁ: "m",
                ṃ: "m",
                ɱ: "m",
                ɯ: "m",
                "ⓝ": "n",
                ｎ: "n",
                ǹ: "n",
                ń: "n",
                ñ: "n",
                ṅ: "n",
                ň: "n",
                ṇ: "n",
                ņ: "n",
                ṋ: "n",
                ṉ: "n",
                ƞ: "n",
                ɲ: "n",
                ŉ: "n",
                "ꞑ": "n",
                "ꞥ": "n",
                ǌ: "nj",
                "ⓞ": "o",
                ｏ: "o",
                ò: "o",
                ó: "o",
                ô: "o",
                ồ: "o",
                ố: "o",
                ỗ: "o",
                ổ: "o",
                õ: "o",
                ṍ: "o",
                ȭ: "o",
                ṏ: "o",
                ō: "o",
                ṑ: "o",
                ṓ: "o",
                ŏ: "o",
                ȯ: "o",
                ȱ: "o",
                ö: "o",
                ȫ: "o",
                ỏ: "o",
                ő: "o",
                ǒ: "o",
                ȍ: "o",
                ȏ: "o",
                ơ: "o",
                ờ: "o",
                ớ: "o",
                ỡ: "o",
                ở: "o",
                ợ: "o",
                ọ: "o",
                ộ: "o",
                ǫ: "o",
                ǭ: "o",
                ø: "o",
                ǿ: "o",
                ɔ: "o",
                ꝋ: "o",
                ꝍ: "o",
                ɵ: "o",
                ƣ: "oi",
                ȣ: "ou",
                ꝏ: "oo",
                "ⓟ": "p",
                ｐ: "p",
                ṕ: "p",
                ṗ: "p",
                ƥ: "p",
                ᵽ: "p",
                ꝑ: "p",
                ꝓ: "p",
                ꝕ: "p",
                "ⓠ": "q",
                ｑ: "q",
                ɋ: "q",
                ꝗ: "q",
                ꝙ: "q",
                "ⓡ": "r",
                ｒ: "r",
                ŕ: "r",
                ṙ: "r",
                ř: "r",
                ȑ: "r",
                ȓ: "r",
                ṛ: "r",
                ṝ: "r",
                ŗ: "r",
                ṟ: "r",
                ɍ: "r",
                ɽ: "r",
                ꝛ: "r",
                "ꞧ": "r",
                ꞃ: "r",
                "ⓢ": "s",
                ｓ: "s",
                ß: "s",
                ś: "s",
                ṥ: "s",
                ŝ: "s",
                ṡ: "s",
                š: "s",
                ṧ: "s",
                ṣ: "s",
                ṩ: "s",
                ș: "s",
                ş: "s",
                "ȿ": "s",
                "ꞩ": "s",
                ꞅ: "s",
                ẛ: "s",
                "ⓣ": "t",
                ｔ: "t",
                ṫ: "t",
                ẗ: "t",
                ť: "t",
                ṭ: "t",
                ț: "t",
                ţ: "t",
                ṱ: "t",
                ṯ: "t",
                ŧ: "t",
                ƭ: "t",
                ʈ: "t",
                ⱦ: "t",
                ꞇ: "t",
                ꜩ: "tz",
                "ⓤ": "u",
                ｕ: "u",
                ù: "u",
                ú: "u",
                û: "u",
                ũ: "u",
                ṹ: "u",
                ū: "u",
                ṻ: "u",
                ŭ: "u",
                ü: "u",
                ǜ: "u",
                ǘ: "u",
                ǖ: "u",
                ǚ: "u",
                ủ: "u",
                ů: "u",
                ű: "u",
                ǔ: "u",
                ȕ: "u",
                ȗ: "u",
                ư: "u",
                ừ: "u",
                ứ: "u",
                ữ: "u",
                ử: "u",
                ự: "u",
                ụ: "u",
                ṳ: "u",
                ų: "u",
                ṷ: "u",
                ṵ: "u",
                ʉ: "u",
                "ⓥ": "v",
                ｖ: "v",
                ṽ: "v",
                ṿ: "v",
                ʋ: "v",
                ꝟ: "v",
                ʌ: "v",
                ꝡ: "vy",
                "ⓦ": "w",
                ｗ: "w",
                ẁ: "w",
                ẃ: "w",
                ŵ: "w",
                ẇ: "w",
                ẅ: "w",
                ẘ: "w",
                ẉ: "w",
                ⱳ: "w",
                "ⓧ": "x",
                ｘ: "x",
                ẋ: "x",
                ẍ: "x",
                "ⓨ": "y",
                ｙ: "y",
                ỳ: "y",
                ý: "y",
                ŷ: "y",
                ỹ: "y",
                ȳ: "y",
                ẏ: "y",
                ÿ: "y",
                ỷ: "y",
                ẙ: "y",
                ỵ: "y",
                ƴ: "y",
                ɏ: "y",
                ỿ: "y",
                "ⓩ": "z",
                ｚ: "z",
                ź: "z",
                ẑ: "z",
                ż: "z",
                ž: "z",
                ẓ: "z",
                ẕ: "z",
                ƶ: "z",
                ȥ: "z",
                "ɀ": "z",
                ⱬ: "z",
                ꝣ: "z",
                Ά: "Α",
                Έ: "Ε",
                Ή: "Η",
                Ί: "Ι",
                Ϊ: "Ι",
                Ό: "Ο",
                Ύ: "Υ",
                Ϋ: "Υ",
                Ώ: "Ω",
                ά: "α",
                έ: "ε",
                ή: "η",
                ί: "ι",
                ϊ: "ι",
                ΐ: "ι",
                ό: "ο",
                ύ: "υ",
                ϋ: "υ",
                ΰ: "υ",
                ω: "ω",
                ς: "σ"
              };
            }),
            e.define("select2/data/base", ["../utils"], function(n) {
              function i(e, t) {
                i.__super__.constructor.call(this);
              }
              return (
                n.Extend(i, n.Observable),
                (i.prototype.current = function(e) {
                  throw new Error(
                    "The `current` method must be defined in child classes."
                  );
                }),
                (i.prototype.query = function(e, t) {
                  throw new Error(
                    "The `query` method must be defined in child classes."
                  );
                }),
                (i.prototype.bind = function(e, t) {}),
                (i.prototype.destroy = function() {}),
                (i.prototype.generateResultId = function(e, t) {
                  var i = e.id + "-result-";
                  return (
                    (i += n.generateChars(4)),
                    null != t.id
                      ? (i += "-" + t.id.toString())
                      : (i += "-" + n.generateChars(4)),
                    i
                  );
                }),
                i
              );
            }),
            e.define(
              "select2/data/select",
              ["./base", "../utils", "jquery"],
              function(e, t, a) {
                function i(e, t) {
                  (this.$element = e),
                    (this.options = t),
                    i.__super__.constructor.call(this);
                }
                return (
                  t.Extend(i, e),
                  (i.prototype.current = function(e) {
                    var i = [],
                      n = this;
                    this.$element.find(":selected").each(function() {
                      var e = a(this),
                        t = n.item(e);
                      i.push(t);
                    }),
                      e(i);
                  }),
                  (i.prototype.select = function(o) {
                    var r = this;
                    if (((o.selected = !0), a(o.element).is("option")))
                      return (
                        (o.element.selected = !0),
                        void this.$element.trigger("change")
                      );
                    if (this.$element.prop("multiple"))
                      this.current(function(e) {
                        var t = [];
                        (o = [o]).push.apply(o, e);
                        for (var i = 0; i < o.length; i++) {
                          var n = o[i].id;
                          -1 === a.inArray(n, t) && t.push(n);
                        }
                        r.$element.val(t), r.$element.trigger("change");
                      });
                    else {
                      var e = o.id;
                      this.$element.val(e), this.$element.trigger("change");
                    }
                  }),
                  (i.prototype.unselect = function(o) {
                    var r = this;
                    if (this.$element.prop("multiple")) {
                      if (((o.selected = !1), a(o.element).is("option")))
                        return (
                          (o.element.selected = !1),
                          void this.$element.trigger("change")
                        );
                      this.current(function(e) {
                        for (var t = [], i = 0; i < e.length; i++) {
                          var n = e[i].id;
                          n !== o.id && -1 === a.inArray(n, t) && t.push(n);
                        }
                        r.$element.val(t), r.$element.trigger("change");
                      });
                    }
                  }),
                  (i.prototype.bind = function(e, t) {
                    var i = this;
                    (this.container = e).on("select", function(e) {
                      i.select(e.data);
                    }),
                      e.on("unselect", function(e) {
                        i.unselect(e.data);
                      });
                  }),
                  (i.prototype.destroy = function() {
                    this.$element.find("*").each(function() {
                      a.removeData(this, "data");
                    });
                  }),
                  (i.prototype.query = function(n, e) {
                    var o = [],
                      r = this;
                    this.$element.children().each(function() {
                      var e = a(this);
                      if (e.is("option") || e.is("optgroup")) {
                        var t = r.item(e),
                          i = r.matches(n, t);
                        null !== i && o.push(i);
                      }
                    }),
                      e({ results: o });
                  }),
                  (i.prototype.addOptions = function(e) {
                    t.appendMany(this.$element, e);
                  }),
                  (i.prototype.option = function(e) {
                    var t;
                    e.children
                      ? ((t = document.createElement("optgroup")).label = e.text)
                      : void 0 !==
                        (t = document.createElement("option")).textContent
                      ? (t.textContent = e.text)
                      : (t.innerText = e.text),
                      void 0 !== e.id && (t.value = e.id),
                      e.disabled && (t.disabled = !0),
                      e.selected && (t.selected = !0),
                      e.title && (t.title = e.title);
                    var i = a(t),
                      n = this._normalizeItem(e);
                    return (n.element = t), a.data(t, "data", n), i;
                  }),
                  (i.prototype.item = function(e) {
                    var t = {};
                    if (null != (t = a.data(e[0], "data"))) return t;
                    if (e.is("option"))
                      t = {
                        id: e.val(),
                        text: e.text(),
                        disabled: e.prop("disabled"),
                        selected: e.prop("selected"),
                        title: e.prop("title")
                      };
                    else if (e.is("optgroup")) {
                      t = {
                        text: e.prop("label"),
                        children: [],
                        title: e.prop("title")
                      };
                      for (
                        var i = e.children("option"), n = [], o = 0;
                        o < i.length;
                        o++
                      ) {
                        var r = a(i[o]),
                          s = this.item(r);
                        n.push(s);
                      }
                      t.children = n;
                    }
                    return (
                      ((t = this._normalizeItem(t)).element = e[0]),
                      a.data(e[0], "data", t),
                      t
                    );
                  }),
                  (i.prototype._normalizeItem = function(e) {
                    a.isPlainObject(e) || (e = { id: e, text: e });
                    return (
                      null != (e = a.extend({}, { text: "" }, e)).id &&
                        (e.id = e.id.toString()),
                      null != e.text && (e.text = e.text.toString()),
                      null == e._resultId &&
                        e.id &&
                        null != this.container &&
                        (e._resultId = this.generateResultId(this.container, e)),
                      a.extend({}, { selected: !1, disabled: !1 }, e)
                    );
                  }),
                  (i.prototype.matches = function(e, t) {
                    return this.options.get("matcher")(e, t);
                  }),
                  i
                );
              }
            ),
            e.define(
              "select2/data/array",
              ["./select", "../utils", "jquery"],
              function(e, f, g) {
                function n(e, t) {
                  var i = t.get("data") || [];
                  n.__super__.constructor.call(this, e, t),
                    this.addOptions(this.convertToOptions(i));
                }
                return (
                  f.Extend(n, e),
                  (n.prototype.select = function(i) {
                    var e = this.$element.find("option").filter(function(e, t) {
                      return t.value == i.id.toString();
                    });
                    0 === e.length && ((e = this.option(i)), this.addOptions(e)),
                      n.__super__.select.call(this, i);
                  }),
                  (n.prototype.convertToOptions = function(e) {
                    var t = this,
                      i = this.$element.find("option"),
                      n = i
                        .map(function() {
                          return t.item(g(this)).id;
                        })
                        .get(),
                      o = [];
                    function r(e) {
                      return function() {
                        return g(this).val() == e.id;
                      };
                    }
                    for (var s = 0; s < e.length; s++) {
                      var a = this._normalizeItem(e[s]);
                      if (0 <= g.inArray(a.id, n)) {
                        var l = i.filter(r(a)),
                          c = this.item(l),
                          d = g.extend(!0, {}, a, c),
                          u = this.option(d);
                        l.replaceWith(u);
                      } else {
                        var p = this.option(a);
                        if (a.children) {
                          var h = this.convertToOptions(a.children);
                          f.appendMany(p, h);
                        }
                        o.push(p);
                      }
                    }
                    return o;
                  }),
                  n
                );
              }
            ),
            e.define(
              "select2/data/ajax",
              ["./array", "../utils", "jquery"],
              function(e, t, r) {
                function i(e, t) {
                  (this.ajaxOptions = this._applyDefaults(t.get("ajax"))),
                    null != this.ajaxOptions.processResults &&
                      (this.processResults = this.ajaxOptions.processResults),
                    i.__super__.constructor.call(this, e, t);
                }
                return (
                  t.Extend(i, e),
                  (i.prototype._applyDefaults = function(e) {
                    var t = {
                      data: function(e) {
                        return r.extend({}, e, { q: e.term });
                      },
                      transport: function(e, t, i) {
                        var n = r.ajax(e);
                        return n.then(t), n.fail(i), n;
                      }
                    };
                    return r.extend({}, t, e, !0);
                  }),
                  (i.prototype.processResults = function(e) {
                    return e;
                  }),
                  (i.prototype.query = function(i, n) {
                    var o = this;
                    null != this._request &&
                      (r.isFunction(this._request.abort) && this._request.abort(),
                      (this._request = null));
                    var t = r.extend({ type: "GET" }, this.ajaxOptions);
                    function e() {
                      var e = t.transport(
                        t,
                        function(e) {
                          var t = o.processResults(e, i);
                          o.options.get("debug") &&
                            window.console &&
                            console.error &&
                            ((t && t.results && r.isArray(t.results)) ||
                              console.error(
                                "Select2: The AJAX results did not return an array in the `results` key of the response."
                              )),
                            n(t);
                        },
                        function() {
                          (e.status && "0" === e.status) ||
                            o.trigger("results:message", {
                              message: "errorLoading"
                            });
                        }
                      );
                      o._request = e;
                    }
                    "function" == typeof t.url &&
                      (t.url = t.url.call(this.$element, i)),
                      "function" == typeof t.data &&
                        (t.data = t.data.call(this.$element, i)),
                      this.ajaxOptions.delay && null != i.term
                        ? (this._queryTimeout &&
                            window.clearTimeout(this._queryTimeout),
                          (this._queryTimeout = window.setTimeout(
                            e,
                            this.ajaxOptions.delay
                          )))
                        : e();
                  }),
                  i
                );
              }
            ),
            e.define("select2/data/tags", ["jquery"], function(d) {
              function e(e, t, i) {
                var n = i.get("tags"),
                  o = i.get("createTag");
                void 0 !== o && (this.createTag = o);
                var r = i.get("insertTag");
                if (
                  (void 0 !== r && (this.insertTag = r),
                  e.call(this, t, i),
                  d.isArray(n))
                )
                  for (var s = 0; s < n.length; s++) {
                    var a = n[s],
                      l = this._normalizeItem(a),
                      c = this.option(l);
                    this.$element.append(c);
                  }
              }
              return (
                (e.prototype.query = function(e, c, d) {
                  var u = this;
                  this._removeOldTags(),
                    null != c.term && null == c.page
                      ? e.call(this, c, function e(t, i) {
                          for (var n = t.results, o = 0; o < n.length; o++) {
                            var r = n[o],
                              s =
                                null != r.children &&
                                !e({ results: r.children }, !0);
                            if (
                              (r.text || "").toUpperCase() ===
                                (c.term || "").toUpperCase() ||
                              s
                            )
                              return !i && ((t.data = n), void d(t));
                          }
                          if (i) return !0;
                          var a = u.createTag(c);
                          if (null != a) {
                            var l = u.option(a);
                            l.attr("data-select2-tag", !0),
                              u.addOptions([l]),
                              u.insertTag(n, a);
                          }
                          (t.results = n), d(t);
                        })
                      : e.call(this, c, d);
                }),
                (e.prototype.createTag = function(e, t) {
                  var i = d.trim(t.term);
                  return "" === i ? null : { id: i, text: i };
                }),
                (e.prototype.insertTag = function(e, t, i) {
                  t.unshift(i);
                }),
                (e.prototype._removeOldTags = function(e) {
                  this._lastTag;
                  this.$element.find("option[data-select2-tag]").each(function() {
                    this.selected || d(this).remove();
                  });
                }),
                e
              );
            }),
            e.define("select2/data/tokenizer", ["jquery"], function(u) {
              function e(e, t, i) {
                var n = i.get("tokenizer");
                void 0 !== n && (this.tokenizer = n), e.call(this, t, i);
              }
              return (
                (e.prototype.bind = function(e, t, i) {
                  e.call(this, t, i),
                    (this.$search =
                      t.dropdown.$search ||
                      t.selection.$search ||
                      i.find(".select2-search__field"));
                }),
                (e.prototype.query = function(e, t, i) {
                  var n = this;
                  t.term = t.term || "";
                  var o = this.tokenizer(t, this.options, function(e) {
                    var t = n._normalizeItem(e);
                    if (
                      !n.$element.find("option").filter(function() {
                        return u(this).val() === t.id;
                      }).length
                    ) {
                      var i = n.option(t);
                      i.attr("data-select2-tag", !0),
                        n._removeOldTags(),
                        n.addOptions([i]);
                    }
                    !(function(e) {
                      n.trigger("select", { data: e });
                    })(t);
                  });
                  o.term !== t.term &&
                    (this.$search.length &&
                      (this.$search.val(o.term), this.$search.focus()),
                    (t.term = o.term)),
                    e.call(this, t, i);
                }),
                (e.prototype.tokenizer = function(e, t, i, n) {
                  for (
                    var o = i.get("tokenSeparators") || [],
                      r = t.term,
                      s = 0,
                      a =
                        this.createTag ||
                        function(e) {
                          return { id: e.term, text: e.term };
                        };
                    s < r.length;
  
                  ) {
                    var l = r[s];
                    if (-1 !== u.inArray(l, o)) {
                      var c = r.substr(0, s),
                        d = a(u.extend({}, t, { term: c }));
                      null != d
                        ? (n(d), (r = r.substr(s + 1) || ""), (s = 0))
                        : s++;
                    } else s++;
                  }
                  return { term: r };
                }),
                e
              );
            }),
            e.define("select2/data/minimumInputLength", [], function() {
              function e(e, t, i) {
                (this.minimumInputLength = i.get("minimumInputLength")),
                  e.call(this, t, i);
              }
              return (
                (e.prototype.query = function(e, t, i) {
                  (t.term = t.term || ""),
                    t.term.length < this.minimumInputLength
                      ? this.trigger("results:message", {
                          message: "inputTooShort",
                          args: {
                            minimum: this.minimumInputLength,
                            input: t.term,
                            params: t
                          }
                        })
                      : e.call(this, t, i);
                }),
                e
              );
            }),
            e.define("select2/data/maximumInputLength", [], function() {
              function e(e, t, i) {
                (this.maximumInputLength = i.get("maximumInputLength")),
                  e.call(this, t, i);
              }
              return (
                (e.prototype.query = function(e, t, i) {
                  (t.term = t.term || ""),
                    0 < this.maximumInputLength &&
                    t.term.length > this.maximumInputLength
                      ? this.trigger("results:message", {
                          message: "inputTooLong",
                          args: {
                            maximum: this.maximumInputLength,
                            input: t.term,
                            params: t
                          }
                        })
                      : e.call(this, t, i);
                }),
                e
              );
            }),
            e.define("select2/data/maximumSelectionLength", [], function() {
              function e(e, t, i) {
                (this.maximumSelectionLength = i.get("maximumSelectionLength")),
                  e.call(this, t, i);
              }
              return (
                (e.prototype.query = function(i, n, o) {
                  var r = this;
                  this.current(function(e) {
                    var t = null != e ? e.length : 0;
                    0 < r.maximumSelectionLength && t >= r.maximumSelectionLength
                      ? r.trigger("results:message", {
                          message: "maximumSelected",
                          args: { maximum: r.maximumSelectionLength }
                        })
                      : i.call(r, n, o);
                  });
                }),
                e
              );
            }),
            e.define("select2/dropdown", ["jquery", "./utils"], function(t, e) {
              function i(e, t) {
                (this.$element = e),
                  (this.options = t),
                  i.__super__.constructor.call(this);
              }
              return (
                e.Extend(i, e.Observable),
                (i.prototype.render = function() {
                  var e = t(
                    '<span class="select2-dropdown"><span class="select2-results"></span></span>'
                  );
                  return (
                    e.attr("dir", this.options.get("dir")), (this.$dropdown = e)
                  );
                }),
                (i.prototype.bind = function() {}),
                (i.prototype.position = function(e, t) {}),
                (i.prototype.destroy = function() {
                  this.$dropdown.remove();
                }),
                i
              );
            }),
            e.define("select2/dropdown/search", ["jquery", "../utils"], function(
              o,
              e
            ) {
              function t() {}
              return (
                (t.prototype.render = function(e) {
                  var t = e.call(this),
                    i = o(
                      '<span class="select2-search select2-search--dropdown"><input class="select2-search__field" type="search" tabindex="-1" autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false" role="textbox" /></span>'
                    );
                  return (
                    (this.$searchContainer = i),
                    (this.$search = i.find("input")),
                    t.prepend(i),
                    t
                  );
                }),
                (t.prototype.bind = function(e, t, i) {
                  var n = this;
                  e.call(this, t, i),
                    this.$search.on("keydown", function(e) {
                      n.trigger("keypress", e),
                        (n._keyUpPrevented = e.isDefaultPrevented());
                    }),
                    this.$search.on("input", function(e) {
                      o(this).off("keyup");
                    }),
                    this.$search.on("keyup input", function(e) {
                      n.handleSearch(e);
                    }),
                    t.on("open", function() {
                      n.$search.attr("tabindex", 0),
                        n.$search.focus(),
                        window.setTimeout(function() {
                          n.$search.focus();
                        }, 0);
                    }),
                    t.on("close", function() {
                      n.$search.attr("tabindex", -1), n.$search.val("");
                    }),
                    t.on("focus", function() {
                      t.isOpen() || n.$search.focus();
                    }),
                    t.on("results:all", function(e) {
                      (null != e.query.term && "" !== e.query.term) ||
                        (n.showSearch(e)
                          ? n.$searchContainer.removeClass("select2-search--hide")
                          : n.$searchContainer.addClass("select2-search--hide"));
                    });
                }),
                (t.prototype.handleSearch = function(e) {
                  if (!this._keyUpPrevented) {
                    var t = this.$search.val();
                    this.trigger("query", { term: t });
                  }
                  this._keyUpPrevented = !1;
                }),
                (t.prototype.showSearch = function(e, t) {
                  return !0;
                }),
                t
              );
            }),
            e.define("select2/dropdown/hidePlaceholder", [], function() {
              function e(e, t, i, n) {
                (this.placeholder = this.normalizePlaceholder(
                  i.get("placeholder")
                )),
                  e.call(this, t, i, n);
              }
              return (
                (e.prototype.append = function(e, t) {
                  (t.results = this.removePlaceholder(t.results)),
                    e.call(this, t);
                }),
                (e.prototype.normalizePlaceholder = function(e, t) {
                  return "string" == typeof t && (t = { id: "", text: t }), t;
                }),
                (e.prototype.removePlaceholder = function(e, t) {
                  for (var i = t.slice(0), n = t.length - 1; 0 <= n; n--) {
                    var o = t[n];
                    this.placeholder.id === o.id && i.splice(n, 1);
                  }
                  return i;
                }),
                e
              );
            }),
            e.define("select2/dropdown/infiniteScroll", ["jquery"], function(o) {
              function e(e, t, i, n) {
                (this.lastParams = {}),
                  e.call(this, t, i, n),
                  (this.$loadingMore = this.createLoadingMore()),
                  (this.loading = !1);
              }
              return (
                (e.prototype.append = function(e, t) {
                  this.$loadingMore.remove(),
                    (this.loading = !1),
                    e.call(this, t),
                    this.showLoadingMore(t) &&
                      this.$results.append(this.$loadingMore);
                }),
                (e.prototype.bind = function(e, t, i) {
                  var n = this;
                  e.call(this, t, i),
                    t.on("query", function(e) {
                      (n.lastParams = e), (n.loading = !0);
                    }),
                    t.on("query:append", function(e) {
                      (n.lastParams = e), (n.loading = !0);
                    }),
                    this.$results.on("scroll", function() {
                      var e = o.contains(
                        document.documentElement,
                        n.$loadingMore[0]
                      );
                      if (!n.loading && e) {
                        var t =
                          n.$results.offset().top + n.$results.outerHeight(!1);
                        n.$loadingMore.offset().top +
                          n.$loadingMore.outerHeight(!1) <=
                          t + 50 && n.loadMore();
                      }
                    });
                }),
                (e.prototype.loadMore = function() {
                  this.loading = !0;
                  var e = o.extend({}, { page: 1 }, this.lastParams);
                  e.page++, this.trigger("query:append", e);
                }),
                (e.prototype.showLoadingMore = function(e, t) {
                  return t.pagination && t.pagination.more;
                }),
                (e.prototype.createLoadingMore = function() {
                  var e = o(
                      '<li class="select2-results__option select2-results__option--load-more"role="treeitem" aria-disabled="true"></li>'
                    ),
                    t = this.options.get("translations").get("loadingMore");
                  return e.html(t(this.lastParams)), e;
                }),
                e
              );
            }),
            e.define(
              "select2/dropdown/attachBody",
              ["jquery", "../utils"],
              function(f, a) {
                function e(e, t, i) {
                  (this.$dropdownParent =
                    i.get("dropdownParent") || f(document.body)),
                    e.call(this, t, i);
                }
                return (
                  (e.prototype.bind = function(e, t, i) {
                    var n = this,
                      o = !1;
                    e.call(this, t, i),
                      t.on("open", function() {
                        n._showDropdown(),
                          n._attachPositioningHandler(t),
                          o ||
                            ((o = !0),
                            t.on("results:all", function() {
                              n._positionDropdown(), n._resizeDropdown();
                            }),
                            t.on("results:append", function() {
                              n._positionDropdown(), n._resizeDropdown();
                            }));
                      }),
                      t.on("close", function() {
                        n._hideDropdown(), n._detachPositioningHandler(t);
                      }),
                      this.$dropdownContainer.on("mousedown", function(e) {
                        e.stopPropagation();
                      });
                  }),
                  (e.prototype.destroy = function(e) {
                    e.call(this), this.$dropdownContainer.remove();
                  }),
                  (e.prototype.position = function(e, t, i) {
                    t.attr("class", i.attr("class")),
                      t.removeClass("select2"),
                      t.addClass("select2-container--open"),
                      t.css({ position: "absolute", top: -999999 }),
                      (this.$container = i);
                  }),
                  (e.prototype.render = function(e) {
                    var t = f("<span></span>"),
                      i = e.call(this);
                    return t.append(i), (this.$dropdownContainer = t);
                  }),
                  (e.prototype._hideDropdown = function(e) {
                    this.$dropdownContainer.detach();
                  }),
                  (e.prototype._attachPositioningHandler = function(e, t) {
                    var i = this,
                      n = "scroll.select2." + t.id,
                      o = "resize.select2." + t.id,
                      r = "orientationchange.select2." + t.id,
                      s = this.$container.parents().filter(a.hasScroll);
                    s.each(function() {
                      f(this).data("select2-scroll-position", {
                        x: f(this).scrollLeft(),
                        y: f(this).scrollTop()
                      });
                    }),
                      s.on(n, function(e) {
                        var t = f(this).data("select2-scroll-position");
                        f(this).scrollTop(t.y);
                      }),
                      f(window).on(n + " " + o + " " + r, function(e) {
                        i._positionDropdown(), i._resizeDropdown();
                      });
                  }),
                  (e.prototype._detachPositioningHandler = function(e, t) {
                    var i = "scroll.select2." + t.id,
                      n = "resize.select2." + t.id,
                      o = "orientationchange.select2." + t.id;
                    this.$container
                      .parents()
                      .filter(a.hasScroll)
                      .off(i),
                      f(window).off(i + " " + n + " " + o);
                  }),
                  (e.prototype._positionDropdown = function() {
                    var e = f(window),
                      t = this.$dropdown.hasClass("select2-dropdown--above"),
                      i = this.$dropdown.hasClass("select2-dropdown--below"),
                      n = null,
                      o = this.$container.offset();
                    o.bottom = o.top + this.$container.outerHeight(!1);
                    var r = { height: this.$container.outerHeight(!1) };
                    (r.top = o.top), (r.bottom = o.top + r.height);
                    var s = this.$dropdown.outerHeight(!1),
                      a = e.scrollTop(),
                      l = e.scrollTop() + e.height(),
                      c = a < o.top - s,
                      d = l > o.bottom + s,
                      u = { left: o.left, top: r.bottom },
                      p = this.$dropdownParent;
                    "static" === p.css("position") && (p = p.offsetParent());
                    var h = p.offset();
                    (u.top -= h.top),
                      (u.left -= h.left),
                      t || i || (n = "below"),
                      d || !c || t
                        ? !c && d && t && (n = "below")
                        : (n = "above"),
                      ("above" == n || (t && "below" !== n)) &&
                        (u.top = r.top - h.top - s),
                      null != n &&
                        (this.$dropdown
                          .removeClass(
                            "select2-dropdown--below select2-dropdown--above"
                          )
                          .addClass("select2-dropdown--" + n),
                        this.$container
                          .removeClass(
                            "select2-container--below select2-container--above"
                          )
                          .addClass("select2-container--" + n)),
                      this.$dropdownContainer.css(u);
                  }),
                  (e.prototype._resizeDropdown = function() {
                    var e = { width: this.$container.outerWidth(!1) + "px" };
                    this.options.get("dropdownAutoWidth") &&
                      ((e.minWidth = e.width),
                      (e.position = "relative"),
                      (e.width = "auto")),
                      this.$dropdown.css(e);
                  }),
                  (e.prototype._showDropdown = function(e) {
                    this.$dropdownContainer.appendTo(this.$dropdownParent),
                      this._positionDropdown(),
                      this._resizeDropdown();
                  }),
                  e
                );
              }
            ),
            e.define("select2/dropdown/minimumResultsForSearch", [], function() {
              function e(e, t, i, n) {
                (this.minimumResultsForSearch = i.get("minimumResultsForSearch")),
                  this.minimumResultsForSearch < 0 &&
                    (this.minimumResultsForSearch = 1 / 0),
                  e.call(this, t, i, n);
              }
              return (
                (e.prototype.showSearch = function(e, t) {
                  return (
                    !(
                      (function e(t) {
                        for (var i = 0, n = 0; n < t.length; n++) {
                          var o = t[n];
                          o.children ? (i += e(o.children)) : i++;
                        }
                        return i;
                      })(t.data.results) < this.minimumResultsForSearch
                    ) && e.call(this, t)
                  );
                }),
                e
              );
            }),
            e.define("select2/dropdown/selectOnClose", [], function() {
              function e() {}
              return (
                (e.prototype.bind = function(e, t, i) {
                  var n = this;
                  e.call(this, t, i),
                    t.on("close", function(e) {
                      n._handleSelectOnClose(e);
                    });
                }),
                (e.prototype._handleSelectOnClose = function(e, t) {
                  if (t && null != t.originalSelect2Event) {
                    var i = t.originalSelect2Event;
                    if ("select" === i._type || "unselect" === i._type) return;
                  }
                  var n = this.getHighlightedResults();
                  if (!(n.length < 1)) {
                    var o = n.data("data");
                    (null != o.element && o.element.selected) ||
                      (null == o.element && o.selected) ||
                      this.trigger("select", { data: o });
                  }
                }),
                e
              );
            }),
            e.define("select2/dropdown/closeOnSelect", [], function() {
              function e() {}
              return (
                (e.prototype.bind = function(e, t, i) {
                  var n = this;
                  e.call(this, t, i),
                    t.on("select", function(e) {
                      n._selectTriggered(e);
                    }),
                    t.on("unselect", function(e) {
                      n._selectTriggered(e);
                    });
                }),
                (e.prototype._selectTriggered = function(e, t) {
                  var i = t.originalEvent;
                  (i && i.ctrlKey) ||
                    this.trigger("close", {
                      originalEvent: i,
                      originalSelect2Event: t
                    });
                }),
                e
              );
            }),
            e.define("select2/i18n/en", [], function() {
              return {
                errorLoading: function() {
                  return "The results could not be loaded.";
                },
                inputTooLong: function(e) {
                  var t = e.input.length - e.maximum,
                    i = "Please delete " + t + " character";
                  return 1 != t && (i += "s"), i;
                },
                inputTooShort: function(e) {
                  return (
                    "Please enter " +
                    (e.minimum - e.input.length) +
                    " or more characters"
                  );
                },
                loadingMore: function() {
                  return "Loading more results…";
                },
                maximumSelected: function(e) {
                  var t = "You can only select " + e.maximum + " item";
                  return 1 != e.maximum && (t += "s"), t;
                },
                noResults: function() {
                  return "No results found";
                },
                searching: function() {
                  return "Searching…";
                }
              };
            }),
            e.define(
              "select2/defaults",
              [
                "jquery",
                "require",
                "./results",
                "./selection/single",
                "./selection/multiple",
                "./selection/placeholder",
                "./selection/allowClear",
                "./selection/search",
                "./selection/eventRelay",
                "./utils",
                "./translation",
                "./diacritics",
                "./data/select",
                "./data/array",
                "./data/ajax",
                "./data/tags",
                "./data/tokenizer",
                "./data/minimumInputLength",
                "./data/maximumInputLength",
                "./data/maximumSelectionLength",
                "./dropdown",
                "./dropdown/search",
                "./dropdown/hidePlaceholder",
                "./dropdown/infiniteScroll",
                "./dropdown/attachBody",
                "./dropdown/minimumResultsForSearch",
                "./dropdown/selectOnClose",
                "./dropdown/closeOnSelect",
                "./i18n/en"
              ],
              function(
                f,
                g,
                m,
                v,
                y,
                w,
                b,
                _,
                k,
                $,
                S,
                t,
                T,
                C,
                x,
                A,
                E,
                O,
                I,
                L,
                j,
                D,
                P,
                M,
                q,
                H,
                N,
                R,
                e
              ) {
                function i() {
                  this.reset();
                }
                return (
                  (i.prototype.apply = function(t) {
                    if (
                      null == (t = f.extend(!0, {}, this.defaults, t)).dataAdapter
                    ) {
                      if (
                        (null != t.ajax
                          ? (t.dataAdapter = x)
                          : null != t.data
                          ? (t.dataAdapter = C)
                          : (t.dataAdapter = T),
                        0 < t.minimumInputLength &&
                          (t.dataAdapter = $.Decorate(t.dataAdapter, O)),
                        0 < t.maximumInputLength &&
                          (t.dataAdapter = $.Decorate(t.dataAdapter, I)),
                        0 < t.maximumSelectionLength &&
                          (t.dataAdapter = $.Decorate(t.dataAdapter, L)),
                        t.tags && (t.dataAdapter = $.Decorate(t.dataAdapter, A)),
                        (null == t.tokenSeparators && null == t.tokenizer) ||
                          (t.dataAdapter = $.Decorate(t.dataAdapter, E)),
                        null != t.query)
                      ) {
                        var e = g(t.amdBase + "compat/query");
                        t.dataAdapter = $.Decorate(t.dataAdapter, e);
                      }
                      if (null != t.initSelection) {
                        var i = g(t.amdBase + "compat/initSelection");
                        t.dataAdapter = $.Decorate(t.dataAdapter, i);
                      }
                    }
                    if (
                      (null == t.resultsAdapter &&
                        ((t.resultsAdapter = m),
                        null != t.ajax &&
                          (t.resultsAdapter = $.Decorate(t.resultsAdapter, M)),
                        null != t.placeholder &&
                          (t.resultsAdapter = $.Decorate(t.resultsAdapter, P)),
                        t.selectOnClose &&
                          (t.resultsAdapter = $.Decorate(t.resultsAdapter, N))),
                      null == t.dropdownAdapter)
                    ) {
                      if (t.multiple) t.dropdownAdapter = j;
                      else {
                        var n = $.Decorate(j, D);
                        t.dropdownAdapter = n;
                      }
                      if (
                        (0 !== t.minimumResultsForSearch &&
                          (t.dropdownAdapter = $.Decorate(t.dropdownAdapter, H)),
                        t.closeOnSelect &&
                          (t.dropdownAdapter = $.Decorate(t.dropdownAdapter, R)),
                        null != t.dropdownCssClass ||
                          null != t.dropdownCss ||
                          null != t.adaptDropdownCssClass)
                      ) {
                        var o = g(t.amdBase + "compat/dropdownCss");
                        t.dropdownAdapter = $.Decorate(t.dropdownAdapter, o);
                      }
                      t.dropdownAdapter = $.Decorate(t.dropdownAdapter, q);
                    }
                    if (null == t.selectionAdapter) {
                      if (
                        (t.multiple
                          ? (t.selectionAdapter = y)
                          : (t.selectionAdapter = v),
                        null != t.placeholder &&
                          (t.selectionAdapter = $.Decorate(
                            t.selectionAdapter,
                            w
                          )),
                        t.allowClear &&
                          (t.selectionAdapter = $.Decorate(
                            t.selectionAdapter,
                            b
                          )),
                        t.multiple &&
                          (t.selectionAdapter = $.Decorate(
                            t.selectionAdapter,
                            _
                          )),
                        null != t.containerCssClass ||
                          null != t.containerCss ||
                          null != t.adaptContainerCssClass)
                      ) {
                        var r = g(t.amdBase + "compat/containerCss");
                        t.selectionAdapter = $.Decorate(t.selectionAdapter, r);
                      }
                      t.selectionAdapter = $.Decorate(t.selectionAdapter, k);
                    }
                    if ("string" == typeof t.language)
                      if (0 < t.language.indexOf("-")) {
                        var s = t.language.split("-")[0];
                        t.language = [t.language, s];
                      } else t.language = [t.language];
                    if (f.isArray(t.language)) {
                      var a = new S();
                      t.language.push("en");
                      for (var l = t.language, c = 0; c < l.length; c++) {
                        var d = l[c],
                          u = {};
                        try {
                          u = S.loadPath(d);
                        } catch (e) {
                          try {
                            (d = this.defaults.amdLanguageBase + d),
                              (u = S.loadPath(d));
                          } catch (e) {
                            t.debug &&
                              window.console &&
                              console.warn &&
                              console.warn(
                                'Select2: The language file for "' +
                                  d +
                                  '" could not be automatically loaded. A fallback will be used instead.'
                              );
                            continue;
                          }
                        }
                        a.extend(u);
                      }
                      t.translations = a;
                    } else {
                      var p = S.loadPath(this.defaults.amdLanguageBase + "en"),
                        h = new S(t.language);
                      h.extend(p), (t.translations = h);
                    }
                    return t;
                  }),
                  (i.prototype.reset = function() {
                    function a(e) {
                      return e.replace(/[^\u0000-\u007E]/g, function(e) {
                        return t[e] || e;
                      });
                    }
                    this.defaults = {
                      amdBase: "./",
                      amdLanguageBase: "./i18n/",
                      closeOnSelect: !0,
                      debug: !1,
                      dropdownAutoWidth: !1,
                      escapeMarkup: $.escapeMarkup,
                      language: e,
                      matcher: function e(t, i) {
                        if ("" === f.trim(t.term)) return i;
                        if (i.children && 0 < i.children.length) {
                          for (
                            var n = f.extend(!0, {}, i),
                              o = i.children.length - 1;
                            0 <= o;
                            o--
                          )
                            null == e(t, i.children[o]) &&
                              n.children.splice(o, 1);
                          return 0 < n.children.length ? n : e(t, n);
                        }
                        var r = a(i.text).toUpperCase(),
                          s = a(t.term).toUpperCase();
                        return -1 < r.indexOf(s) ? i : null;
                      },
                      minimumInputLength: 0,
                      maximumInputLength: 0,
                      maximumSelectionLength: 0,
                      minimumResultsForSearch: 0,
                      selectOnClose: !1,
                      sorter: function(e) {
                        return e;
                      },
                      templateResult: function(e) {
                        return e.text;
                      },
                      templateSelection: function(e) {
                        return e.text;
                      },
                      theme: "default",
                      width: "resolve"
                    };
                  }),
                  (i.prototype.set = function(e, t) {
                    var i = {};
                    i[f.camelCase(e)] = t;
                    var n = $._convertData(i);
                    f.extend(this.defaults, n);
                  }),
                  new i()
                );
              }
            ),
            e.define(
              "select2/options",
              ["require", "jquery", "./defaults", "./utils"],
              function(n, r, o, s) {
                function e(e, t) {
                  if (
                    ((this.options = e),
                    null != t && this.fromElement(t),
                    (this.options = o.apply(this.options)),
                    t && t.is("input"))
                  ) {
                    var i = n(this.get("amdBase") + "compat/inputData");
                    this.options.dataAdapter = s.Decorate(
                      this.options.dataAdapter,
                      i
                    );
                  }
                }
                return (
                  (e.prototype.fromElement = function(e) {
                    var t = ["select2"];
                    null == this.options.multiple &&
                      (this.options.multiple = e.prop("multiple")),
                      null == this.options.disabled &&
                        (this.options.disabled = e.prop("disabled")),
                      null == this.options.language &&
                        (e.prop("lang")
                          ? (this.options.language = e.prop("lang").toLowerCase())
                          : e.closest("[lang]").prop("lang") &&
                            (this.options.language = e
                              .closest("[lang]")
                              .prop("lang"))),
                      null == this.options.dir &&
                        (e.prop("dir")
                          ? (this.options.dir = e.prop("dir"))
                          : e.closest("[dir]").prop("dir")
                          ? (this.options.dir = e.closest("[dir]").prop("dir"))
                          : (this.options.dir = "ltr")),
                      e.prop("disabled", this.options.disabled),
                      e.prop("multiple", this.options.multiple),
                      e.data("select2Tags") &&
                        (this.options.debug &&
                          window.console &&
                          console.warn &&
                          console.warn(
                            'Select2: The `data-select2-tags` attribute has been changed to use the `data-data` and `data-tags="true"` attributes and will be removed in future versions of Select2.'
                          ),
                        e.data("data", e.data("select2Tags")),
                        e.data("tags", !0)),
                      e.data("ajaxUrl") &&
                        (this.options.debug &&
                          window.console &&
                          console.warn &&
                          console.warn(
                            "Select2: The `data-ajax-url` attribute has been changed to `data-ajax--url` and support for the old attribute will be removed in future versions of Select2."
                          ),
                        e.attr("ajax--url", e.data("ajaxUrl")),
                        e.data("ajax--url", e.data("ajaxUrl")));
                    var i = {};
                    i =
                      r.fn.jquery &&
                      "1." == r.fn.jquery.substr(0, 2) &&
                      e[0].dataset
                        ? r.extend(!0, {}, e[0].dataset, e.data())
                        : e.data();
                    var n = r.extend(!0, {}, i);
                    for (var o in (n = s._convertData(n)))
                      -1 < r.inArray(o, t) ||
                        (r.isPlainObject(this.options[o])
                          ? r.extend(this.options[o], n[o])
                          : (this.options[o] = n[o]));
                    return this;
                  }),
                  (e.prototype.get = function(e) {
                    return this.options[e];
                  }),
                  (e.prototype.set = function(e, t) {
                    this.options[e] = t;
                  }),
                  e
                );
              }
            ),
            e.define(
              "select2/core",
              ["jquery", "./options", "./utils", "./keys"],
              function(o, c, i, n) {
                var d = function(e, t) {
                  null != e.data("select2") && e.data("select2").destroy(),
                    (this.$element = e),
                    (this.id = this._generateId(e)),
                    (t = t || {}),
                    (this.options = new c(t, e)),
                    d.__super__.constructor.call(this);
                  var i = e.attr("tabindex") || 0;
                  e.data("old-tabindex", i), e.attr("tabindex", "-1");
                  var n = this.options.get("dataAdapter");
                  this.dataAdapter = new n(e, this.options);
                  var o = this.render();
                  this._placeContainer(o);
                  var r = this.options.get("selectionAdapter");
                  (this.selection = new r(e, this.options)),
                    (this.$selection = this.selection.render()),
                    this.selection.position(this.$selection, o);
                  var s = this.options.get("dropdownAdapter");
                  (this.dropdown = new s(e, this.options)),
                    (this.$dropdown = this.dropdown.render()),
                    this.dropdown.position(this.$dropdown, o);
                  var a = this.options.get("resultsAdapter");
                  (this.results = new a(e, this.options, this.dataAdapter)),
                    (this.$results = this.results.render()),
                    this.results.position(this.$results, this.$dropdown);
                  var l = this;
                  this._bindAdapters(),
                    this._registerDomEvents(),
                    this._registerDataEvents(),
                    this._registerSelectionEvents(),
                    this._registerDropdownEvents(),
                    this._registerResultsEvents(),
                    this._registerEvents(),
                    this.dataAdapter.current(function(e) {
                      l.trigger("selection:update", { data: e });
                    }),
                    e.addClass("select2-hidden-accessible"),
                    e.attr("aria-hidden", "true"),
                    this._syncAttributes(),
                    e.data("select2", this);
                };
                return (
                  i.Extend(d, i.Observable),
                  (d.prototype._generateId = function(e) {
                    return (
                      "select2-" +
                      (null != e.attr("id")
                        ? e.attr("id")
                        : null != e.attr("name")
                        ? e.attr("name") + "-" + i.generateChars(2)
                        : i.generateChars(4)
                      ).replace(/(:|\.|\[|\]|,)/g, "")
                    );
                  }),
                  (d.prototype._placeContainer = function(e) {
                    e.insertAfter(this.$element);
                    var t = this._resolveWidth(
                      this.$element,
                      this.options.get("width")
                    );
                    null != t && e.css("width", t);
                  }),
                  (d.prototype._resolveWidth = function(e, t) {
                    var i = /^width:(([-+]?([0-9]*\.)?[0-9]+)(px|em|ex|%|in|cm|mm|pt|pc))/i;
                    if ("resolve" == t) {
                      var n = this._resolveWidth(e, "style");
                      return null != n ? n : this._resolveWidth(e, "element");
                    }
                    if ("element" == t) {
                      var o = e.outerWidth(!1);
                      return o <= 0 ? "auto" : o + "px";
                    }
                    if ("style" != t) return t;
                    var r = e.attr("style");
                    if ("string" != typeof r) return null;
                    for (
                      var s = r.split(";"), a = 0, l = s.length;
                      a < l;
                      a += 1
                    ) {
                      var c = s[a].replace(/\s/g, "").match(i);
                      if (null !== c && 1 <= c.length) return c[1];
                    }
                    return null;
                  }),
                  (d.prototype._bindAdapters = function() {
                    this.dataAdapter.bind(this, this.$container),
                      this.selection.bind(this, this.$container),
                      this.dropdown.bind(this, this.$container),
                      this.results.bind(this, this.$container);
                  }),
                  (d.prototype._registerDomEvents = function() {
                    var t = this;
                    this.$element.on("change.select2", function() {
                      t.dataAdapter.current(function(e) {
                        t.trigger("selection:update", { data: e });
                      });
                    }),
                      this.$element.on("focus.select2", function(e) {
                        t.trigger("focus", e);
                      }),
                      (this._syncA = i.bind(this._syncAttributes, this)),
                      (this._syncS = i.bind(this._syncSubtree, this)),
                      this.$element[0].attachEvent &&
                        this.$element[0].attachEvent(
                          "onpropertychange",
                          this._syncA
                        );
                    var e =
                      window.MutationObserver ||
                      window.WebKitMutationObserver ||
                      window.MozMutationObserver;
                    null != e
                      ? ((this._observer = new e(function(e) {
                          o.each(e, t._syncA), o.each(e, t._syncS);
                        })),
                        this._observer.observe(this.$element[0], {
                          attributes: !0,
                          childList: !0,
                          subtree: !1
                        }))
                      : this.$element[0].addEventListener &&
                        (this.$element[0].addEventListener(
                          "DOMAttrModified",
                          t._syncA,
                          !1
                        ),
                        this.$element[0].addEventListener(
                          "DOMNodeInserted",
                          t._syncS,
                          !1
                        ),
                        this.$element[0].addEventListener(
                          "DOMNodeRemoved",
                          t._syncS,
                          !1
                        ));
                  }),
                  (d.prototype._registerDataEvents = function() {
                    var i = this;
                    this.dataAdapter.on("*", function(e, t) {
                      i.trigger(e, t);
                    });
                  }),
                  (d.prototype._registerSelectionEvents = function() {
                    var i = this,
                      n = ["toggle", "focus"];
                    this.selection.on("toggle", function() {
                      i.toggleDropdown();
                    }),
                      this.selection.on("focus", function(e) {
                        i.focus(e);
                      }),
                      this.selection.on("*", function(e, t) {
                        -1 === o.inArray(e, n) && i.trigger(e, t);
                      });
                  }),
                  (d.prototype._registerDropdownEvents = function() {
                    var i = this;
                    this.dropdown.on("*", function(e, t) {
                      i.trigger(e, t);
                    });
                  }),
                  (d.prototype._registerResultsEvents = function() {
                    var i = this;
                    this.results.on("*", function(e, t) {
                      i.trigger(e, t);
                    });
                  }),
                  (d.prototype._registerEvents = function() {
                    var i = this;
                    this.on("open", function() {
                      i.$container.addClass("select2-container--open");
                    }),
                      this.on("close", function() {
                        i.$container.removeClass("select2-container--open");
                      }),
                      this.on("enable", function() {
                        i.$container.removeClass("select2-container--disabled");
                      }),
                      this.on("disable", function() {
                        i.$container.addClass("select2-container--disabled");
                      }),
                      this.on("blur", function() {
                        i.$container.removeClass("select2-container--focus");
                      }),
                      this.on("query", function(t) {
                        i.isOpen() || i.trigger("open", {}),
                          this.dataAdapter.query(t, function(e) {
                            i.trigger("results:all", { data: e, query: t });
                          });
                      }),
                      this.on("query:append", function(t) {
                        this.dataAdapter.query(t, function(e) {
                          i.trigger("results:append", { data: e, query: t });
                        });
                      }),
                      this.on("keypress", function(e) {
                        var t = e.which;
                        i.isOpen()
                          ? t === n.ESC || t === n.TAB || (t === n.UP && e.altKey)
                            ? (i.close(), e.preventDefault())
                            : t === n.ENTER
                            ? (i.trigger("results:select", {}),
                              e.preventDefault())
                            : t === n.SPACE && e.ctrlKey
                            ? (i.trigger("results:toggle", {}),
                              e.preventDefault())
                            : t === n.UP
                            ? (i.trigger("results:previous", {}),
                              e.preventDefault())
                            : t === n.DOWN &&
                              (i.trigger("results:next", {}), e.preventDefault())
                          : (t === n.ENTER ||
                              t === n.SPACE ||
                              (t === n.DOWN && e.altKey)) &&
                            (i.open(), e.preventDefault());
                      });
                  }),
                  (d.prototype._syncAttributes = function() {
                    this.options.set("disabled", this.$element.prop("disabled")),
                      this.options.get("disabled")
                        ? (this.isOpen() && this.close(),
                          this.trigger("disable", {}))
                        : this.trigger("enable", {});
                  }),
                  (d.prototype._syncSubtree = function(e, t) {
                    var i = !1,
                      n = this;
                    if (
                      !e ||
                      !e.target ||
                      "OPTION" === e.target.nodeName ||
                      "OPTGROUP" === e.target.nodeName
                    ) {
                      if (t)
                        if (t.addedNodes && 0 < t.addedNodes.length)
                          for (var o = 0; o < t.addedNodes.length; o++) {
                            t.addedNodes[o].selected && (i = !0);
                          }
                        else
                          t.removedNodes && 0 < t.removedNodes.length && (i = !0);
                      else i = !0;
                      i &&
                        this.dataAdapter.current(function(e) {
                          n.trigger("selection:update", { data: e });
                        });
                    }
                  }),
                  (d.prototype.trigger = function(e, t) {
                    var i = d.__super__.trigger,
                      n = {
                        open: "opening",
                        close: "closing",
                        select: "selecting",
                        unselect: "unselecting"
                      };
                    if ((void 0 === t && (t = {}), e in n)) {
                      var o = n[e],
                        r = { prevented: !1, name: e, args: t };
                      if ((i.call(this, o, r), r.prevented))
                        return void (t.prevented = !0);
                    }
                    i.call(this, e, t);
                  }),
                  (d.prototype.toggleDropdown = function() {
                    this.options.get("disabled") ||
                      (this.isOpen() ? this.close() : this.open());
                  }),
                  (d.prototype.open = function() {
                    this.isOpen() || this.trigger("query", {});
                  }),
                  (d.prototype.close = function() {
                    this.isOpen() && this.trigger("close", {});
                  }),
                  (d.prototype.isOpen = function() {
                    return this.$container.hasClass("select2-container--open");
                  }),
                  (d.prototype.hasFocus = function() {
                    return this.$container.hasClass("select2-container--focus");
                  }),
                  (d.prototype.focus = function(e) {
                    this.hasFocus() ||
                      (this.$container.addClass("select2-container--focus"),
                      this.trigger("focus", {}));
                  }),
                  (d.prototype.enable = function(e) {
                    this.options.get("debug") &&
                      window.console &&
                      console.warn &&
                      console.warn(
                        'Select2: The `select2("enable")` method has been deprecated and will be removed in later Select2 versions. Use $element.prop("disabled") instead.'
                      ),
                      (null != e && 0 !== e.length) || (e = [!0]);
                    var t = !e[0];
                    this.$element.prop("disabled", t);
                  }),
                  (d.prototype.data = function() {
                    this.options.get("debug") &&
                      0 < arguments.length &&
                      window.console &&
                      console.warn &&
                      console.warn(
                        'Select2: Data can no longer be set using `select2("data")`. You should consider setting the value instead using `$element.val()`.'
                      );
                    var t = [];
                    return (
                      this.dataAdapter.current(function(e) {
                        t = e;
                      }),
                      t
                    );
                  }),
                  (d.prototype.val = function(e) {
                    if (
                      (this.options.get("debug") &&
                        window.console &&
                        console.warn &&
                        console.warn(
                          'Select2: The `select2("val")` method has been deprecated and will be removed in later Select2 versions. Use $element.val() instead.'
                        ),
                      null == e || 0 === e.length)
                    )
                      return this.$element.val();
                    var t = e[0];
                    o.isArray(t) &&
                      (t = o.map(t, function(e) {
                        return e.toString();
                      })),
                      this.$element.val(t).trigger("change");
                  }),
                  (d.prototype.destroy = function() {
                    this.$container.remove(),
                      this.$element[0].detachEvent &&
                        this.$element[0].detachEvent(
                          "onpropertychange",
                          this._syncA
                        ),
                      null != this._observer
                        ? (this._observer.disconnect(), (this._observer = null))
                        : this.$element[0].removeEventListener &&
                          (this.$element[0].removeEventListener(
                            "DOMAttrModified",
                            this._syncA,
                            !1
                          ),
                          this.$element[0].removeEventListener(
                            "DOMNodeInserted",
                            this._syncS,
                            !1
                          ),
                          this.$element[0].removeEventListener(
                            "DOMNodeRemoved",
                            this._syncS,
                            !1
                          )),
                      (this._syncA = null),
                      (this._syncS = null),
                      this.$element.off(".select2"),
                      this.$element.attr(
                        "tabindex",
                        this.$element.data("old-tabindex")
                      ),
                      this.$element.removeClass("select2-hidden-accessible"),
                      this.$element.attr("aria-hidden", "false"),
                      this.$element.removeData("select2"),
                      this.dataAdapter.destroy(),
                      this.selection.destroy(),
                      this.dropdown.destroy(),
                      this.results.destroy(),
                      (this.dataAdapter = null),
                      (this.selection = null),
                      (this.dropdown = null),
                      (this.results = null);
                  }),
                  (d.prototype.render = function() {
                    var e = o(
                      '<span class="select2 select2-container"><span class="selection"></span><span class="dropdown-wrapper" aria-hidden="true"></span></span>'
                    );
                    return (
                      e.attr("dir", this.options.get("dir")),
                      (this.$container = e),
                      this.$container.addClass(
                        "select2-container--" + this.options.get("theme")
                      ),
                      e.data("element", this.$element),
                      e
                    );
                  }),
                  d
                );
              }
            ),
            e.define("select2/compat/utils", ["jquery"], function(s) {
              return {
                syncCssClasses: function(e, t, i) {
                  var n,
                    o,
                    r = [];
                  (n = s.trim(e.attr("class"))) &&
                    s((n = "" + n).split(/\s+/)).each(function() {
                      0 === this.indexOf("select2-") && r.push(this);
                    }),
                    (n = s.trim(t.attr("class"))) &&
                      s((n = "" + n).split(/\s+/)).each(function() {
                        0 !== this.indexOf("select2-") &&
                          null != (o = i(this)) &&
                          r.push(o);
                      }),
                    e.attr("class", r.join(" "));
                }
              };
            }),
            e.define(
              "select2/compat/containerCss",
              ["jquery", "./utils"],
              function(s, a) {
                function l(e) {
                  return null;
                }
                function e() {}
                return (
                  (e.prototype.render = function(e) {
                    var t = e.call(this),
                      i = this.options.get("containerCssClass") || "";
                    s.isFunction(i) && (i = i(this.$element));
                    var n = this.options.get("adaptContainerCssClass");
                    if (((n = n || l), -1 !== i.indexOf(":all:"))) {
                      i = i.replace(":all:", "");
                      var o = n;
                      n = function(e) {
                        var t = o(e);
                        return null != t ? t + " " + e : e;
                      };
                    }
                    var r = this.options.get("containerCss") || {};
                    return (
                      s.isFunction(r) && (r = r(this.$element)),
                      a.syncCssClasses(t, this.$element, n),
                      t.css(r),
                      t.addClass(i),
                      t
                    );
                  }),
                  e
                );
              }
            ),
            e.define(
              "select2/compat/dropdownCss",
              ["jquery", "./utils"],
              function(s, a) {
                function l(e) {
                  return null;
                }
                function e() {}
                return (
                  (e.prototype.render = function(e) {
                    var t = e.call(this),
                      i = this.options.get("dropdownCssClass") || "";
                    s.isFunction(i) && (i = i(this.$element));
                    var n = this.options.get("adaptDropdownCssClass");
                    if (((n = n || l), -1 !== i.indexOf(":all:"))) {
                      i = i.replace(":all:", "");
                      var o = n;
                      n = function(e) {
                        var t = o(e);
                        return null != t ? t + " " + e : e;
                      };
                    }
                    var r = this.options.get("dropdownCss") || {};
                    return (
                      s.isFunction(r) && (r = r(this.$element)),
                      a.syncCssClasses(t, this.$element, n),
                      t.css(r),
                      t.addClass(i),
                      t
                    );
                  }),
                  e
                );
              }
            ),
            e.define("select2/compat/initSelection", ["jquery"], function(n) {
              function e(e, t, i) {
                i.get("debug") &&
                  window.console &&
                  console.warn &&
                  console.warn(
                    "Select2: The `initSelection` option has been deprecated in favor of a custom data adapter that overrides the `current` method. This method is now called multiple times instead of a single time when the instance is initialized. Support will be removed for the `initSelection` option in future versions of Select2"
                  ),
                  (this.initSelection = i.get("initSelection")),
                  (this._isInitialized = !1),
                  e.call(this, t, i);
              }
              return (
                (e.prototype.current = function(e, t) {
                  var i = this;
                  this._isInitialized
                    ? e.call(this, t)
                    : this.initSelection.call(null, this.$element, function(e) {
                        (i._isInitialized = !0), n.isArray(e) || (e = [e]), t(e);
                      });
                }),
                e
              );
            }),
            e.define("select2/compat/inputData", ["jquery"], function(s) {
              function e(e, t, i) {
                (this._currentData = []),
                  (this._valueSeparator = i.get("valueSeparator") || ","),
                  "hidden" === t.prop("type") &&
                    i.get("debug") &&
                    console &&
                    console.warn &&
                    console.warn(
                      "Select2: Using a hidden input with Select2 is no longer supported and may stop working in the future. It is recommended to use a `<select>` element instead."
                    ),
                  e.call(this, t, i);
              }
              return (
                (e.prototype.current = function(e, t) {
                  function n(e, t) {
                    var i = [];
                    return (
                      e.selected || -1 !== s.inArray(e.id, t)
                        ? ((e.selected = !0), i.push(e))
                        : (e.selected = !1),
                      e.children && i.push.apply(i, n(e.children, t)),
                      i
                    );
                  }
                  for (var i = [], o = 0; o < this._currentData.length; o++) {
                    var r = this._currentData[o];
                    i.push.apply(
                      i,
                      n(r, this.$element.val().split(this._valueSeparator))
                    );
                  }
                  t(i);
                }),
                (e.prototype.select = function(e, t) {
                  if (this.options.get("multiple")) {
                    var i = this.$element.val();
                    (i += this._valueSeparator + t.id),
                      this.$element.val(i),
                      this.$element.trigger("change");
                  } else
                    this.current(function(e) {
                      s.map(e, function(e) {
                        e.selected = !1;
                      });
                    }),
                      this.$element.val(t.id),
                      this.$element.trigger("change");
                }),
                (e.prototype.unselect = function(e, o) {
                  var r = this;
                  (o.selected = !1),
                    this.current(function(e) {
                      for (var t = [], i = 0; i < e.length; i++) {
                        var n = e[i];
                        o.id != n.id && t.push(n.id);
                      }
                      r.$element.val(t.join(r._valueSeparator)),
                        r.$element.trigger("change");
                    });
                }),
                (e.prototype.query = function(e, t, i) {
                  for (var n = [], o = 0; o < this._currentData.length; o++) {
                    var r = this._currentData[o],
                      s = this.matches(t, r);
                    null !== s && n.push(s);
                  }
                  i({ results: n });
                }),
                (e.prototype.addOptions = function(e, t) {
                  var i = s.map(t, function(e) {
                    return s.data(e[0], "data");
                  });
                  this._currentData.push.apply(this._currentData, i);
                }),
                e
              );
            }),
            e.define("select2/compat/matcher", ["jquery"], function(s) {
              return function(r) {
                return function(e, t) {
                  var i = s.extend(!0, {}, t);
                  if (null == e.term || "" === s.trim(e.term)) return i;
                  if (t.children) {
                    for (var n = t.children.length - 1; 0 <= n; n--) {
                      var o = t.children[n];
                      r(e.term, o.text, o) || i.children.splice(n, 1);
                    }
                    if (0 < i.children.length) return i;
                  }
                  return r(e.term, t.text, t) ? i : null;
                };
              };
            }),
            e.define("select2/compat/query", [], function() {
              function e(e, t, i) {
                i.get("debug") &&
                  window.console &&
                  console.warn &&
                  console.warn(
                    "Select2: The `query` option has been deprecated in favor of a custom data adapter that overrides the `query` method. Support will be removed for the `query` option in future versions of Select2."
                  ),
                  e.call(this, t, i);
              }
              return (
                (e.prototype.query = function(e, t, i) {
                  (t.callback = i), this.options.get("query").call(null, t);
                }),
                e
              );
            }),
            e.define("select2/dropdown/attachContainer", [], function() {
              function e(e, t, i) {
                e.call(this, t, i);
              }
              return (
                (e.prototype.position = function(e, t, i) {
                  i.find(".dropdown-wrapper").append(t),
                    t.addClass("select2-dropdown--below"),
                    i.addClass("select2-container--below");
                }),
                e
              );
            }),
            e.define("select2/dropdown/stopPropagation", [], function() {
              function e() {}
              return (
                (e.prototype.bind = function(e, t, i) {
                  e.call(this, t, i);
                  this.$dropdown.on(
                    [
                      "blur",
                      "change",
                      "click",
                      "dblclick",
                      "focus",
                      "focusin",
                      "focusout",
                      "input",
                      "keydown",
                      "keyup",
                      "keypress",
                      "mousedown",
                      "mouseenter",
                      "mouseleave",
                      "mousemove",
                      "mouseover",
                      "mouseup",
                      "search",
                      "touchend",
                      "touchstart"
                    ].join(" "),
                    function(e) {
                      e.stopPropagation();
                    }
                  );
                }),
                e
              );
            }),
            e.define("select2/selection/stopPropagation", [], function() {
              function e() {}
              return (
                (e.prototype.bind = function(e, t, i) {
                  e.call(this, t, i);
                  this.$selection.on(
                    [
                      "blur",
                      "change",
                      "click",
                      "dblclick",
                      "focus",
                      "focusin",
                      "focusout",
                      "input",
                      "keydown",
                      "keyup",
                      "keypress",
                      "mousedown",
                      "mouseenter",
                      "mouseleave",
                      "mousemove",
                      "mouseover",
                      "mouseup",
                      "search",
                      "touchend",
                      "touchstart"
                    ].join(" "),
                    function(e) {
                      e.stopPropagation();
                    }
                  );
                }),
                e
              );
            }),
            (i = function(p) {
              var h,
                f,
                e = [
                  "wheel",
                  "mousewheel",
                  "DOMMouseScroll",
                  "MozMousePixelScroll"
                ],
                t =
                  "onwheel" in document || 9 <= document.documentMode
                    ? ["wheel"]
                    : ["mousewheel", "DomMouseScroll", "MozMousePixelScroll"],
                g = Array.prototype.slice;
              if (p.event.fixHooks)
                for (var i = e.length; i; )
                  p.event.fixHooks[e[--i]] = p.event.mouseHooks;
              var m = (p.event.special.mousewheel = {
                version: "3.1.12",
                setup: function() {
                  if (this.addEventListener)
                    for (var e = t.length; e; )
                      this.addEventListener(t[--e], n, !1);
                  else this.onmousewheel = n;
                  p.data(this, "mousewheel-line-height", m.getLineHeight(this)),
                    p.data(this, "mousewheel-page-height", m.getPageHeight(this));
                },
                teardown: function() {
                  if (this.removeEventListener)
                    for (var e = t.length; e; )
                      this.removeEventListener(t[--e], n, !1);
                  else this.onmousewheel = null;
                  p.removeData(this, "mousewheel-line-height"),
                    p.removeData(this, "mousewheel-page-height");
                },
                getLineHeight: function(e) {
                  var t = p(e),
                    i = t["offsetParent" in p.fn ? "offsetParent" : "parent"]();
                  return (
                    i.length || (i = p("body")),
                    parseInt(i.css("fontSize"), 10) ||
                      parseInt(t.css("fontSize"), 10) ||
                      16
                  );
                },
                getPageHeight: function(e) {
                  return p(e).height();
                },
                settings: { adjustOldDeltas: !0, normalizeOffset: !0 }
              });
              function n(e) {
                var t,
                  i = e || window.event,
                  n = g.call(arguments, 1),
                  o = 0,
                  r = 0,
                  s = 0,
                  a = 0,
                  l = 0;
                if (
                  (((e = p.event.fix(i)).type = "mousewheel"),
                  "detail" in i && (s = -1 * i.detail),
                  "wheelDelta" in i && (s = i.wheelDelta),
                  "wheelDeltaY" in i && (s = i.wheelDeltaY),
                  "wheelDeltaX" in i && (r = -1 * i.wheelDeltaX),
                  "axis" in i &&
                    i.axis === i.HORIZONTAL_AXIS &&
                    ((r = -1 * s), (s = 0)),
                  (o = 0 === s ? r : s),
                  "deltaY" in i && (o = s = -1 * i.deltaY),
                  "deltaX" in i && ((r = i.deltaX), 0 === s && (o = -1 * r)),
                  0 !== s || 0 !== r)
                ) {
                  if (1 === i.deltaMode) {
                    var c = p.data(this, "mousewheel-line-height");
                    (o *= c), (s *= c), (r *= c);
                  } else if (2 === i.deltaMode) {
                    var d = p.data(this, "mousewheel-page-height");
                    (o *= d), (s *= d), (r *= d);
                  }
                  if (
                    ((t = Math.max(Math.abs(s), Math.abs(r))),
                    (!f || t < f) && y(i, (f = t)) && (f /= 40),
                    y(i, t) && ((o /= 40), (r /= 40), (s /= 40)),
                    (o = Math[1 <= o ? "floor" : "ceil"](o / f)),
                    (r = Math[1 <= r ? "floor" : "ceil"](r / f)),
                    (s = Math[1 <= s ? "floor" : "ceil"](s / f)),
                    m.settings.normalizeOffset && this.getBoundingClientRect)
                  ) {
                    var u = this.getBoundingClientRect();
                    (a = e.clientX - u.left), (l = e.clientY - u.top);
                  }
                  return (
                    (e.deltaX = r),
                    (e.deltaY = s),
                    (e.deltaFactor = f),
                    (e.offsetX = a),
                    (e.offsetY = l),
                    (e.deltaMode = 0),
                    n.unshift(e, o, r, s),
                    h && clearTimeout(h),
                    (h = setTimeout(v, 200)),
                    (p.event.dispatch || p.event.handle).apply(this, n)
                  );
                }
              }
              function v() {
                f = null;
              }
              function y(e, t) {
                return (
                  m.settings.adjustOldDeltas &&
                  "mousewheel" === e.type &&
                  t % 120 == 0
                );
              }
              p.fn.extend({
                mousewheel: function(e) {
                  return e
                    ? this.bind("mousewheel", e)
                    : this.trigger("mousewheel");
                },
                unmousewheel: function(e) {
                  return this.unbind("mousewheel", e);
                }
              });
            }),
            "function" == typeof e.define && e.define.amd
              ? e.define("jquery-mousewheel", ["jquery"], i)
              : "object" == typeof exports
              ? (module.exports = i)
              : i(n),
            e.define(
              "jquery.select2",
              [
                "jquery",
                "jquery-mousewheel",
                "./select2/core",
                "./select2/defaults"
              ],
              function(o, e, r, t) {
                if (null == o.fn.select2) {
                  var s = ["open", "close", "destroy"];
                  o.fn.select2 = function(t) {
                    if ("object" == typeof (t = t || {}))
                      return (
                        this.each(function() {
                          var e = o.extend(!0, {}, t);
                          new r(o(this), e);
                        }),
                        this
                      );
                    if ("string" != typeof t)
                      throw new Error("Invalid arguments for Select2: " + t);
                    var i,
                      n = Array.prototype.slice.call(arguments, 1);
                    return (
                      this.each(function() {
                        var e = o(this).data("select2");
                        null == e &&
                          window.console &&
                          console.error &&
                          console.error(
                            "The select2('" +
                              t +
                              "') method was called on an element that is not using Select2."
                          ),
                          (i = e[t].apply(e, n));
                      }),
                      -1 < o.inArray(t, s) ? this : i
                    );
                  };
                }
                return (
                  null == o.fn.select2.defaults && (o.fn.select2.defaults = t), r
                );
              }
            ),
            { define: e.define, require: e.require }
          );
        })(),
        t = e.require("jquery.select2");
      return (n.fn.select2.amd = e), t;
    }),
    (function(e) {
      "use strict";
      "function" == typeof define && define.amd
        ? define(["jquery"], e)
        : "undefined" != typeof exports
        ? (module.exports = e(require("jquery")))
        : e(jQuery);
    })(function(c) {
      "use strict";
      var o,
        s = window.Slick || {};
      (o = 0),
        ((s = function(e, t) {
          var i,
            n = this;
          (n.defaults = {
            accessibility: !0,
            adaptiveHeight: !1,
            appendArrows: c(e),
            appendDots: c(e),
            arrows: !0,
            asNavFor: null,
            prevArrow:
              '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button">Previous</button>',
            nextArrow:
              '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button">Next</button>',
            autoplay: !1,
            autoplaySpeed: 3e3,
            centerMode: !1,
            centerPadding: "50px",
            cssEase: "ease",
            customPaging: function(e, t) {
              return c(
                '<button type="button" data-role="none" role="button" tabindex="0" />'
              ).text(t + 1);
            },
            dots: !1,
            dotsClass: "slick-dots",
            draggable: !0,
            easing: "linear",
            edgeFriction: 0.35,
            fade: !1,
            focusOnSelect: !1,
            infinite: !0,
            initialSlide: 0,
            lazyLoad: "ondemand",
            mobileFirst: !1,
            pauseOnHover: !0,
            pauseOnFocus: !0,
            pauseOnDotsHover: !1,
            respondTo: "window",
            responsive: null,
            rows: 1,
            rtl: !1,
            slide: "",
            slidesPerRow: 1,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 500,
            swipe: !0,
            swipeToSlide: !1,
            touchMove: !0,
            touchThreshold: 5,
            useCSS: !0,
            useTransform: !0,
            variableWidth: !1,
            vertical: !1,
            verticalSwiping: !1,
            waitForAnimate: !0,
            zIndex: 1e3
          }),
            (n.initials = {
              animating: !1,
              dragging: !1,
              autoPlayTimer: null,
              currentDirection: 0,
              currentLeft: null,
              currentSlide: 0,
              direction: 1,
              $dots: null,
              listWidth: null,
              listHeight: null,
              loadIndex: 0,
              $nextArrow: null,
              $prevArrow: null,
              slideCount: null,
              slideWidth: null,
              $slideTrack: null,
              $slides: null,
              sliding: !1,
              slideOffset: 0,
              swipeLeft: null,
              $list: null,
              touchObject: {},
              transformsEnabled: !1,
              unslicked: !1
            }),
            c.extend(n, n.initials),
            (n.activeBreakpoint = null),
            (n.animType = null),
            (n.animProp = null),
            (n.breakpoints = []),
            (n.breakpointSettings = []),
            (n.cssTransitions = !1),
            (n.focussed = !1),
            (n.interrupted = !1),
            (n.hidden = "hidden"),
            (n.paused = !0),
            (n.positionProp = null),
            (n.respondTo = null),
            (n.rowCount = 1),
            (n.shouldClick = !0),
            (n.$slider = c(e)),
            (n.$slidesCache = null),
            (n.transformType = null),
            (n.transitionType = null),
            (n.visibilityChange = "visibilitychange"),
            (n.windowWidth = 0),
            (n.windowTimer = null),
            (i = c(e).data("slick") || {}),
            (n.options = c.extend({}, n.defaults, t, i)),
            (n.currentSlide = n.options.initialSlide),
            (n.originalSettings = n.options),
            void 0 !== document.mozHidden
              ? ((n.hidden = "mozHidden"),
                (n.visibilityChange = "mozvisibilitychange"))
              : void 0 !== document.webkitHidden &&
                ((n.hidden = "webkitHidden"),
                (n.visibilityChange = "webkitvisibilitychange")),
            (n.autoPlay = c.proxy(n.autoPlay, n)),
            (n.autoPlayClear = c.proxy(n.autoPlayClear, n)),
            (n.autoPlayIterator = c.proxy(n.autoPlayIterator, n)),
            (n.changeSlide = c.proxy(n.changeSlide, n)),
            (n.clickHandler = c.proxy(n.clickHandler, n)),
            (n.selectHandler = c.proxy(n.selectHandler, n)),
            (n.setPosition = c.proxy(n.setPosition, n)),
            (n.swipeHandler = c.proxy(n.swipeHandler, n)),
            (n.dragHandler = c.proxy(n.dragHandler, n)),
            (n.keyHandler = c.proxy(n.keyHandler, n)),
            (n.instanceUid = o++),
            (n.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/),
            n.registerBreakpoints(),
            n.init(!0);
        }).prototype.activateADA = function() {
          this.$slideTrack
            .find(".slick-active")
            .attr({ "aria-hidden": "false" })
            .find("a, input, button, select")
            .attr({ tabindex: "0" });
        }),
        (s.prototype.addSlide = s.prototype.slickAdd = function(e, t, i) {
          var n = this;
          if ("boolean" == typeof t) (i = t), (t = null);
          else if (t < 0 || t >= n.slideCount) return !1;
          n.unload(),
            "number" == typeof t
              ? 0 === t && 0 === n.$slides.length
                ? c(e).appendTo(n.$slideTrack)
                : i
                ? c(e).insertBefore(n.$slides.eq(t))
                : c(e).insertAfter(n.$slides.eq(t))
              : !0 === i
              ? c(e).prependTo(n.$slideTrack)
              : c(e).appendTo(n.$slideTrack),
            (n.$slides = n.$slideTrack.children(this.options.slide)),
            n.$slideTrack.children(this.options.slide).detach(),
            n.$slideTrack.append(n.$slides),
            n.$slides.each(function(e, t) {
              c(t).attr("data-slick-index", e);
            }),
            (n.$slidesCache = n.$slides),
            n.reinit();
        }),
        (s.prototype.animateHeight = function() {
          var e = this;
          if (
            1 === e.options.slidesToShow &&
            !0 === e.options.adaptiveHeight &&
            !1 === e.options.vertical
          ) {
            var t = e.$slides.eq(e.currentSlide).outerHeight(!0);
            e.$list.animate({ height: t }, e.options.speed);
          }
        }),
        (s.prototype.animateSlide = function(e, t) {
          var i = {},
            n = this;
          n.animateHeight(),
            !0 === n.options.rtl && !1 === n.options.vertical && (e = -e),
            !1 === n.transformsEnabled
              ? !1 === n.options.vertical
                ? n.$slideTrack.animate(
                    { left: e },
                    n.options.speed,
                    n.options.easing,
                    t
                  )
                : n.$slideTrack.animate(
                    { top: e },
                    n.options.speed,
                    n.options.easing,
                    t
                  )
              : !1 === n.cssTransitions
              ? (!0 === n.options.rtl && (n.currentLeft = -n.currentLeft),
                c({ animStart: n.currentLeft }).animate(
                  { animStart: e },
                  {
                    duration: n.options.speed,
                    easing: n.options.easing,
                    step: function(e) {
                      (e = Math.ceil(e)),
                        !1 === n.options.vertical
                          ? (i[n.animType] = "translate(" + e + "px, 0px)")
                          : (i[n.animType] = "translate(0px," + e + "px)"),
                        n.$slideTrack.css(i);
                    },
                    complete: function() {
                      t && t.call();
                    }
                  }
                ))
              : (n.applyTransition(),
                (e = Math.ceil(e)),
                !1 === n.options.vertical
                  ? (i[n.animType] = "translate3d(" + e + "px, 0px, 0px)")
                  : (i[n.animType] = "translate3d(0px," + e + "px, 0px)"),
                n.$slideTrack.css(i),
                t &&
                  setTimeout(function() {
                    n.disableTransition(), t.call();
                  }, n.options.speed));
        }),
        (s.prototype.getNavTarget = function() {
          var e = this.options.asNavFor;
          return e && null !== e && (e = c(e).not(this.$slider)), e;
        }),
        (s.prototype.asNavFor = function(t) {
          var e = this.getNavTarget();
          null !== e &&
            "object" == typeof e &&
            e.each(function() {
              var e = c(this).slick("getSlick");
              e.unslicked || e.slideHandler(t, !0);
            });
        }),
        (s.prototype.applyTransition = function(e) {
          var t = this,
            i = {};
          !1 === t.options.fade
            ? (i[t.transitionType] =
                t.transformType +
                " " +
                t.options.speed +
                "ms " +
                t.options.cssEase)
            : (i[t.transitionType] =
                "opacity " + t.options.speed + "ms " + t.options.cssEase),
            !1 === t.options.fade ? t.$slideTrack.css(i) : t.$slides.eq(e).css(i);
        }),
        (s.prototype.autoPlay = function() {
          var e = this;
          e.autoPlayClear(),
            e.slideCount > e.options.slidesToShow &&
              (e.autoPlayTimer = setInterval(
                e.autoPlayIterator,
                e.options.autoplaySpeed
              ));
        }),
        (s.prototype.autoPlayClear = function() {
          this.autoPlayTimer && clearInterval(this.autoPlayTimer);
        }),
        (s.prototype.autoPlayIterator = function() {
          var e = this,
            t = e.currentSlide + e.options.slidesToScroll;
          e.paused ||
            e.interrupted ||
            e.focussed ||
            (!1 === e.options.infinite &&
              (1 === e.direction && e.currentSlide + 1 === e.slideCount - 1
                ? (e.direction = 0)
                : 0 === e.direction &&
                  ((t = e.currentSlide - e.options.slidesToScroll),
                  e.currentSlide - 1 == 0 && (e.direction = 1))),
            e.slideHandler(t));
        }),
        (s.prototype.buildArrows = function() {
          var e = this;
          !0 === e.options.arrows &&
            ((e.$prevArrow = c(e.options.prevArrow).addClass("slick-arrow")),
            (e.$nextArrow = c(e.options.nextArrow).addClass("slick-arrow")),
            e.slideCount > e.options.slidesToShow
              ? (e.$prevArrow
                  .removeClass("slick-hidden")
                  .removeAttr("aria-hidden tabindex"),
                e.$nextArrow
                  .removeClass("slick-hidden")
                  .removeAttr("aria-hidden tabindex"),
                e.htmlExpr.test(e.options.prevArrow) &&
                  e.$prevArrow.prependTo(e.options.appendArrows),
                e.htmlExpr.test(e.options.nextArrow) &&
                  e.$nextArrow.appendTo(e.options.appendArrows),
                !0 !== e.options.infinite &&
                  e.$prevArrow
                    .addClass("slick-disabled")
                    .attr("aria-disabled", "true"))
              : e.$prevArrow
                  .add(e.$nextArrow)
                  .addClass("slick-hidden")
                  .attr({ "aria-disabled": "true", tabindex: "-1" }));
        }),
        (s.prototype.buildDots = function() {
          var e,
            t,
            i = this;
          if (!0 === i.options.dots && i.slideCount > i.options.slidesToShow) {
            for (
              i.$slider.addClass("slick-dotted"),
                t = c("<ul />").addClass(i.options.dotsClass),
                e = 0;
              e <= i.getDotCount();
              e += 1
            )
              t.append(
                c("<li />").append(i.options.customPaging.call(this, i, e))
              );
            (i.$dots = t.appendTo(i.options.appendDots)),
              i.$dots
                .find("li")
                .first()
                .addClass("slick-active")
                .attr("aria-hidden", "false");
          }
        }),
        (s.prototype.buildOut = function() {
          var e = this;
          (e.$slides = e.$slider
            .children(e.options.slide + ":not(.slick-cloned)")
            .addClass("slick-slide")),
            (e.slideCount = e.$slides.length),
            e.$slides.each(function(e, t) {
              c(t)
                .attr("data-slick-index", e)
                .data("originalStyling", c(t).attr("style") || "");
            }),
            e.$slider.addClass("slick-slider"),
            (e.$slideTrack =
              0 === e.slideCount
                ? c('<div class="slick-track"/>').appendTo(e.$slider)
                : e.$slides.wrapAll('<div class="slick-track"/>').parent()),
            (e.$list = e.$slideTrack
              .wrap('<div aria-live="polite" class="slick-list"/>')
              .parent()),
            e.$slideTrack.css("opacity", 0),
            (!0 !== e.options.centerMode && !0 !== e.options.swipeToSlide) ||
              (e.options.slidesToScroll = 1),
            c("img[data-lazy]", e.$slider)
              .not("[src]")
              .addClass("slick-loading"),
            e.setupInfinite(),
            e.buildArrows(),
            e.buildDots(),
            e.updateDots(),
            e.setSlideClasses(
              "number" == typeof e.currentSlide ? e.currentSlide : 0
            ),
            !0 === e.options.draggable && e.$list.addClass("draggable");
        }),
        (s.prototype.buildRows = function() {
          var e,
            t,
            i,
            n,
            o,
            r,
            s,
            a = this;
          if (
            ((n = document.createDocumentFragment()),
            (r = a.$slider.children()),
            1 < a.options.rows)
          ) {
            for (
              s = a.options.slidesPerRow * a.options.rows,
                o = Math.ceil(r.length / s),
                e = 0;
              e < o;
              e++
            ) {
              var l = document.createElement("div");
              for (t = 0; t < a.options.rows; t++) {
                var c = document.createElement("div");
                for (i = 0; i < a.options.slidesPerRow; i++) {
                  var d = e * s + (t * a.options.slidesPerRow + i);
                  r.get(d) && c.appendChild(r.get(d));
                }
                l.appendChild(c);
              }
              n.appendChild(l);
            }
            a.$slider.empty().append(n),
              a.$slider
                .children()
                .children()
                .children()
                .css({
                  width: 100 / a.options.slidesPerRow + "%",
                  display: "inline-block"
                });
          }
        }),
        (s.prototype.checkResponsive = function(e, t) {
          var i,
            n,
            o,
            r = this,
            s = !1,
            a = r.$slider.width(),
            l = window.innerWidth || c(window).width();
          if (
            ("window" === r.respondTo
              ? (o = l)
              : "slider" === r.respondTo
              ? (o = a)
              : "min" === r.respondTo && (o = Math.min(l, a)),
            r.options.responsive &&
              r.options.responsive.length &&
              null !== r.options.responsive)
          ) {
            for (i in ((n = null), r.breakpoints))
              r.breakpoints.hasOwnProperty(i) &&
                (!1 === r.originalSettings.mobileFirst
                  ? o < r.breakpoints[i] && (n = r.breakpoints[i])
                  : o > r.breakpoints[i] && (n = r.breakpoints[i]));
            null !== n
              ? null !== r.activeBreakpoint
                ? (n !== r.activeBreakpoint || t) &&
                  ((r.activeBreakpoint = n),
                  "unslick" === r.breakpointSettings[n]
                    ? r.unslick(n)
                    : ((r.options = c.extend(
                        {},
                        r.originalSettings,
                        r.breakpointSettings[n]
                      )),
                      !0 === e && (r.currentSlide = r.options.initialSlide),
                      r.refresh(e)),
                  (s = n))
                : ((r.activeBreakpoint = n),
                  "unslick" === r.breakpointSettings[n]
                    ? r.unslick(n)
                    : ((r.options = c.extend(
                        {},
                        r.originalSettings,
                        r.breakpointSettings[n]
                      )),
                      !0 === e && (r.currentSlide = r.options.initialSlide),
                      r.refresh(e)),
                  (s = n))
              : null !== r.activeBreakpoint &&
                ((r.activeBreakpoint = null),
                (r.options = r.originalSettings),
                !0 === e && (r.currentSlide = r.options.initialSlide),
                r.refresh(e),
                (s = n)),
              e || !1 === s || r.$slider.trigger("breakpoint", [r, s]);
          }
        }),
        (s.prototype.changeSlide = function(e, t) {
          var i,
            n,
            o = this,
            r = c(e.currentTarget);
          switch (
            (r.is("a") && e.preventDefault(),
            r.is("li") || (r = r.closest("li")),
            (i =
              o.slideCount % o.options.slidesToScroll != 0
                ? 0
                : (o.slideCount - o.currentSlide) % o.options.slidesToScroll),
            e.data.message)
          ) {
            case "previous":
              (n =
                0 == i ? o.options.slidesToScroll : o.options.slidesToShow - i),
                o.slideCount > o.options.slidesToShow &&
                  o.slideHandler(o.currentSlide - n, !1, t);
              break;
            case "next":
              (n = 0 == i ? o.options.slidesToScroll : i),
                o.slideCount > o.options.slidesToShow &&
                  o.slideHandler(o.currentSlide + n, !1, t);
              break;
            case "index":
              var s =
                0 === e.data.index
                  ? 0
                  : e.data.index || r.index() * o.options.slidesToScroll;
              o.slideHandler(o.checkNavigable(s), !1, t),
                r.children().trigger("focus");
              break;
            default:
              return;
          }
        }),
        (s.prototype.checkNavigable = function(e) {
          var t, i;
          if (((i = 0), e > (t = this.getNavigableIndexes())[t.length - 1]))
            e = t[t.length - 1];
          else
            for (var n in t) {
              if (e < t[n]) {
                e = i;
                break;
              }
              i = t[n];
            }
          return e;
        }),
        (s.prototype.cleanUpEvents = function() {
          var e = this;
          e.options.dots &&
            null !== e.$dots &&
            c("li", e.$dots)
              .off("click.slick", e.changeSlide)
              .off("mouseenter.slick", c.proxy(e.interrupt, e, !0))
              .off("mouseleave.slick", c.proxy(e.interrupt, e, !1)),
            e.$slider.off("focus.slick blur.slick"),
            !0 === e.options.arrows &&
              e.slideCount > e.options.slidesToShow &&
              (e.$prevArrow && e.$prevArrow.off("click.slick", e.changeSlide),
              e.$nextArrow && e.$nextArrow.off("click.slick", e.changeSlide)),
            e.$list.off("touchstart.slick mousedown.slick", e.swipeHandler),
            e.$list.off("touchmove.slick mousemove.slick", e.swipeHandler),
            e.$list.off("touchend.slick mouseup.slick", e.swipeHandler),
            e.$list.off("touchcancel.slick mouseleave.slick", e.swipeHandler),
            e.$list.off("click.slick", e.clickHandler),
            c(document).off(e.visibilityChange, e.visibility),
            e.cleanUpSlideEvents(),
            !0 === e.options.accessibility &&
              e.$list.off("keydown.slick", e.keyHandler),
            !0 === e.options.focusOnSelect &&
              c(e.$slideTrack)
                .children()
                .off("click.slick", e.selectHandler),
            c(window).off(
              "orientationchange.slick.slick-" + e.instanceUid,
              e.orientationChange
            ),
            c(window).off("resize.slick.slick-" + e.instanceUid, e.resize),
            c("[draggable!=true]", e.$slideTrack).off(
              "dragstart",
              e.preventDefault
            ),
            c(window).off("load.slick.slick-" + e.instanceUid, e.setPosition),
            c(document).off("ready.slick.slick-" + e.instanceUid, e.setPosition);
        }),
        (s.prototype.cleanUpSlideEvents = function() {
          var e = this;
          e.$list.off("mouseenter.slick", c.proxy(e.interrupt, e, !0)),
            e.$list.off("mouseleave.slick", c.proxy(e.interrupt, e, !1));
        }),
        (s.prototype.cleanUpRows = function() {
          var e;
          1 < this.options.rows &&
            ((e = this.$slides.children().children()).removeAttr("style"),
            this.$slider.empty().append(e));
        }),
        (s.prototype.clickHandler = function(e) {
          !1 === this.shouldClick &&
            (e.stopImmediatePropagation(),
            e.stopPropagation(),
            e.preventDefault());
        }),
        (s.prototype.destroy = function(e) {
          var t = this;
          t.autoPlayClear(),
            (t.touchObject = {}),
            t.cleanUpEvents(),
            c(".slick-cloned", t.$slider).detach(),
            t.$dots && t.$dots.remove(),
            t.$prevArrow &&
              t.$prevArrow.length &&
              (t.$prevArrow
                .removeClass("slick-disabled slick-arrow slick-hidden")
                .removeAttr("aria-hidden aria-disabled tabindex")
                .css("display", ""),
              t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.remove()),
            t.$nextArrow &&
              t.$nextArrow.length &&
              (t.$nextArrow
                .removeClass("slick-disabled slick-arrow slick-hidden")
                .removeAttr("aria-hidden aria-disabled tabindex")
                .css("display", ""),
              t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.remove()),
            t.$slides &&
              (t.$slides
                .removeClass(
                  "slick-slide slick-active slick-center slick-visible slick-current"
                )
                .removeAttr("aria-hidden")
                .removeAttr("data-slick-index")
                .each(function() {
                  c(this).attr("style", c(this).data("originalStyling"));
                }),
              t.$slideTrack.children(this.options.slide).detach(),
              t.$slideTrack.detach(),
              t.$list.detach(),
              t.$slider.append(t.$slides)),
            t.cleanUpRows(),
            t.$slider.removeClass("slick-slider"),
            t.$slider.removeClass("slick-initialized"),
            t.$slider.removeClass("slick-dotted"),
            (t.unslicked = !0),
            e || t.$slider.trigger("destroy", [t]);
        }),
        (s.prototype.disableTransition = function(e) {
          var t = {};
          (t[this.transitionType] = ""),
            !1 === this.options.fade
              ? this.$slideTrack.css(t)
              : this.$slides.eq(e).css(t);
        }),
        (s.prototype.fadeSlide = function(e, t) {
          var i = this;
          !1 === i.cssTransitions
            ? (i.$slides.eq(e).css({ zIndex: i.options.zIndex }),
              i.$slides
                .eq(e)
                .animate({ opacity: 1 }, i.options.speed, i.options.easing, t))
            : (i.applyTransition(e),
              i.$slides.eq(e).css({ opacity: 1, zIndex: i.options.zIndex }),
              t &&
                setTimeout(function() {
                  i.disableTransition(e), t.call();
                }, i.options.speed));
        }),
        (s.prototype.fadeSlideOut = function(e) {
          var t = this;
          !1 === t.cssTransitions
            ? t.$slides
                .eq(e)
                .animate(
                  { opacity: 0, zIndex: t.options.zIndex - 2 },
                  t.options.speed,
                  t.options.easing
                )
            : (t.applyTransition(e),
              t.$slides.eq(e).css({ opacity: 0, zIndex: t.options.zIndex - 2 }));
        }),
        (s.prototype.filterSlides = s.prototype.slickFilter = function(e) {
          var t = this;
          null !== e &&
            ((t.$slidesCache = t.$slides),
            t.unload(),
            t.$slideTrack.children(this.options.slide).detach(),
            t.$slidesCache.filter(e).appendTo(t.$slideTrack),
            t.reinit());
        }),
        (s.prototype.focusHandler = function() {
          var i = this;
          i.$slider
            .off("focus.slick blur.slick")
            .on("focus.slick blur.slick", "*:not(.slick-arrow)", function(e) {
              e.stopImmediatePropagation();
              var t = c(this);
              setTimeout(function() {
                i.options.pauseOnFocus &&
                  ((i.focussed = t.is(":focus")), i.autoPlay());
              }, 0);
            });
        }),
        (s.prototype.getCurrent = s.prototype.slickCurrentSlide = function() {
          return this.currentSlide;
        }),
        (s.prototype.getDotCount = function() {
          var e = this,
            t = 0,
            i = 0,
            n = 0;
          if (!0 === e.options.infinite)
            for (; t < e.slideCount; )
              ++n,
                (t = i + e.options.slidesToScroll),
                (i +=
                  e.options.slidesToScroll <= e.options.slidesToShow
                    ? e.options.slidesToScroll
                    : e.options.slidesToShow);
          else if (!0 === e.options.centerMode) n = e.slideCount;
          else
            for (; t < e.slideCount; )
              ++n,
                (t = i + e.options.slidesToScroll),
                (i +=
                  e.options.slidesToScroll <= e.options.slidesToShow
                    ? e.options.slidesToScroll
                    : e.options.slidesToShow);
          return n - 1;
        }),
        (s.prototype.getLeft = function(e) {
          var t,
            i,
            n,
            o = this,
            r = 0;
          return (
            (o.slideOffset = 0),
            (i = o.$slides.first().outerHeight(!0)),
            !0 === o.options.infinite
              ? (o.slideCount > o.options.slidesToShow &&
                  ((o.slideOffset = o.slideWidth * o.options.slidesToShow * -1),
                  (r = i * o.options.slidesToShow * -1)),
                o.slideCount % o.options.slidesToScroll != 0 &&
                  e + o.options.slidesToScroll > o.slideCount &&
                  o.slideCount > o.options.slidesToShow &&
                  (r =
                    e > o.slideCount
                      ? ((o.slideOffset =
                          (o.options.slidesToShow - (e - o.slideCount)) *
                          o.slideWidth *
                          -1),
                        (o.options.slidesToShow - (e - o.slideCount)) * i * -1)
                      : ((o.slideOffset =
                          (o.slideCount % o.options.slidesToScroll) *
                          o.slideWidth *
                          -1),
                        (o.slideCount % o.options.slidesToScroll) * i * -1)))
              : e + o.options.slidesToShow > o.slideCount &&
                ((o.slideOffset =
                  (e + o.options.slidesToShow - o.slideCount) * o.slideWidth),
                (r = (e + o.options.slidesToShow - o.slideCount) * i)),
            o.slideCount <= o.options.slidesToShow && (r = o.slideOffset = 0),
            !0 === o.options.centerMode && !0 === o.options.infinite
              ? (o.slideOffset +=
                  o.slideWidth * Math.floor(o.options.slidesToShow / 2) -
                  o.slideWidth)
              : !0 === o.options.centerMode &&
                ((o.slideOffset = 0),
                (o.slideOffset +=
                  o.slideWidth * Math.floor(o.options.slidesToShow / 2))),
            (t =
              !1 === o.options.vertical
                ? e * o.slideWidth * -1 + o.slideOffset
                : e * i * -1 + r),
            !0 === o.options.variableWidth &&
              ((n =
                o.slideCount <= o.options.slidesToShow ||
                !1 === o.options.infinite
                  ? o.$slideTrack.children(".slick-slide").eq(e)
                  : o.$slideTrack
                      .children(".slick-slide")
                      .eq(e + o.options.slidesToShow)),
              (t =
                !0 === o.options.rtl
                  ? n[0]
                    ? -1 * (o.$slideTrack.width() - n[0].offsetLeft - n.width())
                    : 0
                  : n[0]
                  ? -1 * n[0].offsetLeft
                  : 0),
              !0 === o.options.centerMode &&
                ((n =
                  o.slideCount <= o.options.slidesToShow ||
                  !1 === o.options.infinite
                    ? o.$slideTrack.children(".slick-slide").eq(e)
                    : o.$slideTrack
                        .children(".slick-slide")
                        .eq(e + o.options.slidesToShow + 1)),
                (t =
                  !0 === o.options.rtl
                    ? n[0]
                      ? -1 * (o.$slideTrack.width() - n[0].offsetLeft - n.width())
                      : 0
                    : n[0]
                    ? -1 * n[0].offsetLeft
                    : 0),
                (t += (o.$list.width() - n.outerWidth()) / 2))),
            t
          );
        }),
        (s.prototype.getOption = s.prototype.slickGetOption = function(e) {
          return this.options[e];
        }),
        (s.prototype.getNavigableIndexes = function() {
          var e,
            t = this,
            i = 0,
            n = 0,
            o = [];
          for (
            e =
              !1 === t.options.infinite
                ? t.slideCount
                : ((i = -1 * t.options.slidesToScroll),
                  (n = -1 * t.options.slidesToScroll),
                  2 * t.slideCount);
            i < e;
  
          )
            o.push(i),
              (i = n + t.options.slidesToScroll),
              (n +=
                t.options.slidesToScroll <= t.options.slidesToShow
                  ? t.options.slidesToScroll
                  : t.options.slidesToShow);
          return o;
        }),
        (s.prototype.getSlick = function() {
          return this;
        }),
        (s.prototype.getSlideCount = function() {
          var i,
            n,
            o = this;
          return (
            (n =
              !0 === o.options.centerMode
                ? o.slideWidth * Math.floor(o.options.slidesToShow / 2)
                : 0),
            !0 === o.options.swipeToSlide
              ? (o.$slideTrack.find(".slick-slide").each(function(e, t) {
                  if (t.offsetLeft - n + c(t).outerWidth() / 2 > -1 * o.swipeLeft)
                    return (i = t), !1;
                }),
                Math.abs(c(i).attr("data-slick-index") - o.currentSlide) || 1)
              : o.options.slidesToScroll
          );
        }),
        (s.prototype.goTo = s.prototype.slickGoTo = function(e, t) {
          this.changeSlide({ data: { message: "index", index: parseInt(e) } }, t);
        }),
        (s.prototype.init = function(e) {
          var t = this;
          c(t.$slider).hasClass("slick-initialized") ||
            (c(t.$slider).addClass("slick-initialized"),
            t.buildRows(),
            t.buildOut(),
            t.setProps(),
            t.startLoad(),
            t.loadSlider(),
            t.initializeEvents(),
            t.updateArrows(),
            t.updateDots(),
            t.checkResponsive(!0),
            t.focusHandler()),
            e && t.$slider.trigger("init", [t]),
            !0 === t.options.accessibility && t.initADA(),
            t.options.autoplay && ((t.paused = !1), t.autoPlay());
        }),
        (s.prototype.initADA = function() {
          var t = this;
          t.$slides
            .add(t.$slideTrack.find(".slick-cloned"))
            .attr({ "aria-hidden": "true", tabindex: "-1" })
            .find("a, input, button, select")
            .attr({ tabindex: "-1" }),
            t.$slideTrack.attr("role", "listbox"),
            t.$slides.not(t.$slideTrack.find(".slick-cloned")).each(function(e) {
              c(this).attr({
                role: "option",
                "aria-describedby": "slick-slide" + t.instanceUid + e
              });
            }),
            null !== t.$dots &&
              t.$dots
                .attr("role", "tablist")
                .find("li")
                .each(function(e) {
                  c(this).attr({
                    role: "presentation",
                    "aria-selected": "false",
                    "aria-controls": "navigation" + t.instanceUid + e,
                    id: "slick-slide" + t.instanceUid + e
                  });
                })
                .first()
                .attr("aria-selected", "true")
                .end()
                .find("button")
                .attr("role", "button")
                .end()
                .closest("div")
                .attr("role", "toolbar"),
            t.activateADA();
        }),
        (s.prototype.initArrowEvents = function() {
          var e = this;
          !0 === e.options.arrows &&
            e.slideCount > e.options.slidesToShow &&
            (e.$prevArrow
              .off("click.slick")
              .on("click.slick", { message: "previous" }, e.changeSlide),
            e.$nextArrow
              .off("click.slick")
              .on("click.slick", { message: "next" }, e.changeSlide));
        }),
        (s.prototype.initDotEvents = function() {
          var e = this;
          !0 === e.options.dots &&
            e.slideCount > e.options.slidesToShow &&
            c("li", e.$dots).on(
              "click.slick",
              { message: "index" },
              e.changeSlide
            ),
            !0 === e.options.dots &&
              !0 === e.options.pauseOnDotsHover &&
              c("li", e.$dots)
                .on("mouseenter.slick", c.proxy(e.interrupt, e, !0))
                .on("mouseleave.slick", c.proxy(e.interrupt, e, !1));
        }),
        (s.prototype.initSlideEvents = function() {
          var e = this;
          e.options.pauseOnHover &&
            (e.$list.on("mouseenter.slick", c.proxy(e.interrupt, e, !0)),
            e.$list.on("mouseleave.slick", c.proxy(e.interrupt, e, !1)));
        }),
        (s.prototype.initializeEvents = function() {
          var e = this;
          e.initArrowEvents(),
            e.initDotEvents(),
            e.initSlideEvents(),
            e.$list.on(
              "touchstart.slick mousedown.slick",
              { action: "start" },
              e.swipeHandler
            ),
            e.$list.on(
              "touchmove.slick mousemove.slick",
              { action: "move" },
              e.swipeHandler
            ),
            e.$list.on(
              "touchend.slick mouseup.slick",
              { action: "end" },
              e.swipeHandler
            ),
            e.$list.on(
              "touchcancel.slick mouseleave.slick",
              { action: "end" },
              e.swipeHandler
            ),
            e.$list.on("click.slick", e.clickHandler),
            c(document).on(e.visibilityChange, c.proxy(e.visibility, e)),
            !0 === e.options.accessibility &&
              e.$list.on("keydown.slick", e.keyHandler),
            !0 === e.options.focusOnSelect &&
              c(e.$slideTrack)
                .children()
                .on("click.slick", e.selectHandler),
            c(window).on(
              "orientationchange.slick.slick-" + e.instanceUid,
              c.proxy(e.orientationChange, e)
            ),
            c(window).on(
              "resize.slick.slick-" + e.instanceUid,
              c.proxy(e.resize, e)
            ),
            c("[draggable!=true]", e.$slideTrack).on(
              "dragstart",
              e.preventDefault
            ),
            c(window).on("load.slick.slick-" + e.instanceUid, e.setPosition),
            c(document).on("ready.slick.slick-" + e.instanceUid, e.setPosition);
        }),
        (s.prototype.initUI = function() {
          var e = this;
          !0 === e.options.arrows &&
            e.slideCount > e.options.slidesToShow &&
            (e.$prevArrow.show(), e.$nextArrow.show()),
            !0 === e.options.dots &&
              e.slideCount > e.options.slidesToShow &&
              e.$dots.show();
        }),
        (s.prototype.keyHandler = function(e) {
          var t = this;
          e.target.tagName.match("TEXTAREA|INPUT|SELECT") ||
            (37 === e.keyCode && !0 === t.options.accessibility
              ? t.changeSlide({
                  data: { message: !0 === t.options.rtl ? "next" : "previous" }
                })
              : 39 === e.keyCode &&
                !0 === t.options.accessibility &&
                t.changeSlide({
                  data: { message: !0 === t.options.rtl ? "previous" : "next" }
                }));
        }),
        (s.prototype.lazyLoad = function() {
          var e,
            t,
            n = this;
          function i(e) {
            c("img[data-lazy]", e).each(function() {
              var e = c(this),
                t = c(this).attr("data-lazy"),
                i = document.createElement("img");
              (i.onload = function() {
                e.animate({ opacity: 0 }, 100, function() {
                  e.attr("src", t).animate({ opacity: 1 }, 200, function() {
                    e.removeAttr("data-lazy").removeClass("slick-loading");
                  }),
                    n.$slider.trigger("lazyLoaded", [n, e, t]);
                });
              }),
                (i.onerror = function() {
                  e
                    .removeAttr("data-lazy")
                    .removeClass("slick-loading")
                    .addClass("slick-lazyload-error"),
                    n.$slider.trigger("lazyLoadError", [n, e, t]);
                }),
                (i.src = t);
            });
          }
          !0 === n.options.centerMode
            ? (t =
                !0 === n.options.infinite
                  ? (e = n.currentSlide + (n.options.slidesToShow / 2 + 1)) +
                    n.options.slidesToShow +
                    2
                  : ((e = Math.max(
                      0,
                      n.currentSlide - (n.options.slidesToShow / 2 + 1)
                    )),
                    n.options.slidesToShow / 2 + 1 + 2 + n.currentSlide))
            : ((e = n.options.infinite
                ? n.options.slidesToShow + n.currentSlide
                : n.currentSlide),
              (t = Math.ceil(e + n.options.slidesToShow)),
              !0 === n.options.fade && (0 < e && e--, t <= n.slideCount && t++)),
            i(n.$slider.find(".slick-slide").slice(e, t)),
            n.slideCount <= n.options.slidesToShow
              ? i(n.$slider.find(".slick-slide"))
              : n.currentSlide >= n.slideCount - n.options.slidesToShow
              ? i(
                  n.$slider.find(".slick-cloned").slice(0, n.options.slidesToShow)
                )
              : 0 === n.currentSlide &&
                i(
                  n.$slider
                    .find(".slick-cloned")
                    .slice(-1 * n.options.slidesToShow)
                );
        }),
        (s.prototype.loadSlider = function() {
          var e = this;
          e.setPosition(),
            e.$slideTrack.css({ opacity: 1 }),
            e.$slider.removeClass("slick-loading"),
            e.initUI(),
            "progressive" === e.options.lazyLoad && e.progressiveLazyLoad();
        }),
        (s.prototype.next = s.prototype.slickNext = function() {
          this.changeSlide({ data: { message: "next" } });
        }),
        (s.prototype.orientationChange = function() {
          this.checkResponsive(), this.setPosition();
        }),
        (s.prototype.pause = s.prototype.slickPause = function() {
          this.autoPlayClear(), (this.paused = !0);
        }),
        (s.prototype.play = s.prototype.slickPlay = function() {
          var e = this;
          e.autoPlay(),
            (e.options.autoplay = !0),
            (e.paused = !1),
            (e.focussed = !1),
            (e.interrupted = !1);
        }),
        (s.prototype.postSlide = function(e) {
          var t = this;
          t.unslicked ||
            (t.$slider.trigger("afterChange", [t, e]),
            (t.animating = !1),
            t.setPosition(),
            (t.swipeLeft = null),
            t.options.autoplay && t.autoPlay(),
            !0 === t.options.accessibility && t.initADA());
        }),
        (s.prototype.prev = s.prototype.slickPrev = function() {
          this.changeSlide({ data: { message: "previous" } });
        }),
        (s.prototype.preventDefault = function(e) {
          e.preventDefault();
        }),
        (s.prototype.progressiveLazyLoad = function(e) {
          e = e || 1;
          var t,
            i,
            n,
            o = this,
            r = c("img[data-lazy]", o.$slider);
          r.length
            ? ((t = r.first()),
              (i = t.attr("data-lazy")),
              ((n = document.createElement("img")).onload = function() {
                t
                  .attr("src", i)
                  .removeAttr("data-lazy")
                  .removeClass("slick-loading"),
                  !0 === o.options.adaptiveHeight && o.setPosition(),
                  o.$slider.trigger("lazyLoaded", [o, t, i]),
                  o.progressiveLazyLoad();
              }),
              (n.onerror = function() {
                e < 3
                  ? setTimeout(function() {
                      o.progressiveLazyLoad(e + 1);
                    }, 500)
                  : (t
                      .removeAttr("data-lazy")
                      .removeClass("slick-loading")
                      .addClass("slick-lazyload-error"),
                    o.$slider.trigger("lazyLoadError", [o, t, i]),
                    o.progressiveLazyLoad());
              }),
              (n.src = i))
            : o.$slider.trigger("allImagesLoaded", [o]);
        }),
        (s.prototype.refresh = function(e) {
          var t,
            i,
            n = this;
          (i = n.slideCount - n.options.slidesToShow),
            !n.options.infinite && n.currentSlide > i && (n.currentSlide = i),
            n.slideCount <= n.options.slidesToShow && (n.currentSlide = 0),
            (t = n.currentSlide),
            n.destroy(!0),
            c.extend(n, n.initials, { currentSlide: t }),
            n.init(),
            e || n.changeSlide({ data: { message: "index", index: t } }, !1);
        }),
        (s.prototype.registerBreakpoints = function() {
          var e,
            t,
            i,
            n = this,
            o = n.options.responsive || null;
          if ("array" === c.type(o) && o.length) {
            for (e in ((n.respondTo = n.options.respondTo || "window"), o))
              if (
                ((i = n.breakpoints.length - 1),
                (t = o[e].breakpoint),
                o.hasOwnProperty(e))
              ) {
                for (; 0 <= i; )
                  n.breakpoints[i] &&
                    n.breakpoints[i] === t &&
                    n.breakpoints.splice(i, 1),
                    i--;
                n.breakpoints.push(t), (n.breakpointSettings[t] = o[e].settings);
              }
            n.breakpoints.sort(function(e, t) {
              return n.options.mobileFirst ? e - t : t - e;
            });
          }
        }),
        (s.prototype.reinit = function() {
          var e = this;
          (e.$slides = e.$slideTrack
            .children(e.options.slide)
            .addClass("slick-slide")),
            (e.slideCount = e.$slides.length),
            e.currentSlide >= e.slideCount &&
              0 !== e.currentSlide &&
              (e.currentSlide = e.currentSlide - e.options.slidesToScroll),
            e.slideCount <= e.options.slidesToShow && (e.currentSlide = 0),
            e.registerBreakpoints(),
            e.setProps(),
            e.setupInfinite(),
            e.buildArrows(),
            e.updateArrows(),
            e.initArrowEvents(),
            e.buildDots(),
            e.updateDots(),
            e.initDotEvents(),
            e.cleanUpSlideEvents(),
            e.initSlideEvents(),
            e.checkResponsive(!1, !0),
            !0 === e.options.focusOnSelect &&
              c(e.$slideTrack)
                .children()
                .on("click.slick", e.selectHandler),
            e.setSlideClasses(
              "number" == typeof e.currentSlide ? e.currentSlide : 0
            ),
            e.setPosition(),
            e.focusHandler(),
            (e.paused = !e.options.autoplay),
            e.autoPlay(),
            e.$slider.trigger("reInit", [e]);
        }),
        (s.prototype.resize = function() {
          var e = this;
          c(window).width() !== e.windowWidth &&
            (clearTimeout(e.windowDelay),
            (e.windowDelay = window.setTimeout(function() {
              (e.windowWidth = c(window).width()),
                e.checkResponsive(),
                e.unslicked || e.setPosition();
            }, 50)));
        }),
        (s.prototype.removeSlide = s.prototype.slickRemove = function(e, t, i) {
          var n = this;
          if (
            ((e =
              "boolean" == typeof e
                ? !0 === (t = e)
                  ? 0
                  : n.slideCount - 1
                : !0 === t
                ? --e
                : e),
            n.slideCount < 1 || e < 0 || e > n.slideCount - 1)
          )
            return !1;
          n.unload(),
            !0 === i
              ? n.$slideTrack.children().remove()
              : n.$slideTrack
                  .children(this.options.slide)
                  .eq(e)
                  .remove(),
            (n.$slides = n.$slideTrack.children(this.options.slide)),
            n.$slideTrack.children(this.options.slide).detach(),
            n.$slideTrack.append(n.$slides),
            (n.$slidesCache = n.$slides),
            n.reinit();
        }),
        (s.prototype.setCSS = function(e) {
          var t,
            i,
            n = this,
            o = {};
          !0 === n.options.rtl && (e = -e),
            (t = "left" == n.positionProp ? Math.ceil(e) + "px" : "0px"),
            (i = "top" == n.positionProp ? Math.ceil(e) + "px" : "0px"),
            (o[n.positionProp] = e),
            !1 === n.transformsEnabled ||
              (!(o = {}) === n.cssTransitions
                ? (o[n.animType] = "translate(" + t + ", " + i + ")")
                : (o[n.animType] = "translate3d(" + t + ", " + i + ", 0px)")),
            n.$slideTrack.css(o);
        }),
        (s.prototype.setDimensions = function() {
          var e = this;
          !1 === e.options.vertical
            ? !0 === e.options.centerMode &&
              e.$list.css({ padding: "0px " + e.options.centerPadding })
            : (e.$list.height(
                e.$slides.first().outerHeight(!0) * e.options.slidesToShow
              ),
              !0 === e.options.centerMode &&
                e.$list.css({ padding: e.options.centerPadding + " 0px" })),
            (e.listWidth = e.$list.width()),
            (e.listHeight = e.$list.height()),
            !1 === e.options.vertical && !1 === e.options.variableWidth
              ? ((e.slideWidth = Math.ceil(e.listWidth / e.options.slidesToShow)),
                e.$slideTrack.width(
                  Math.ceil(
                    e.slideWidth * e.$slideTrack.children(".slick-slide").length
                  )
                ))
              : !0 === e.options.variableWidth
              ? e.$slideTrack.width(5e3 * e.slideCount)
              : ((e.slideWidth = Math.ceil(e.listWidth)),
                e.$slideTrack.height(
                  Math.ceil(
                    e.$slides.first().outerHeight(!0) *
                      e.$slideTrack.children(".slick-slide").length
                  )
                ));
          var t = e.$slides.first().outerWidth(!0) - e.$slides.first().width();
          !1 === e.options.variableWidth &&
            e.$slideTrack.children(".slick-slide").width(e.slideWidth - t);
        }),
        (s.prototype.setFade = function() {
          var i,
            n = this;
          n.$slides.each(function(e, t) {
            (i = n.slideWidth * e * -1),
              !0 === n.options.rtl
                ? c(t).css({
                    position: "relative",
                    right: i,
                    top: 0,
                    zIndex: n.options.zIndex - 2,
                    opacity: 0
                  })
                : c(t).css({
                    position: "relative",
                    left: i,
                    top: 0,
                    zIndex: n.options.zIndex - 2,
                    opacity: 0
                  });
          }),
            n.$slides
              .eq(n.currentSlide)
              .css({ zIndex: n.options.zIndex - 1, opacity: 1 });
        }),
        (s.prototype.setHeight = function() {
          var e = this;
          if (
            1 === e.options.slidesToShow &&
            !0 === e.options.adaptiveHeight &&
            !1 === e.options.vertical
          ) {
            var t = e.$slides.eq(e.currentSlide).outerHeight(!0);
            e.$list.css("height", t);
          }
        }),
        (s.prototype.setOption = s.prototype.slickSetOption = function() {
          var e,
            t,
            i,
            n,
            o,
            r = this,
            s = !1;
          if (
            ("object" === c.type(arguments[0])
              ? ((i = arguments[0]), (s = arguments[1]), (o = "multiple"))
              : "string" === c.type(arguments[0]) &&
                ((i = arguments[0]),
                (n = arguments[1]),
                (s = arguments[2]),
                "responsive" === arguments[0] && "array" === c.type(arguments[1])
                  ? (o = "responsive")
                  : void 0 !== arguments[1] && (o = "single")),
            "single" === o)
          )
            r.options[i] = n;
          else if ("multiple" === o)
            c.each(i, function(e, t) {
              r.options[e] = t;
            });
          else if ("responsive" === o)
            for (t in n)
              if ("array" !== c.type(r.options.responsive))
                r.options.responsive = [n[t]];
              else {
                for (e = r.options.responsive.length - 1; 0 <= e; )
                  r.options.responsive[e].breakpoint === n[t].breakpoint &&
                    r.options.responsive.splice(e, 1),
                    e--;
                r.options.responsive.push(n[t]);
              }
          s && (r.unload(), r.reinit());
        }),
        (s.prototype.setPosition = function() {
          var e = this;
          e.setDimensions(),
            e.setHeight(),
            !1 === e.options.fade
              ? e.setCSS(e.getLeft(e.currentSlide))
              : e.setFade(),
            e.$slider.trigger("setPosition", [e]);
        }),
        (s.prototype.setProps = function() {
          var e = this,
            t = document.body.style;
          (e.positionProp = !0 === e.options.vertical ? "top" : "left"),
            "top" === e.positionProp
              ? e.$slider.addClass("slick-vertical")
              : e.$slider.removeClass("slick-vertical"),
            (void 0 === t.WebkitTransition &&
              void 0 === t.MozTransition &&
              void 0 === t.msTransition) ||
              (!0 === e.options.useCSS && (e.cssTransitions = !0)),
            e.options.fade &&
              ("number" == typeof e.options.zIndex
                ? e.options.zIndex < 3 && (e.options.zIndex = 3)
                : (e.options.zIndex = e.defaults.zIndex)),
            void 0 !== t.OTransform &&
              ((e.animType = "OTransform"),
              (e.transformType = "-o-transform"),
              (e.transitionType = "OTransition"),
              void 0 === t.perspectiveProperty &&
                void 0 === t.webkitPerspective &&
                (e.animType = !1)),
            void 0 !== t.MozTransform &&
              ((e.animType = "MozTransform"),
              (e.transformType = "-moz-transform"),
              (e.transitionType = "MozTransition"),
              void 0 === t.perspectiveProperty &&
                void 0 === t.MozPerspective &&
                (e.animType = !1)),
            void 0 !== t.webkitTransform &&
              ((e.animType = "webkitTransform"),
              (e.transformType = "-webkit-transform"),
              (e.transitionType = "webkitTransition"),
              void 0 === t.perspectiveProperty &&
                void 0 === t.webkitPerspective &&
                (e.animType = !1)),
            void 0 !== t.msTransform &&
              ((e.animType = "msTransform"),
              (e.transformType = "-ms-transform"),
              (e.transitionType = "msTransition"),
              void 0 === t.msTransform && (e.animType = !1)),
            void 0 !== t.transform &&
              !1 !== e.animType &&
              ((e.animType = "transform"),
              (e.transformType = "transform"),
              (e.transitionType = "transition")),
            (e.transformsEnabled =
              e.options.useTransform && null !== e.animType && !1 !== e.animType);
        }),
        (s.prototype.setSlideClasses = function(e) {
          var t,
            i,
            n,
            o,
            r = this;
          (i = r.$slider
            .find(".slick-slide")
            .removeClass("slick-active slick-center slick-current")
            .attr("aria-hidden", "true")),
            r.$slides.eq(e).addClass("slick-current"),
            !0 === r.options.centerMode
              ? ((t = Math.floor(r.options.slidesToShow / 2)),
                !0 === r.options.infinite &&
                  (t <= e && e <= r.slideCount - 1 - t
                    ? r.$slides
                        .slice(e - t, e + t + 1)
                        .addClass("slick-active")
                        .attr("aria-hidden", "false")
                    : ((n = r.options.slidesToShow + e),
                      i
                        .slice(n - t + 1, n + t + 2)
                        .addClass("slick-active")
                        .attr("aria-hidden", "false")),
                  0 === e
                    ? i
                        .eq(i.length - 1 - r.options.slidesToShow)
                        .addClass("slick-center")
                    : e === r.slideCount - 1 &&
                      i.eq(r.options.slidesToShow).addClass("slick-center")),
                r.$slides.eq(e).addClass("slick-center"))
              : 0 <= e && e <= r.slideCount - r.options.slidesToShow
              ? r.$slides
                  .slice(e, e + r.options.slidesToShow)
                  .addClass("slick-active")
                  .attr("aria-hidden", "false")
              : i.length <= r.options.slidesToShow
              ? i.addClass("slick-active").attr("aria-hidden", "false")
              : ((o = r.slideCount % r.options.slidesToShow),
                (n = !0 === r.options.infinite ? r.options.slidesToShow + e : e),
                r.options.slidesToShow == r.options.slidesToScroll &&
                r.slideCount - e < r.options.slidesToShow
                  ? i
                      .slice(n - (r.options.slidesToShow - o), n + o)
                      .addClass("slick-active")
                      .attr("aria-hidden", "false")
                  : i
                      .slice(n, n + r.options.slidesToShow)
                      .addClass("slick-active")
                      .attr("aria-hidden", "false")),
            "ondemand" === r.options.lazyLoad && r.lazyLoad();
        }),
        (s.prototype.setupInfinite = function() {
          var e,
            t,
            i,
            n = this;
          if (
            (!0 === n.options.fade && (n.options.centerMode = !1),
            !0 === n.options.infinite &&
              !1 === n.options.fade &&
              ((t = null), n.slideCount > n.options.slidesToShow))
          ) {
            for (
              i =
                !0 === n.options.centerMode
                  ? n.options.slidesToShow + 1
                  : n.options.slidesToShow,
                e = n.slideCount;
              e > n.slideCount - i;
              e -= 1
            )
              (t = e - 1),
                c(n.$slides[t])
                  .clone(!0)
                  .attr("id", "")
                  .attr("data-slick-index", t - n.slideCount)
                  .prependTo(n.$slideTrack)
                  .addClass("slick-cloned");
            for (e = 0; e < i; e += 1)
              (t = e),
                c(n.$slides[t])
                  .clone(!0)
                  .attr("id", "")
                  .attr("data-slick-index", t + n.slideCount)
                  .appendTo(n.$slideTrack)
                  .addClass("slick-cloned");
            n.$slideTrack
              .find(".slick-cloned")
              .find("[id]")
              .each(function() {
                c(this).attr("id", "");
              });
          }
        }),
        (s.prototype.interrupt = function(e) {
          e || this.autoPlay(), (this.interrupted = e);
        }),
        (s.prototype.selectHandler = function(e) {
          var t = this,
            i = c(e.target).is(".slick-slide")
              ? c(e.target)
              : c(e.target).parents(".slick-slide"),
            n = parseInt(i.attr("data-slick-index"));
          if ((n || (n = 0), t.slideCount <= t.options.slidesToShow))
            return t.setSlideClasses(n), void t.asNavFor(n);
          t.slideHandler(n);
        }),
        (s.prototype.slideHandler = function(e, t, i) {
          var n,
            o,
            r,
            s,
            a,
            l,
            c = this;
          if (
            ((t = t || !1),
            (!0 !== c.animating || !0 !== c.options.waitForAnimate) &&
              !(
                (!0 === c.options.fade && c.currentSlide === e) ||
                c.slideCount <= c.options.slidesToShow
              ))
          )
            if (
              (!1 === t && c.asNavFor(e),
              (n = e),
              (a = c.getLeft(n)),
              (s = c.getLeft(c.currentSlide)),
              (c.currentLeft = null === c.swipeLeft ? s : c.swipeLeft),
              !1 === c.options.infinite &&
                !1 === c.options.centerMode &&
                (e < 0 || e > c.getDotCount() * c.options.slidesToScroll))
            )
              !1 === c.options.fade &&
                ((n = c.currentSlide),
                !0 !== i
                  ? c.animateSlide(s, function() {
                      c.postSlide(n);
                    })
                  : c.postSlide(n));
            else if (
              !1 === c.options.infinite &&
              !0 === c.options.centerMode &&
              (e < 0 || e > c.slideCount - c.options.slidesToScroll)
            )
              !1 === c.options.fade &&
                ((n = c.currentSlide),
                !0 !== i
                  ? c.animateSlide(s, function() {
                      c.postSlide(n);
                    })
                  : c.postSlide(n));
            else {
              if (
                (c.options.autoplay && clearInterval(c.autoPlayTimer),
                (o =
                  n < 0
                    ? c.slideCount % c.options.slidesToScroll != 0
                      ? c.slideCount - (c.slideCount % c.options.slidesToScroll)
                      : c.slideCount + n
                    : n >= c.slideCount
                    ? c.slideCount % c.options.slidesToScroll != 0
                      ? 0
                      : n - c.slideCount
                    : n),
                (c.animating = !0),
                c.$slider.trigger("beforeChange", [c, c.currentSlide, o]),
                (r = c.currentSlide),
                (c.currentSlide = o),
                c.setSlideClasses(c.currentSlide),
                c.options.asNavFor &&
                  (l = (l = c.getNavTarget()).slick("getSlick")).slideCount <=
                    l.options.slidesToShow &&
                  l.setSlideClasses(c.currentSlide),
                c.updateDots(),
                c.updateArrows(),
                !0 === c.options.fade)
              )
                return (
                  !0 !== i
                    ? (c.fadeSlideOut(r),
                      c.fadeSlide(o, function() {
                        c.postSlide(o);
                      }))
                    : c.postSlide(o),
                  void c.animateHeight()
                );
              !0 !== i
                ? c.animateSlide(a, function() {
                    c.postSlide(o);
                  })
                : c.postSlide(o);
            }
        }),
        (s.prototype.startLoad = function() {
          var e = this;
          !0 === e.options.arrows &&
            e.slideCount > e.options.slidesToShow &&
            (e.$prevArrow.hide(), e.$nextArrow.hide()),
            !0 === e.options.dots &&
              e.slideCount > e.options.slidesToShow &&
              e.$dots.hide(),
            e.$slider.addClass("slick-loading");
        }),
        (s.prototype.swipeDirection = function() {
          var e,
            t,
            i,
            n,
            o = this;
          return (
            (e = o.touchObject.startX - o.touchObject.curX),
            (t = o.touchObject.startY - o.touchObject.curY),
            (i = Math.atan2(t, e)),
            (n = Math.round((180 * i) / Math.PI)) < 0 && (n = 360 - Math.abs(n)),
            n <= 45 && 0 <= n
              ? !1 === o.options.rtl
                ? "left"
                : "right"
              : n <= 360 && 315 <= n
              ? !1 === o.options.rtl
                ? "left"
                : "right"
              : 135 <= n && n <= 225
              ? !1 === o.options.rtl
                ? "right"
                : "left"
              : !0 === o.options.verticalSwiping
              ? 35 <= n && n <= 135
                ? "down"
                : "up"
              : "vertical"
          );
        }),
        (s.prototype.swipeEnd = function(e) {
          var t,
            i,
            n = this;
          if (
            ((n.dragging = !1),
            (n.interrupted = !1),
            (n.shouldClick = !(10 < n.touchObject.swipeLength)),
            void 0 === n.touchObject.curX)
          )
            return !1;
          if (
            (!0 === n.touchObject.edgeHit &&
              n.$slider.trigger("edge", [n, n.swipeDirection()]),
            n.touchObject.swipeLength >= n.touchObject.minSwipe)
          ) {
            switch ((i = n.swipeDirection())) {
              case "left":
              case "down":
                (t = n.options.swipeToSlide
                  ? n.checkNavigable(n.currentSlide + n.getSlideCount())
                  : n.currentSlide + n.getSlideCount()),
                  (n.currentDirection = 0);
                break;
              case "right":
              case "up":
                (t = n.options.swipeToSlide
                  ? n.checkNavigable(n.currentSlide - n.getSlideCount())
                  : n.currentSlide - n.getSlideCount()),
                  (n.currentDirection = 1);
            }
            "vertical" != i &&
              (n.slideHandler(t),
              (n.touchObject = {}),
              n.$slider.trigger("swipe", [n, i]));
          } else
            n.touchObject.startX !== n.touchObject.curX &&
              (n.slideHandler(n.currentSlide), (n.touchObject = {}));
        }),
        (s.prototype.swipeHandler = function(e) {
          var t = this;
          if (
            !(
              !1 === t.options.swipe ||
              ("ontouchend" in document && !1 === t.options.swipe) ||
              (!1 === t.options.draggable && -1 !== e.type.indexOf("mouse"))
            )
          )
            switch (
              ((t.touchObject.fingerCount =
                e.originalEvent && void 0 !== e.originalEvent.touches
                  ? e.originalEvent.touches.length
                  : 1),
              (t.touchObject.minSwipe = t.listWidth / t.options.touchThreshold),
              !0 === t.options.verticalSwiping &&
                (t.touchObject.minSwipe =
                  t.listHeight / t.options.touchThreshold),
              e.data.action)
            ) {
              case "start":
                t.swipeStart(e);
                break;
              case "move":
                t.swipeMove(e);
                break;
              case "end":
                t.swipeEnd(e);
            }
        }),
        (s.prototype.swipeMove = function(e) {
          var t,
            i,
            n,
            o,
            r,
            s = this;
          return (
            (r = void 0 !== e.originalEvent ? e.originalEvent.touches : null),
            !(!s.dragging || (r && 1 !== r.length)) &&
              ((t = s.getLeft(s.currentSlide)),
              (s.touchObject.curX = void 0 !== r ? r[0].pageX : e.clientX),
              (s.touchObject.curY = void 0 !== r ? r[0].pageY : e.clientY),
              (s.touchObject.swipeLength = Math.round(
                Math.sqrt(Math.pow(s.touchObject.curX - s.touchObject.startX, 2))
              )),
              !0 === s.options.verticalSwiping &&
                (s.touchObject.swipeLength = Math.round(
                  Math.sqrt(
                    Math.pow(s.touchObject.curY - s.touchObject.startY, 2)
                  )
                )),
              "vertical" !== (i = s.swipeDirection())
                ? (void 0 !== e.originalEvent &&
                    4 < s.touchObject.swipeLength &&
                    e.preventDefault(),
                  (o =
                    (!1 === s.options.rtl ? 1 : -1) *
                    (s.touchObject.curX > s.touchObject.startX ? 1 : -1)),
                  !0 === s.options.verticalSwiping &&
                    (o = s.touchObject.curY > s.touchObject.startY ? 1 : -1),
                  (n = s.touchObject.swipeLength),
                  (s.touchObject.edgeHit = !1) === s.options.infinite &&
                    ((0 === s.currentSlide && "right" === i) ||
                      (s.currentSlide >= s.getDotCount() && "left" === i)) &&
                    ((n = s.touchObject.swipeLength * s.options.edgeFriction),
                    (s.touchObject.edgeHit = !0)),
                  !1 === s.options.vertical
                    ? (s.swipeLeft = t + n * o)
                    : (s.swipeLeft =
                        t + n * (s.$list.height() / s.listWidth) * o),
                  !0 === s.options.verticalSwiping && (s.swipeLeft = t + n * o),
                  !0 !== s.options.fade &&
                    !1 !== s.options.touchMove &&
                    (!0 === s.animating
                      ? ((s.swipeLeft = null), !1)
                      : void s.setCSS(s.swipeLeft)))
                : void 0)
          );
        }),
        (s.prototype.swipeStart = function(e) {
          var t,
            i = this;
          if (
            ((i.interrupted = !0),
            1 !== i.touchObject.fingerCount ||
              i.slideCount <= i.options.slidesToShow)
          )
            return !(i.touchObject = {});
          void 0 !== e.originalEvent &&
            void 0 !== e.originalEvent.touches &&
            (t = e.originalEvent.touches[0]),
            (i.touchObject.startX = i.touchObject.curX =
              void 0 !== t ? t.pageX : e.clientX),
            (i.touchObject.startY = i.touchObject.curY =
              void 0 !== t ? t.pageY : e.clientY),
            (i.dragging = !0);
        }),
        (s.prototype.unfilterSlides = s.prototype.slickUnfilter = function() {
          var e = this;
          null !== e.$slidesCache &&
            (e.unload(),
            e.$slideTrack.children(this.options.slide).detach(),
            e.$slidesCache.appendTo(e.$slideTrack),
            e.reinit());
        }),
        (s.prototype.unload = function() {
          var e = this;
          c(".slick-cloned", e.$slider).remove(),
            e.$dots && e.$dots.remove(),
            e.$prevArrow &&
              e.htmlExpr.test(e.options.prevArrow) &&
              e.$prevArrow.remove(),
            e.$nextArrow &&
              e.htmlExpr.test(e.options.nextArrow) &&
              e.$nextArrow.remove(),
            e.$slides
              .removeClass("slick-slide slick-active slick-visible slick-current")
              .attr("aria-hidden", "true")
              .css("width", "");
        }),
        (s.prototype.unslick = function(e) {
          this.$slider.trigger("unslick", [this, e]), this.destroy();
        }),
        (s.prototype.updateArrows = function() {
          var e = this;
          Math.floor(e.options.slidesToShow / 2),
            !0 === e.options.arrows &&
              e.slideCount > e.options.slidesToShow &&
              !e.options.infinite &&
              (e.$prevArrow
                .removeClass("slick-disabled")
                .attr("aria-disabled", "false"),
              e.$nextArrow
                .removeClass("slick-disabled")
                .attr("aria-disabled", "false"),
              0 === e.currentSlide
                ? (e.$prevArrow
                    .addClass("slick-disabled")
                    .attr("aria-disabled", "true"),
                  e.$nextArrow
                    .removeClass("slick-disabled")
                    .attr("aria-disabled", "false"))
                : e.currentSlide >= e.slideCount - e.options.slidesToShow &&
                  !1 === e.options.centerMode
                ? (e.$nextArrow
                    .addClass("slick-disabled")
                    .attr("aria-disabled", "true"),
                  e.$prevArrow
                    .removeClass("slick-disabled")
                    .attr("aria-disabled", "false"))
                : e.currentSlide >= e.slideCount - 1 &&
                  !0 === e.options.centerMode &&
                  (e.$nextArrow
                    .addClass("slick-disabled")
                    .attr("aria-disabled", "true"),
                  e.$prevArrow
                    .removeClass("slick-disabled")
                    .attr("aria-disabled", "false")));
        }),
        (s.prototype.updateDots = function() {
          var e = this;
          null !== e.$dots &&
            (e.$dots
              .find("li")
              .removeClass("slick-active")
              .attr("aria-hidden", "true"),
            e.$dots
              .find("li")
              .eq(Math.floor(e.currentSlide / e.options.slidesToScroll))
              .addClass("slick-active")
              .attr("aria-hidden", "false"));
        }),
        (s.prototype.visibility = function() {
          this.options.autoplay &&
            (document[this.hidden]
              ? (this.interrupted = !0)
              : (this.interrupted = !1));
        }),
        (c.fn.slick = function() {
          var e,
            t,
            i = this,
            n = arguments[0],
            o = Array.prototype.slice.call(arguments, 1),
            r = i.length;
          for (e = 0; e < r; e++)
            if (
              ("object" == typeof n || void 0 === n
                ? (i[e].slick = new s(i[e], n))
                : (t = i[e].slick[n].apply(i[e].slick, o)),
              void 0 !== t)
            )
              return t;
          return i;
        });
    }),
    function() {
      var I, L;
      (I = window.jQuery),
        (L = I(window)),
        (I.fn.stick_in_parent = function(e) {
          var $, t, S, i, n, T, o, C, x, r, A, E, O;
          for (
            null == e && (e = {}),
              O = e.sticky_class,
              T = e.inner_scrolling,
              E = e.recalc_every,
              A = e.parent,
              x = e.offset_top,
              C = e.spacer,
              S = e.bottoming,
              null == x && (x = 0),
              null == A && (A = void 0),
              null == T && (T = !0),
              null == O && (O = "is_stuck"),
              $ = I(document),
              null == S && (S = !0),
              r = function(e) {
                var t, i;
                return window.getComputedStyle
                  ? (e[0],
                    (t = window.getComputedStyle(e[0])),
                    (i =
                      parseFloat(t.getPropertyValue("width")) +
                      parseFloat(t.getPropertyValue("margin-left")) +
                      parseFloat(t.getPropertyValue("margin-right"))),
                    "border-box" !== t.getPropertyValue("box-sizing") &&
                      (i +=
                        parseFloat(t.getPropertyValue("border-left-width")) +
                        parseFloat(t.getPropertyValue("border-right-width")) +
                        parseFloat(t.getPropertyValue("padding-left")) +
                        parseFloat(t.getPropertyValue("padding-right"))),
                    i)
                  : e.outerWidth(!0);
              },
              i = function(s, a, l, c, d, u, p, h) {
                var f, e, g, m, v, y, w, b, t, _, k, n;
                if (!s.data("sticky_kit")) {
                  if (
                    (s.data("sticky_kit", !0),
                    (v = $.height()),
                    (w = s.parent()),
                    null != A && (w = w.closest(A)),
                    !w.length)
                  )
                    throw "failed to find stick parent";
                  if (
                    ((f = g = !1),
                    (k = null != C ? C && s.closest(C) : I("<div />")) &&
                      k.css("position", s.css("position")),
                    (b = function() {
                      var e, t, i;
                      if (!h)
                        return (
                          (v = $.height()),
                          (e = parseInt(w.css("border-top-width"), 10)),
                          (t = parseInt(w.css("padding-top"), 10)),
                          (a = parseInt(w.css("padding-bottom"), 10)),
                          (l = w.offset().top + e + t),
                          (c = w.height()),
                          g &&
                            ((f = g = !1),
                            null == C && (s.insertAfter(k), k.detach()),
                            s
                              .css({
                                position: "",
                                top: "",
                                width: "",
                                bottom: ""
                              })
                              .removeClass(O),
                            (i = !0)),
                          (d =
                            s.offset().top -
                            (parseInt(s.css("margin-top"), 10) || 0) -
                            x),
                          (u = s.outerHeight(!0)),
                          (p = s.css("float")),
                          k &&
                            k.css({
                              width: r(s),
                              height: u,
                              display: s.css("display"),
                              "vertical-align": s.css("vertical-align"),
                              float: p
                            }),
                          i ? n() : void 0
                        );
                    })(),
                    u !== c)
                  )
                    return (
                      (m = void 0),
                      (y = x),
                      (_ = E),
                      (n = function() {
                        var e, t, i, n, o, r;
                        if (!h)
                          return (
                            (i = !1),
                            null != _ &&
                              (_ -= 1) <= 0 &&
                              ((_ = E), b(), (i = !0)),
                            i || $.height() === v || (b(), (i = !0)),
                            (n = L.scrollTop()),
                            null != m && (t = n - m),
                            (m = n),
                            g
                              ? (S &&
                                  ((o = c + l < n + u + y),
                                  f &&
                                    !o &&
                                    ((f = !1),
                                    s
                                      .css({
                                        position: "fixed",
                                        bottom: "",
                                        top: y
                                      })
                                      .trigger("sticky_kit:unbottom"))),
                                n < d &&
                                  ((g = !1),
                                  (y = x),
                                  null == C &&
                                    (("left" !== p && "right" !== p) ||
                                      s.insertAfter(k),
                                    k.detach()),
                                  (e = { position: "", width: "", top: "" }),
                                  s
                                    .css(e)
                                    .removeClass(O)
                                    .trigger("sticky_kit:unstick")),
                                T &&
                                  (r = L.height()) < u + x &&
                                  (f ||
                                    ((y -= t),
                                    (y = Math.max(r - u, y)),
                                    (y = Math.min(x, y)),
                                    g && s.css({ top: y + "px" }))))
                              : d < n &&
                                ((g = !0),
                                ((e = { position: "fixed", top: y }).width =
                                  "border-box" === s.css("box-sizing")
                                    ? s.outerWidth() + "px"
                                    : s.width() + "px"),
                                s.css(e).addClass(O),
                                null == C &&
                                  (s.after(k),
                                  ("left" !== p && "right" !== p) || k.append(s)),
                                s.trigger("sticky_kit:stick")),
                            g &&
                            S &&
                            (null == o && (o = c + l < n + u + y), !f && o)
                              ? ((f = !0),
                                "static" === w.css("position") &&
                                  w.css({ position: "relative" }),
                                s
                                  .css({
                                    position: "absolute",
                                    bottom: a,
                                    top: "auto"
                                  })
                                  .trigger("sticky_kit:bottom"))
                              : void 0
                          );
                      }),
                      (t = function() {
                        return b(), n();
                      }),
                      (e = function() {
                        if (
                          ((h = !0),
                          L.off("touchmove", n),
                          L.off("scroll", n),
                          L.off("resize", t),
                          I(document.body).off("sticky_kit:recalc", t),
                          s.off("sticky_kit:detach", e),
                          s.removeData("sticky_kit"),
                          s.css({ position: "", bottom: "", top: "", width: "" }),
                          w.position("position", ""),
                          g)
                        )
                          return (
                            null == C &&
                              (("left" !== p && "right" !== p) ||
                                s.insertAfter(k),
                              k.remove()),
                            s.removeClass(O)
                          );
                      }),
                      L.on("touchmove", n),
                      L.on("scroll", n),
                      L.on("resize", t),
                      I(document.body).on("sticky_kit:recalc", t),
                      s.on("sticky_kit:detach", e),
                      setTimeout(n, 0)
                    );
                }
              },
              n = 0,
              o = this.length;
            n < o;
            n++
          )
            (t = this[n]), i(I(t));
          return this;
        });
    }.call(this),
    (function(e, t) {
      "function" == typeof define && define.amd
        ? define([], function() {
            return (e.svg4everybody = t());
          })
        : "object" == typeof module && module.exports
        ? (module.exports = t())
        : (e.svg4everybody = t());
    })(this, function() {
      function m(e, t, i) {
        if (i) {
          var n = document.createDocumentFragment(),
            o = !t.hasAttribute("viewBox") && i.getAttribute("viewBox");
          o && t.setAttribute("viewBox", o);
          for (var r = i.cloneNode(!0); r.childNodes.length; )
            n.appendChild(r.firstChild);
          e.appendChild(n);
        }
      }
      function v(n) {
        (n.onreadystatechange = function() {
          if (4 === n.readyState) {
            var i = n._cachedDocument;
            i ||
              (((i = n._cachedDocument = document.implementation.createHTMLDocument(
                ""
              )).body.innerHTML = n.responseText),
              (n._cachedTarget = {})),
              n._embeds.splice(0).map(function(e) {
                var t = n._cachedTarget[e.id];
                t || (t = n._cachedTarget[e.id] = i.getElementById(e.id)),
                  m(e.parent, e.svg, t);
              });
          }
        }),
          n.onreadystatechange();
      }
      function y(e) {
        for (
          var t = e;
          "svg" !== t.nodeName.toLowerCase() && (t = t.parentNode);
  
        );
        return t;
      }
      return function(e) {
        var d,
          u = Object(e),
          t = window.top !== window.self;
        d =
          "polyfill" in u
            ? u.polyfill
            : /\bTrident\/[567]\b|\bMSIE (?:9|10)\.0\b/.test(
                navigator.userAgent
              ) ||
              (navigator.userAgent.match(/\bEdge\/12\.(\d+)\b/) || [])[1] <
                10547 ||
              (navigator.userAgent.match(/\bAppleWebKit\/(\d+)\b/) || [])[1] <
                537 ||
              (/\bEdge\/.(\d+)\b/.test(navigator.userAgent) && t);
        var p = {},
          h = window.requestAnimationFrame || setTimeout,
          f = document.getElementsByTagName("use"),
          g = 0;
        d &&
          (function e() {
            for (var t = 0; t < f.length; ) {
              var i = f[t],
                n = i.parentNode,
                o = y(n),
                r = i.getAttribute("xlink:href") || i.getAttribute("href");
              if (
                (!r && u.attributeName && (r = i.getAttribute(u.attributeName)),
                o && r)
              ) {
                if (d)
                  if (!u.validate || u.validate(r, o, i)) {
                    n.removeChild(i);
                    var s = r.split("#"),
                      a = s.shift(),
                      l = s.join("#");
                    if (a.length) {
                      var c = p[a];
                      c ||
                        ((c = p[a] = new XMLHttpRequest()).open("GET", a),
                        c.send(),
                        (c._embeds = [])),
                        c._embeds.push({ parent: n, svg: o, id: l }),
                        v(c);
                    } else m(n, o, document.getElementById(l));
                  } else ++t, ++g;
              } else ++t;
            }
            (!f.length || 0 < f.length - g) && h(e, 67);
          })();
      };
    }),
    (function(e, t) {
      "object" == typeof exports && "undefined" != typeof module
        ? (module.exports = t(require("popper.js")))
        : "function" == typeof define && define.amd
        ? define(["popper.js"], t)
        : (e.Tooltip = t(e.Popper));
    })(this, function(r) {
      "use strict";
      r = r && r.hasOwnProperty("default") ? r.default : r;
      var e = (function() {
          function n(e, t) {
            for (var i = 0; i < t.length; i++) {
              var n = t[i];
              (n.enumerable = n.enumerable || !1),
                (n.configurable = !0),
                "value" in n && (n.writable = !0),
                Object.defineProperty(e, n.key, n);
            }
          }
          return function(e, t, i) {
            return t && n(e.prototype, t), i && n(e, i), e;
          };
        })(),
        s =
          Object.assign ||
          function(e) {
            for (var t = 1; t < arguments.length; t++) {
              var i = arguments[t];
              for (var n in i)
                Object.prototype.hasOwnProperty.call(i, n) && (e[n] = i[n]);
            }
            return e;
          },
        o = {
          container: !1,
          delay: 0,
          html: !1,
          placement: "top",
          title: "",
          template:
            '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
          trigger: "hover focus",
          offset: 0,
          arrowSelector: ".tooltip-arrow, .tooltip__arrow",
          innerSelector: ".tooltip-inner, .tooltip__inner"
        },
        t = (function() {
          function n(e, t) {
            !(function(e, t) {
              if (!(e instanceof t))
                throw new TypeError("Cannot call a class as a function");
            })(this, n),
              a.call(this),
              (t = s({}, o, t)),
              e.jquery && (e = e[0]),
              (this.reference = e);
            var i =
              "string" == typeof (this.options = t).trigger
                ? t.trigger.split(" ").filter(function(e) {
                    return -1 !== ["click", "hover", "focus"].indexOf(e);
                  })
                : [];
            (this._isOpen = !1),
              (this._popperOptions = {}),
              this._setEventListeners(e, i, t);
          }
          return (
            e(n, [
              {
                key: "_create",
                value: function(e, t, i, n) {
                  var o = window.document.createElement("div");
                  o.innerHTML = t.trim();
                  var r = o.childNodes[0];
                  (r.id =
                    "tooltip_" +
                    Math.random()
                      .toString(36)
                      .substr(2, 10)),
                    r.setAttribute("aria-hidden", "false");
                  var s = o.querySelector(this.options.innerSelector);
                  return this._addTitleContent(e, i, n, s), r;
                }
              },
              {
                key: "_addTitleContent",
                value: function(e, t, i, n) {
                  if (1 === t.nodeType || 11 === t.nodeType)
                    i && n.appendChild(t);
                  else if (
                    (function(e) {
                      return e && "[object Function]" === {}.toString.call(e);
                    })(t)
                  ) {
                    var o = t.call(e);
                    i ? (n.innerHTML = o) : (n.textContent = o);
                  } else i ? (n.innerHTML = t) : (n.textContent = t);
                }
              },
              {
                key: "_show",
                value: function(e, t) {
                  if (this._isOpen && !this._isOpening) return this;
                  if (((this._isOpen = !0), this._tooltipNode))
                    return (
                      (this._tooltipNode.style.visibility = "visible"),
                      this._tooltipNode.setAttribute("aria-hidden", "false"),
                      this.popperInstance.update(),
                      this
                    );
                  var i = e.getAttribute("title") || t.title;
                  if (!i) return this;
                  var n = this._create(e, t.template, i, t.html);
                  e.setAttribute("aria-describedby", n.id);
                  var o = this._findContainer(t.container, e);
                  return (
                    this._append(n, o),
                    (this._popperOptions = s({}, t.popperOptions, {
                      placement: t.placement
                    })),
                    (this._popperOptions.modifiers = s(
                      {},
                      this._popperOptions.modifiers,
                      {
                        arrow: { element: this.options.arrowSelector },
                        offset: { offset: t.offset }
                      }
                    )),
                    t.boundariesElement &&
                      (this._popperOptions.modifiers.preventOverflow = {
                        boundariesElement: t.boundariesElement
                      }),
                    (this.popperInstance = new r(e, n, this._popperOptions)),
                    (this._tooltipNode = n),
                    this
                  );
                }
              },
              {
                key: "_hide",
                value: function() {
                  return (
                    this._isOpen &&
                      ((this._isOpen = !1),
                      (this._tooltipNode.style.visibility = "hidden"),
                      this._tooltipNode.setAttribute("aria-hidden", "true")),
                    this
                  );
                }
              },
              {
                key: "_dispose",
                value: function() {
                  var n = this;
                  return (
                    this._events.forEach(function(e) {
                      var t = e.func,
                        i = e.event;
                      n.reference.removeEventListener(i, t);
                    }),
                    (this._events = []),
                    this._tooltipNode &&
                      (this._hide(),
                      this.popperInstance.destroy(),
                      this.popperInstance.options.removeOnDestroy ||
                        (this._tooltipNode.parentNode.removeChild(
                          this._tooltipNode
                        ),
                        (this._tooltipNode = null))),
                    this
                  );
                }
              },
              {
                key: "_findContainer",
                value: function(e, t) {
                  return (
                    "string" == typeof e
                      ? (e = window.document.querySelector(e))
                      : !1 === e && (e = t.parentNode),
                    e
                  );
                }
              },
              {
                key: "_append",
                value: function(e, t) {
                  t.appendChild(e);
                }
              },
              {
                key: "_setEventListeners",
                value: function(n, e, o) {
                  var r = this,
                    t = [],
                    i = [];
                  e.forEach(function(e) {
                    switch (e) {
                      case "hover":
                        t.push("mouseenter"), i.push("mouseleave");
                        break;
                      case "focus":
                        t.push("focus"), i.push("blur");
                        break;
                      case "click":
                        t.push("click"), i.push("click");
                    }
                  }),
                    t.forEach(function(e) {
                      function t(e) {
                        !0 !== r._isOpening &&
                          ((e.usedByTooltip = !0),
                          r._scheduleShow(n, o.delay, o, e));
                      }
                      r._events.push({ event: e, func: t }),
                        n.addEventListener(e, t);
                    }),
                    i.forEach(function(e) {
                      function i(e) {
                        !0 !== e.usedByTooltip &&
                          r._scheduleHide(n, o.delay, o, e);
                      }
                      r._events.push({ event: e, func: i }),
                        n.addEventListener(e, i),
                        "click" === e &&
                          o.closeOnClickOutside &&
                          document.addEventListener(
                            "mousedown",
                            function(e) {
                              if (r._isOpening) {
                                var t = r.popperInstance.popper;
                                n.contains(e.target) ||
                                  t.contains(e.target) ||
                                  i(e);
                              }
                            },
                            !0
                          );
                    });
                }
              },
              {
                key: "_scheduleShow",
                value: function(e, t, i) {
                  var n = this;
                  this._isOpening = !0;
                  var o = (t && t.show) || t || 0;
                  this._showTimeout = window.setTimeout(function() {
                    return n._show(e, i);
                  }, o);
                }
              },
              {
                key: "_scheduleHide",
                value: function(e, t, i, n) {
                  var o = this;
                  this._isOpening = !1;
                  var r = (t && t.hide) || t || 0;
                  window.setTimeout(function() {
                    if (
                      (window.clearTimeout(o._showTimeout),
                      !1 !== o._isOpen && document.body.contains(o._tooltipNode))
                    ) {
                      if ("mouseleave" === n.type)
                        if (o._setTooltipNodeEvent(n, e, t, i)) return;
                      o._hide(e, i);
                    }
                  }, r);
                }
              },
              {
                key: "_updateTitleContent",
                value: function(e) {
                  if (void 0 !== this._tooltipNode) {
                    var t = this._tooltipNode.parentNode.querySelector(
                      this.options.innerSelector
                    );
                    this._clearTitleContent(
                      t,
                      this.options.html,
                      this.reference.getAttribute("title") || this.options.title
                    ),
                      this._addTitleContent(
                        this.reference,
                        e,
                        this.options.html,
                        t
                      ),
                      (this.options.title = e),
                      this.popperInstance.update();
                  } else
                    void 0 !== this.options.title && (this.options.title = e);
                }
              },
              {
                key: "_clearTitleContent",
                value: function(e, t, i) {
                  1 === i.nodeType || 11 === i.nodeType
                    ? t && e.removeChild(i)
                    : t
                    ? (e.innerHTML = "")
                    : (e.textContent = "");
                }
              }
            ]),
            n
          );
        })(),
        a = function() {
          var s = this;
          (this.show = function() {
            return s._show(s.reference, s.options);
          }),
            (this.hide = function() {
              return s._hide();
            }),
            (this.dispose = function() {
              return s._dispose();
            }),
            (this.toggle = function() {
              return s._isOpen ? s.hide() : s.show();
            }),
            (this.updateTitleContent = function(e) {
              return s._updateTitleContent(e);
            }),
            (this._events = []),
            (this._setTooltipNodeEvent = function(n, o, e, r) {
              var t = n.relatedreference || n.toElement || n.relatedTarget;
              return (
                !!s._tooltipNode.contains(t) &&
                (s._tooltipNode.addEventListener(n.type, function e(t) {
                  var i = t.relatedreference || t.toElement || t.relatedTarget;
                  s._tooltipNode.removeEventListener(n.type, e),
                    o.contains(i) || s._scheduleHide(o, r.delay, r, t);
                }),
                !0)
              );
            });
        };
      return t;
    });
  